/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Map: { input: any; output: any; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type ActivateTrialInput = {
  activationReason: TrialActivationReason;
  activationSource?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type ActivateTrialResponse = {
  __typename?: 'ActivateTrialResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  subscription?: Maybe<SubscriptionPayload>;
};

export type ActivityItem = {
  __typename?: 'ActivityItem';
  countryCode: Scalars['String']['output'];
  date: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  userAgent: Scalars['String']['output'];
};

export type ActivityPagination = {
  __typename?: 'ActivityPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Input for adding a note to a product. */
export type AddAdminProductNoteInput = {
  /** Note message content */
  message: Scalars['String']['input'];
  /** Product ID */
  productId: Scalars['Int']['input'];
};

/** Response for adding a note to a product. */
export type AddAdminProductNoteResponse = {
  __typename?: 'AddAdminProductNoteResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** The created note */
  note?: Maybe<AdminProductNote>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

/** Complete admin dashboard menu structure containing all available sections. */
export type AdminDashboardMenu = {
  __typename?: 'AdminDashboardMenu';
  /** Affiliate program management */
  affiliates?: Maybe<AdminDashboardMenuSection>;
  /** Anti-fraud tools: IP watchlist, banned accounts, session monitoring */
  antifraudCenter?: Maybe<AdminDashboardMenuSection>;
  /** Customer support tools: support tool, order viewer, downloads */
  customerSupport?: Maybe<AdminDashboardMenuSection>;
  /** Daily gifts configuration and management */
  dailyGifts?: Maybe<AdminDashboardMenuSection>;
  /** Deals center management */
  dealsCenter?: Maybe<AdminDashboardMenuSection>;
  /** Designer management: earnings, payouts, verification, profiles */
  designers?: Maybe<AdminDashboardMenuSection>;
  /** Flow management */
  flow?: Maybe<AdminDashboardMenuSection>;
  /** General management tools: freebies, crons, settings, removals */
  manage?: Maybe<AdminDashboardMenuSection>;
  /** Multi-currency settings */
  multicurrency?: Maybe<AdminDashboardMenuSection>;
  /** Multilingual/translation management */
  multilingual?: Maybe<AdminDashboardMenuSection>;
  /** Product and marketing tools */
  productAndMarketing?: Maybe<AdminDashboardMenuSection>;
  /** Pulse/analytics dashboard */
  pulse?: Maybe<AdminDashboardMenuSection>;
  /** Report center: copyright reports, content moderation */
  reportCenter?: Maybe<AdminDashboardMenuSection>;
  /** Product reviews moderation */
  reviews?: Maybe<AdminDashboardMenuSection>;
  /** SEO tools and configuration */
  seo?: Maybe<AdminDashboardMenuSection>;
  /** SEO themes configuration */
  seoThemes?: Maybe<AdminDashboardMenuSection>;
  /** Sitewide notification banners management */
  sitewideNotifications?: Maybe<AdminDashboardMenuSection>;
  /** Social features management */
  social?: Maybe<AdminDashboardMenuSection>;
  /** Category management (Stock Photos, PNGs, etc.) */
  stockPhotos?: Maybe<AdminDashboardMenuSection>;
  /** Studio tools */
  studio?: Maybe<AdminDashboardMenuSection>;
  /** Transfer/Ads management */
  transfer?: Maybe<AdminDashboardMenuSection>;
  /** Upload management and monitoring */
  upload?: Maybe<AdminDashboardMenuSection>;
};

/** A single menu item within an admin dashboard section. */
export type AdminDashboardMenuItem = {
  __typename?: 'AdminDashboardMenuItem';
  /** Whether the current user has access to this menu item based on their capabilities */
  access: Scalars['Boolean']['output'];
  /** Display title of the menu item */
  title: Scalars['String']['output'];
  /** URL path for the menu item */
  url: Scalars['String']['output'];
};

/** A section in the admin dashboard menu (e.g., 'Manage', 'Customer Support'). */
export type AdminDashboardMenuSection = {
  __typename?: 'AdminDashboardMenuSection';
  /** Whether the current user has access to this section */
  access: Scalars['Boolean']['output'];
  /** Menu items within this section */
  content: Array<AdminDashboardMenuItem>;
  /** Font Awesome icon class for the section (e.g., 'fa-home', 'fa-users') */
  icon: Scalars['String']['output'];
  /** Display title of the section */
  title: Scalars['String']['output'];
};

/** Pagination information for paginated admin responses. */
export type AdminPagination = {
  __typename?: 'AdminPagination';
  /** Current page number (1-indexed) */
  page: Scalars['Int']['output'];
  /** Number of items per page */
  perPage: Scalars['Int']['output'];
  /** Total number of items across all pages */
  total: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

/** Basic product information for the admin product manager. */
export type AdminProduct = {
  __typename?: 'AdminProduct';
  /** ISO 8601 formatted creation date, null if not set */
  dateCreated?: Maybe<Scalars['String']['output']>;
  /** Product description */
  description: Scalars['String']['output'];
  /** Product ID */
  id: Scalars['Int']['output'];
  /** Whether the product is in the bundles category */
  isBundle: Scalars['Boolean']['output'];
  /** Whether the product is in the classes category */
  isClass: Scalars['Boolean']['output'];
  /** Full URL to the product page */
  permalink: Scalars['String']['output'];
  /** Product status (publish, cf-removed, trash, etc.) */
  status: Scalars['String']['output'];
  /** URL to the product thumbnail image */
  thumbnailUrl: Scalars['String']['output'];
  /** Product title */
  title: Scalars['String']['output'];
};

/** Designer information associated with a product. */
export type AdminProductDesignerInfo = {
  __typename?: 'AdminProductDesignerInfo';
  /** Designer display name, empty if product has no associated designer */
  displayName: Scalars['String']['output'];
  /** Designer user ID, null if product has no associated designer */
  id?: Maybe<Scalars['Int']['output']>;
  /** Whether the designer is contracted */
  isContracted: Scalars['Boolean']['output'];
  /** Whether the designer is exclusive to Creative Fabrica */
  isExclusive: Scalars['Boolean']['output'];
};

/** A downloadable file associated with a product. */
export type AdminProductFile = {
  __typename?: 'AdminProductFile';
  /** Full download URL */
  file: Scalars['String']['output'];
  /** Download ID (product ID for fonts, WooCommerce download ID for others) */
  id: Scalars['String']['output'];
  /** Filename */
  name: Scalars['String']['output'];
};

/** A single entry in the product operation history log. */
export type AdminProductHistoryEntry = {
  __typename?: 'AdminProductHistoryEntry';
  /** Date/time when the operation occurred */
  date: Scalars['String']['output'];
  /** Human-readable description of the change */
  description: Scalars['String']['output'];
  /** Log entry ID */
  id: Scalars['String']['output'];
  /** Operation type identifier */
  operation: Scalars['String']['output'];
  /** Display name of the user, empty if system action or user not found */
  userDisplayName: Scalars['String']['output'];
  /** User ID who performed the operation, null if system action */
  userId?: Maybe<Scalars['String']['output']>;
};

/** An image associated with a product. */
export type AdminProductImage = {
  __typename?: 'AdminProductImage';
  /** Attachment ID */
  id: Scalars['Int']['output'];
  /** Whether this is the main product image */
  isMain: Scalars['Boolean']['output'];
  /** MIME type (e.g., image/jpeg) */
  mimeType: Scalars['String']['output'];
  /** Filename */
  name: Scalars['String']['output'];
  /** File size in bytes */
  size: Scalars['Int']['output'];
  /** Thumbnail URL */
  thumbnailUrl: Scalars['String']['output'];
  /** Full image URL */
  url: Scalars['String']['output'];
};

/** An admin note attached to a product. */
export type AdminProductNote = {
  __typename?: 'AdminProductNote';
  /** User ID who added the note */
  addedById: Scalars['Int']['output'];
  /** Display name of the user who added the note */
  addedByName: Scalars['String']['output'];
  /** Date/time when the note was created */
  createdAt: Scalars['String']['output'];
  /** Note ID */
  id: Scalars['Int']['output'];
  /** Note content */
  message: Scalars['String']['output'];
  /** Date/time when the note was last updated */
  updatedAt: Scalars['String']['output'];
};

/** A reason for removing a product. */
export type AdminProductRemovalReason = {
  __typename?: 'AdminProductRemovalReason';
  /** Reason description used to pre-fill the removal text */
  description: Scalars['String']['output'];
  /** Reason ID */
  id: Scalars['Int']['output'];
  /** Reason title displayed in the dropdown */
  title: Scalars['String']['output'];
};

/** A problem or copyright report for a product. */
export type AdminProductReport = {
  __typename?: 'AdminProductReport';
  /** Date/time when the report was created */
  createdOn: Scalars['String']['output'];
  /** Report ID */
  id: Scalars['Int']['output'];
  /** Report details provided by the reporter */
  reasonNote: Scalars['String']['output'];
  /** Report type (intellectual-property, broken-file, low-quality, other) */
  reasonType: Scalars['String']['output'];
  /** Additional fields for IP reports, varies by report type */
  reportExtra?: Maybe<Scalars['Map']['output']>;
  /** Reporter email */
  userEmail: Scalars['String']['output'];
  /** Reporting user ID, null if reporter was not logged in */
  userId?: Maybe<Scalars['Int']['output']>;
  /** Reporter name */
  userName: Scalars['String']['output'];
};

/** A single result from the admin product search. */
export type AdminProductSearchResult = {
  __typename?: 'AdminProductSearchResult';
  /** Product ID */
  id: Scalars['Int']['output'];
  /** Display text in format 'product_title (#ID)' */
  text: Scalars['String']['output'];
};

/** A tag associated with a product. */
export type AdminProductTag = {
  __typename?: 'AdminProductTag';
  /** Tag ID */
  id: Scalars['Int']['output'];
  /** Tag name */
  name: Scalars['String']['output'];
};

/** A single result from the admin user search. */
export type AdminUserSearchResult = {
  __typename?: 'AdminUserSearchResult';
  /** User ID */
  id: Scalars['Int']['output'];
  /** Display text in format 'display_name (#ID)' */
  text: Scalars['String']['output'];
};

export enum AdvertisingAssetType {
  Image = 'image',
  Logo = 'logo',
  Unspecified = 'unspecified',
  Video = 'video'
}

export type AdvertisingCreateCampaignInput = {
  campaignCtaText?: InputMaybe<Scalars['String']['input']>;
  campaignText?: InputMaybe<Scalars['String']['input']>;
  campaignTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationUrl: Scalars['String']['input'];
  endDate: Scalars['Time']['input'];
  images?: InputMaybe<Array<CampaignAssetInput>>;
  logos?: InputMaybe<Array<CampaignAssetInput>>;
  name: Scalars['String']['input'];
  startDate: Scalars['Time']['input'];
  targetGeolocation: AdvertisingGeolocation;
  template: CampaignTemplateType;
  videos?: InputMaybe<Array<CampaignAssetInput>>;
};

export type AdvertisingCreateCampaignResponse = {
  __typename?: 'AdvertisingCreateCampaignResponse';
  campaign?: Maybe<Campaign>;
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AdvertisingDeleteCampaignInput = {
  id: Scalars['ID']['input'];
};

export type AdvertisingDeleteCampaignResponse = {
  __typename?: 'AdvertisingDeleteCampaignResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export enum AdvertisingGeolocation {
  Global = 'global'
}

export type AdvertisingGetCampaignInput = {
  id: Scalars['ID']['input'];
};

export type AdvertisingGetCampaignResponse = {
  __typename?: 'AdvertisingGetCampaignResponse';
  campaign?: Maybe<Campaign>;
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AdvertisingGetRandomNCampaignsInput = {
  assetType?: InputMaybe<AdvertisingAssetType>;
  campaignQuantity?: InputMaybe<Scalars['Int']['input']>;
  geolocation?: InputMaybe<AdvertisingGeolocation>;
};

export type AdvertisingGetRandomNCampaignsResponse = {
  __typename?: 'AdvertisingGetRandomNCampaignsResponse';
  campaigns?: Maybe<Array<Campaign>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type AdvertisingGetTotalActionsByMonthInput = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type AdvertisingGetTotalActionsByMonthResponse = {
  __typename?: 'AdvertisingGetTotalActionsByMonthResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  monthlyActions?: Maybe<Array<MonthlyAction>>;
  pagination?: Maybe<AdvertisingMonthlyActionListPagination>;
};

export type AdvertisingGetUploadedInput = {
  uploadId: Scalars['String']['input'];
};

export type AdvertisingGetUploadedResponse = {
  __typename?: 'AdvertisingGetUploadedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type AdvertisingIncreaseClickForCampaignInput = {
  clickTime: Scalars['Time']['input'];
  id: Scalars['String']['input'];
};

export type AdvertisingIncreaseClickForCampaignResponse = {
  __typename?: 'AdvertisingIncreaseClickForCampaignResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AdvertisingIncreaseViewForCampaignInput = {
  id: Scalars['String']['input'];
  viewTime: Scalars['Time']['input'];
};

export type AdvertisingIncreaseViewForCampaignResponse = {
  __typename?: 'AdvertisingIncreaseViewForCampaignResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AdvertisingListCampaignInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
};

export type AdvertisingListCampaignResponse = {
  __typename?: 'AdvertisingListCampaignResponse';
  campaigns?: Maybe<Array<Campaign>>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<AdvertisingListPagination>;
};

export type AdvertisingListPagination = {
  __typename?: 'AdvertisingListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdvertisingMonthlyActionListPagination = {
  __typename?: 'AdvertisingMonthlyActionListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdvertisingUpdateCampaignInput = {
  campaignCtaText?: InputMaybe<Scalars['String']['input']>;
  campaignText?: InputMaybe<Scalars['String']['input']>;
  campaignTitle?: InputMaybe<Scalars['String']['input']>;
  deleteAssetsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<CampaignAssetInput>>;
  logos?: InputMaybe<Array<CampaignAssetInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  targetGeolocation?: InputMaybe<AdvertisingGeolocation>;
  template?: InputMaybe<CampaignTemplateType>;
  videos?: InputMaybe<Array<CampaignAssetInput>>;
};

export type AdvertisingUpdateCampaignResponse = {
  __typename?: 'AdvertisingUpdateCampaignResponse';
  campaign?: Maybe<Campaign>;
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AdvertisingUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String']['input'];
};

export type AdvertisingUploadsCreateSignedUrlResponse = {
  __typename?: 'AdvertisingUploadsCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type AffiliateInfo = {
  __typename?: 'AffiliateInfo';
  affiliateId: Scalars['ID']['output'];
  affiliatePercentage: Scalars['Float']['output'];
};

export type AllAccessBanner = {
  __typename?: 'AllAccessBanner';
  backgroundColor: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavPromo: Scalars['Int']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  button: AllAccessBannerButton;
  countdown?: Maybe<SiteBannerCountdown>;
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
  type: SiteBannerType;
};

export type AllAccessBannerButton = {
  __typename?: 'AllAccessBannerButton';
  backgroundColor: Scalars['String']['output'];
  hoverTextColor: Scalars['String']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
};

export type AllAccessYearlyBanner = {
  __typename?: 'AllAccessYearlyBanner';
  backgroundImage: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  buttonUrl: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  isHidden: Scalars['Boolean']['output'];
  showInHeader: Scalars['Boolean']['output'];
  type: SiteBannerType;
  yearly: Scalars['Boolean']['output'];
};

export type AllAccessYearlyExtendBanner = {
  __typename?: 'AllAccessYearlyExtendBanner';
  backgroundImage: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  countdownDt?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  inProgress: Scalars['Boolean']['output'];
  lastOrderPaymentUrl: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  type: SiteBannerType;
};

export type AllAccessYearlyTrialBanner = {
  __typename?: 'AllAccessYearlyTrialBanner';
  backgroundImage: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  buttonUrl: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  isHidden: Scalars['Boolean']['output'];
  showInHeader: Scalars['Boolean']['output'];
  type: SiteBannerType;
  yearly: Scalars['Boolean']['output'];
};

export type AllowedPaymentMethodTypesInput = {
  currencyCode: AvailableCurrencyCode;
};

export type AllowedPaymentMethodTypesResponse = {
  __typename?: 'AllowedPaymentMethodTypesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  types?: Maybe<Array<AvailablePaymentMethod>>;
};

export type Answer = {
  __typename?: 'Answer';
  answer: Scalars['String']['output'];
  assets?: Maybe<Array<AskCfAsset>>;
  commentCount: Scalars['Int']['output'];
  comments?: Maybe<Array<Comment>>;
  createTime: Scalars['DateTime']['output'];
  downvotes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isBestAnswer: Scalars['Boolean']['output'];
  isDisliked: Scalars['Boolean']['output'];
  isGenieAnswer: Scalars['Boolean']['output'];
  isHtmlAnswer: Scalars['Boolean']['output'];
  isLiked: Scalars['Boolean']['output'];
  upvotes: Scalars['Int']['output'];
  user: PublicUserProfile;
  /** @deprecated Use user field instead */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AskCfAsset = {
  __typename?: 'AskCFAsset';
  id: Scalars['ID']['output'];
  optimizedUrl?: Maybe<Scalars['String']['output']>;
  type: AskCfAssetType;
  url: Scalars['String']['output'];
};

export type AskCfAssetInput = {
  assetType: AskCfAssetTypeInput;
  assetUrl: Scalars['String']['input'];
};

export enum AskCfAssetType {
  Image = 'image',
  Unspecified = 'unspecified',
  Video = 'video'
}

export enum AskCfAssetTypeInput {
  Image = 'image',
  Unspecified = 'unspecified',
  Video = 'video'
}

export type AskCfConfirmQuestionInput = {
  questionId: Scalars['String']['input'];
};

export type AskCfConfirmQuestionResponse = {
  __typename?: 'AskCFConfirmQuestionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  question?: Maybe<Question>;
  success: Scalars['Boolean']['output'];
};

export type AskCfConfirmTopicInput = {
  topicId?: InputMaybe<Scalars['ID']['input']>;
  topicName?: InputMaybe<Scalars['String']['input']>;
  topicSlug: Scalars['String']['input'];
};

export type AskCfConfirmTopicResponse = {
  __typename?: 'AskCFConfirmTopicResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfCreateSignedUploadUrlV2Input = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
};

export type AskCfCreateSignedUploadUrlV2Response = {
  __typename?: 'AskCFCreateSignedUploadUrlV2Response';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  inputFormFields?: Maybe<Array<KeyValuePairs>>;
  signedUrl: Scalars['String']['output'];
};

export type AskCfDeleteAnswerInput = {
  answerId: Scalars['String']['input'];
  deleteReason: Scalars['String']['input'];
};

export type AskCfDeleteAnswerResponse = {
  __typename?: 'AskCFDeleteAnswerResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfDeleteAnswersFromUserInput = {
  deleteReason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AskCfDeleteAnswersFromUserResponse = {
  __typename?: 'AskCFDeleteAnswersFromUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfDeleteQuestionInput = {
  deleteReason: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type AskCfDeleteQuestionResponse = {
  __typename?: 'AskCFDeleteQuestionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfDeleteQuestionsFromUserInput = {
  deleteReason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AskCfDeleteQuestionsFromUserResponse = {
  __typename?: 'AskCFDeleteQuestionsFromUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfDiscardQuestionInput = {
  questionId: Scalars['String']['input'];
};

export type AskCfDiscardQuestionResponse = {
  __typename?: 'AskCFDiscardQuestionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfDiscoveryFeedInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
};

export type AskCfDislikeAnswerInput = {
  answerId: Scalars['String']['input'];
};

export type AskCfDislikeAnswerResponse = {
  __typename?: 'AskCFDislikeAnswerResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfDislikeCommentInput = {
  commentId: Scalars['String']['input'];
};

export type AskCfDislikeCommentResponse = {
  __typename?: 'AskCFDislikeCommentResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfFeedResponse = {
  __typename?: 'AskCFFeedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<AskCfListQuestionsPagination>;
  questions?: Maybe<Array<Question>>;
};

export type AskCfFollowQuestionInput = {
  questionId: Scalars['String']['input'];
};

export type AskCfFollowQuestionResponse = {
  __typename?: 'AskCFFollowQuestionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfFollowedQuestionsInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
};

export type AskCfFollowingFeedInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
};

export type AskCfGetGivenTopicsInput = {
  topicSlugs: Array<Scalars['String']['input']>;
};

export type AskCfGetLatestQuestionsInput = {
  questionLimit: Scalars['Int']['input'];
  timeRange: TimeRange;
  topics: Array<Scalars['String']['input']>;
};

export type AskCfGetLatestQuestionsResponse = {
  __typename?: 'AskCFGetLatestQuestionsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  questions?: Maybe<Array<Question>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfGetQuestionInput = {
  answersPage: Scalars['Int']['input'];
  answersPerPage: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  questionSlug?: InputMaybe<Scalars['String']['input']>;
};

export type AskCfGetQuestionPartialThreadInput = {
  answerId: Scalars['ID']['input'];
  commentId?: InputMaybe<Scalars['ID']['input']>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
  questionSlug?: InputMaybe<Scalars['String']['input']>;
};

export type AskCfGetQuestionPartialThreadResponse = {
  __typename?: 'AskCFGetQuestionPartialThreadResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  question?: Maybe<Question>;
  success: Scalars['Boolean']['output'];
};

export type AskCfGetQuestionResponse = {
  __typename?: 'AskCFGetQuestionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  question?: Maybe<Question>;
  success: Scalars['Boolean']['output'];
};

export type AskCfGetTopicInput = {
  topicId?: InputMaybe<Scalars['ID']['input']>;
  topicSlug?: InputMaybe<Scalars['String']['input']>;
};

export type AskCfGetUploadedInput = {
  uploadId: Scalars['String']['input'];
};

export type AskCfGetUploadedResponse = {
  __typename?: 'AskCFGetUploadedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type AskCfGetUserStatsInput = {
  userId: Scalars['ID']['input'];
};

export type AskCfGiveTipToAnswerInput = {
  answerId: Scalars['String']['input'];
};

export type AskCfGiveTipToAnswerResponse = {
  __typename?: 'AskCFGiveTipToAnswerResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfHomeFeedInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
};

export type AskCfLikeAnswerInput = {
  answerId: Scalars['String']['input'];
};

export type AskCfLikeAnswerResponse = {
  __typename?: 'AskCFLikeAnswerResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfLikeCommentInput = {
  commentId: Scalars['String']['input'];
};

export type AskCfLikeCommentResponse = {
  __typename?: 'AskCFLikeCommentResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfListCommentsInput = {
  answerId: Scalars['ID']['input'];
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
  parentCommentId?: InputMaybe<Scalars['ID']['input']>;
};

export type AskCfListCommentsResponse = {
  __typename?: 'AskCFListCommentsResponse';
  comments?: Maybe<Array<Comment>>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<AskCfListPagination>;
};

export type AskCfListPagination = {
  __typename?: 'AskCFListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AskCfListQuestionsPagination = {
  __typename?: 'AskCFListQuestionsPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AskCfPostAnswerInput = {
  answer: Scalars['String']['input'];
  assets?: InputMaybe<Array<AskCfAssetInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

export type AskCfPostAnswerResponse = {
  __typename?: 'AskCFPostAnswerResponse';
  answer?: Maybe<Answer>;
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfPostCommentInput = {
  answerId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  comment_parent_id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AskCfPostCommentResponse = {
  __typename?: 'AskCFPostCommentResponse';
  comment?: Maybe<Comment>;
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfPostQuestionInput = {
  assets?: InputMaybe<Array<AskCfAssetInput>>;
  context?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type AskCfPostQuestionResponse = {
  __typename?: 'AskCFPostQuestionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  question?: Maybe<Question>;
  success: Scalars['Boolean']['output'];
};

export type AskCfSetBestAnswerInput = {
  answerId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};

export type AskCfSetBestAnswerResponse = {
  __typename?: 'AskCFSetBestAnswerResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfTopic = {
  __typename?: 'AskCFTopic';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questionCount: Scalars['Int']['output'];
  textIdentifier: Scalars['String']['output'];
  topicSlug: Scalars['String']['output'];
  userFollows: Scalars['Boolean']['output'];
};

export type AskCfTopicDeleteInput = {
  topicId: Scalars['ID']['input'];
};

export type AskCfTopicDeleteResponse = {
  __typename?: 'AskCFTopicDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfTopicFeedInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
  topicSlug?: InputMaybe<Scalars['String']['input']>;
};

export type AskCfUnfollowQuestionInput = {
  questionId: Scalars['String']['input'];
};

export type AskCfUnfollowQuestionResponse = {
  __typename?: 'AskCFUnfollowQuestionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfUploadCreateSignedUrlInput = {
  uploadFile: Scalars['String']['input'];
};

export type AskCfUploadCreateSignedUrlResponse = {
  __typename?: 'AskCFUploadCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type AskCfUserAnsweredFeedInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type AskCfUserDigestSubscribeResponse = {
  __typename?: 'AskCFUserDigestSubscribeResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfUserDigestUnsubscribeResponse = {
  __typename?: 'AskCFUserDigestUnsubscribeResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type AskCfUserFeedInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  userSlug?: InputMaybe<Scalars['String']['input']>;
};

export type AskCfUserStats = {
  __typename?: 'AskCFUserStats';
  answerCount: Scalars['Int']['output'];
  questionCount: Scalars['Int']['output'];
  questionsFollowedCount: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type AssetDownloadResponse = {
  __typename?: 'AssetDownloadResponse';
  assetId: Scalars['ID']['output'];
  /** This field is populated when skip trial is triggered */
  paymentRequired?: Maybe<ContentPaymentRequired>;
  /** Note that we currently only support the ID (`product.id`) */
  product: ContentProduct;
  /** @deprecated Use `product.id` instead */
  product_id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type AssetDownloadResponseV2 = {
  __typename?: 'AssetDownloadResponseV2';
  assetId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type AssetsDownloadResponseV2 = {
  __typename?: 'AssetsDownloadResponseV2';
  assets: Array<AssetDownloadResponseV2>;
  errors: Array<ErrorMessage>;
};

export type AuthChallenge = {
  __typename?: 'AuthChallenge';
  email?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type: ChallengeType;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  currency?: Maybe<Currency>;
  errors?: Maybe<Array<ErrorMessage>>;
  subscriptionId: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum AuthType {
  AuthTypeApple = 'authTypeApple',
  AuthTypeFacebook = 'authTypeFacebook',
  AuthTypeGoogle = 'authTypeGoogle'
}

export enum AvailableCurrencyCode {
  Eur = 'eur',
  Gbp = 'gbp',
  Usd = 'usd'
}

export enum AvailablePaymentMethod {
  BacsDebit = 'bacsDebit',
  Card = 'card',
  Link = 'link',
  Paypal = 'paypal',
  SepaDebit = 'sepaDebit'
}

export type AwaitingRenewalConfirmationBanner = {
  __typename?: 'AwaitingRenewalConfirmationBanner';
  backgroundColor: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: SiteBannerType;
};

export enum BanStatus {
  UserBanStatusDesignerBlock = 'USER_BAN_STATUS_DESIGNER_BLOCK',
  UserBanStatusNone = 'USER_BAN_STATUS_NONE',
  UserBanStatusShadowban = 'USER_BAN_STATUS_SHADOWBAN',
  UserBanStatusUnspecified = 'USER_BAN_STATUS_UNSPECIFIED'
}

export type BillingDetails = {
  __typename?: 'BillingDetails';
  address: Address;
  email: Scalars['String']['output'];
  euTaxId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  taxId?: Maybe<Scalars['String']['output']>;
};

export enum BillingPeriod {
  Month = 'month',
  Year = 'year'
}

export type BlocksRange = {
  __typename?: 'BlocksRange';
  maxBlocksAllowed: Scalars['Int']['output'];
  minBlocksAllowed: Scalars['Int']['output'];
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type BuildPaymentDataForSubscriptionResult = {
  __typename?: 'BuildPaymentDataForSubscriptionResult';
  payment?: Maybe<Payment>;
  userBanned?: Maybe<Scalars['Boolean']['output']>;
};

export type BuyCoinsCustomInput = {
  amount: Scalars['Int']['input'];
  product: CoinProductType;
};

export type CfMainEnterpriseRequestInput = {
  answer: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  employees: EnterpriseRequestEmployees;
  job?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  usage: Scalars['String']['input'];
};

export type CfMainEnterpriseRequestResponse = {
  __typename?: 'CFMainEnterpriseRequestResponse';
  enterpriseRequests?: Maybe<EnterpriseRequest>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type CfMainGetEnterpriseRequestInput = {
  id: Scalars['Int']['input'];
};

export type CfMainGetEnterpriseRequestResponse = {
  __typename?: 'CFMainGetEnterpriseRequestResponse';
  enterpriseRequest?: Maybe<EnterpriseRequest>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type CfMainHasMore = {
  __typename?: 'CFMainHasMore';
  next: Scalars['Boolean']['output'];
  previous: Scalars['Boolean']['output'];
};

export type CfMainIsUserFavorite = {
  __typename?: 'CFMainIsUserFavorite';
  isFavorite: Scalars['Boolean']['output'];
  productID: Scalars['Int']['output'];
};

export type CfMainListEnterpriseRequestsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CfMainListEnterpriseRequestsPagination = {
  __typename?: 'CFMainListEnterpriseRequestsPagination';
  limit: Scalars['Int']['output'];
  nextOffset: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CfMainListEnterpriseRequestsResponse = {
  __typename?: 'CFMainListEnterpriseRequestsResponse';
  enterpriseRequests?: Maybe<Array<EnterpriseRequest>>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<CfMainListEnterpriseRequestsPagination>;
};

export enum CfMainPageDirection {
  Next = 'next',
  Previous = 'previous'
}

export type CfMainProductsFavoritesCount = {
  __typename?: 'CFMainProductsFavoritesCount';
  favoritesCounts: Array<CfMainProductsFavoritesCountItem>;
};

export type CfMainProductsFavoritesCountItem = {
  __typename?: 'CFMainProductsFavoritesCountItem';
  count: Scalars['Int']['output'];
  isFavorite: Scalars['Boolean']['output'];
  productId: Scalars['Int']['output'];
};

export type CfMainUpdateEnterpriseRequestInput = {
  id: Scalars['Int']['input'];
  owner: Scalars['Int']['input'];
};

export type CfMainUpdateEnterpriseRequestResponse = {
  __typename?: 'CFMainUpdateEnterpriseRequestResponse';
  enterpriseRequests?: Maybe<EnterpriseRequest>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type CfOrder = {
  __typename?: 'CFOrder';
  date?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  needsPayment?: Maybe<Scalars['Boolean']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type CfSubscription = {
  __typename?: 'CFSubscription';
  billingPeriod?: Maybe<Scalars['String']['output']>;
  canBeCancelled?: Maybe<Scalars['Boolean']['output']>;
  canBeReactivated?: Maybe<Scalars['Boolean']['output']>;
  cancelUrl?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  discountedPrice?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActivating?: Maybe<Scalars['Boolean']['output']>;
  leavingList: Array<CfSubscriptionLeavingList>;
  name: Scalars['String']['output'];
  nextPaymentDate?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusCode: Scalars['String']['output'];
  stripeUrl?: Maybe<Scalars['String']['output']>;
  totalAccessibleProducts?: Maybe<Scalars['Int']['output']>;
  totalAmount: Scalars['String']['output'];
  totalAmountFormatted?: Maybe<Scalars['String']['output']>;
};

export type CfSubscriptionLeavingList = {
  __typename?: 'CFSubscriptionLeavingList';
  count?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CalculatePricesInput = {
  currency: CurrencyCode;
  match?: InputMaybe<Scalars['Boolean']['input']>;
  prices: Array<Scalars['Int']['input']>;
};

export type CalculatePricesResponse = {
  __typename?: 'CalculatePricesResponse';
  currency: CurrencyCode;
  prices: Array<TransformedPricesResponse>;
};

export type Campaign = {
  __typename?: 'Campaign';
  clicks: Scalars['Int']['output'];
  content: Contents;
  createTime: Scalars['DateTime']['output'];
  ctr: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  geolocation: AdvertisingGeolocation;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  views: Scalars['Int']['output'];
};

export type CampaignAsset = {
  __typename?: 'CampaignAsset';
  assetType: AdvertisingAssetType;
  assetUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  placementOrder: Scalars['Int']['output'];
};

export type CampaignAssetInput = {
  assetType: AdvertisingAssetType;
  assetUrl: Scalars['String']['input'];
  placementOrder: Scalars['Int']['input'];
};

export enum CampaignTemplateType {
  ImageAndLogo = 'imageAndLogo',
  ImageOnly = 'imageOnly',
  ImagesAndText = 'imagesAndText',
  VideoAndImage = 'videoAndImage',
  VideoOnly = 'videoOnly'
}

export type CancelSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export type CancelSubscriptionResponse = {
  __typename?: 'CancelSubscriptionResponse';
  error?: Maybe<ErrorGrowth>;
};

export enum Category {
  Bundles = 'bundles',
  Crafts = 'crafts',
  Embroidery = 'embroidery',
  Fonts = 'fonts',
  Graphics = 'graphics',
  Knitting = 'knitting',
  LaserCutting = 'laserCutting',
  Pngs = 'pngs',
  Svgs = 'svgs',
  ThreeDPaperCrafts = 'threeDPaperCrafts'
}

export type CategoryFaq = {
  __typename?: 'CategoryFAQ';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type CategoryLink = {
  __typename?: 'CategoryLink';
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type CategoryPagination = {
  __typename?: 'CategoryPagination';
  currentPage: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum ChallengeType {
  Challenge2fa = 'challenge2fa',
  ChallengeOtp = 'challengeOtp'
}

/** A single file update for changing download URLs. */
export type ChangeAdminProductFileInput = {
  /** File ID (WooCommerce download ID or product ID for fonts) */
  fileId: Scalars['String']['input'];
  /** New file path (must be a URL ending in .zip) */
  filePath: Scalars['String']['input'];
};

/** Input for changing product download URLs. */
export type ChangeAdminProductFileUrlInput = {
  /** List of file updates */
  files: Array<ChangeAdminProductFileInput>;
  /** Product ID */
  productId: Scalars['Int']['input'];
};

/** Response for changing product download URLs. */
export type ChangeAdminProductFileUrlResponse = {
  __typename?: 'ChangeAdminProductFileUrlResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** Success message from WP */
  message: Scalars['String']['output'];
};

export enum ChangeUserRoleStatus {
  AwaitingAdminApproval = 'AwaitingAdminApproval',
  Unknown = 'Unknown',
  Updated = 'Updated'
}

export type Class = {
  __typename?: 'Class';
  category: Scalars['String']['output'];
  categoryUrl: Scalars['String']['output'];
  communityProduct: Scalars['Boolean']['output'];
  favorite: Scalars['Boolean']['output'];
  favoriteCount: Scalars['Int']['output'];
  imgAlt: Scalars['String']['output'];
  imgSrc: Scalars['String']['output'];
  level?: Maybe<Scalars['String']['output']>;
  pinterestUrl: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  sourceCfOriginal?: Maybe<Scalars['Boolean']['output']>;
  studentsEnrolledCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  videoLength: Scalars['String']['output'];
};

export type ClassProperties = {
  __typename?: 'ClassProperties';
  level?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type ClassesBanner = {
  __typename?: 'ClassesBanner';
  backgroundColor: Scalars['String']['output'];
  bannerTitleClass: Scalars['String']['output'];
  button: ClassesBannerButton;
  fontSize: Scalars['String']['output'];
  hideByDefault: Scalars['Boolean']['output'];
  lineHeight: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
  type: SiteBannerType;
};

export type ClassesBannerButton = {
  __typename?: 'ClassesBannerButton';
  backgroundColor: Scalars['String']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
};

export enum ClientType {
  ClientTypeAndroid = 'ClientTypeAndroid',
  ClientTypeIos = 'ClientTypeIOS',
  ClientTypeWeb = 'ClientTypeWeb'
}

export type Clubhouse = {
  __typename?: 'Clubhouse';
  askTopics?: Maybe<Array<Scalars['String']['output']>>;
  avatarImage?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  bgColor?: Maybe<Scalars['String']['output']>;
  digitalAssetsFilters?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  invitesTotal?: Maybe<Scalars['Int']['output']>;
  isMember: Scalars['Boolean']['output'];
  isSubscribedToDigest: Scalars['Boolean']['output'];
  lightBgColor?: Maybe<Scalars['String']['output']>;
  membersLast30Days?: Maybe<Scalars['Int']['output']>;
  membersTotal: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  query: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  studioTemplateQuery?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  type: ClubhouseType;
  userPendingInviters?: Maybe<Array<PublicUserProfile>>;
};

export type ClubhouseAcceptInviteInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type ClubhouseAcceptInviteResponse = {
  __typename?: 'ClubhouseAcceptInviteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export enum ClubhouseDigestFrequency {
  Daily = 'DAILY',
  Disabled = 'DISABLED',
  Unspecified = 'UNSPECIFIED',
  Weekly = 'WEEKLY'
}

export type ClubhouseFriendsListInput = {
  clubhouseSlug: Scalars['String']['input'];
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type ClubhouseFriendsListResponse = {
  __typename?: 'ClubhouseFriendsListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  friends?: Maybe<Array<ClubhouseMember>>;
  pagination?: Maybe<ClubhousesListPagination>;
};

export type ClubhouseGetNotificationSettingsInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type ClubhouseGetNotificationSettingsResponse = {
  __typename?: 'ClubhouseGetNotificationSettingsResponse';
  commentedOnYourDiscussion?: Maybe<Scalars['Boolean']['output']>;
  digestPreference?: Maybe<ClubhouseDigestFrequency>;
  errors?: Maybe<Array<ErrorMessage>>;
  repliedToYourComment?: Maybe<Scalars['Boolean']['output']>;
};

export type ClubhouseInviteInput = {
  clubhouseSlug: Scalars['String']['input'];
  friendId?: InputMaybe<Scalars['String']['input']>;
  friendsEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  inviteMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ClubhouseInviteResponse = {
  __typename?: 'ClubhouseInviteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhouseIsMemberInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type ClubhouseIsMemberResponse = {
  __typename?: 'ClubhouseIsMemberResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  isMember: Scalars['Boolean']['output'];
};

export type ClubhouseJoinInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type ClubhouseJoinResponse = {
  __typename?: 'ClubhouseJoinResponse';
  Success: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhouseLeaveInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type ClubhouseLeaveResponse = {
  __typename?: 'ClubhouseLeaveResponse';
  Success: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhouseListPendingInvitationInput = {
  clubhouseSlug: Scalars['String']['input'];
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type ClubhouseListPendingInvitationPagination = {
  __typename?: 'ClubhouseListPendingInvitationPagination';
  TotalInvites: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ClubhouseListPendingInvitationResponse = {
  __typename?: 'ClubhouseListPendingInvitationResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<ClubhouseListPendingInvitationPagination>;
  pendingInviters?: Maybe<Array<PublicUserProfile>>;
};

export type ClubhouseMember = {
  __typename?: 'ClubhouseMember';
  isAlreadyInvited: Scalars['Boolean']['output'];
  isMember: Scalars['Boolean']['output'];
  userProfile: PublicUserProfile;
};

export type ClubhouseOnlineInput = {
  id: Scalars['ID']['input'];
};

export enum ClubhouseType {
  Brand = 'brand',
  BusinessAndSelling = 'businessAndSelling',
  Craft = 'craft',
  Holiday = 'holiday',
  LifeEvent = 'lifeEvent',
  MaterialsAndMachines = 'materialsAndMachines',
  Unspecified = 'unspecified'
}

export type ClubhouseUpdateDigestPreferenceInput = {
  clubhouseSlug: Scalars['String']['input'];
  frequency: ClubhouseDigestFrequency;
};

export type ClubhouseUpdateDigestPreferenceResponse = {
  __typename?: 'ClubhouseUpdateDigestPreferenceResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhouseUpdateNotificationSettingsInput = {
  clubhouseSlug: Scalars['String']['input'];
  commentedOnYourDiscussion?: InputMaybe<Scalars['Boolean']['input']>;
  repliedToYourComment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClubhouseUpdateNotificationSettingsResponse = {
  __typename?: 'ClubhouseUpdateNotificationSettingsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhousesAdminUploadCreateSignedUrlInput = {
  uploadFile: Scalars['String']['input'];
};

export type ClubhousesAdminUploadCreateSignedUrlResponse = {
  __typename?: 'ClubhousesAdminUploadCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type ClubhousesComment = {
  __typename?: 'ClubhousesComment';
  assets?: Maybe<Array<ImageAsset>>;
  /** @deprecated No longer supported */
  childRepliesCount?: Maybe<Scalars['Int']['output']>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  edited?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use 'assets' instead */
  images?: Maybe<Array<ImageAsset>>;
  isLiked: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  productCards?: Maybe<Array<SocialProductCard>>;
  /** @deprecated No longer supported */
  text?: Maybe<Scalars['String']['output']>;
  user: PublicUserProfile;
};

export type ClubhousesCommentsPagination = {
  __typename?: 'ClubhousesCommentsPagination';
  nextCursor?: Maybe<Scalars['ID']['output']>;
  page: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ClubhousesCommunityLeaderStatusInput = {
  clubhouseSlug: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ClubhousesCommunityLeaderStatusResponse = {
  __typename?: 'ClubhousesCommunityLeaderStatusResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  isLeader: Scalars['Boolean']['output'];
  leaderInfo?: Maybe<CommunityLeaderInfo>;
};

export type ClubhousesCommunityLeadersListInput = {
  clubhouseSlug: Scalars['String']['input'];
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type ClubhousesCommunityLeadersListResponse = {
  __typename?: 'ClubhousesCommunityLeadersListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  leaders?: Maybe<Array<CommunityLeader>>;
  pagination?: Maybe<ClubhousesListPagination>;
  totalMembers: Scalars['Int']['output'];
};

export type ClubhousesCreateCommunityLeaderInput = {
  clubhouseSlug: Scalars['String']['input'];
  rights?: InputMaybe<Array<CommunityLeaderRight>>;
  userId: Scalars['String']['input'];
};

export type ClubhousesCreateCommunityLeaderResponse = {
  __typename?: 'ClubhousesCreateCommunityLeaderResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  leader?: Maybe<CommunityLeader>;
};

export type ClubhousesCreateDiscussionInput = {
  clubhouseSlug: Scalars['String']['input'];
  content: Scalars['String']['input'];
  headline: Scalars['String']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  topicSlug: Scalars['String']['input'];
};

export type ClubhousesCreateDiscussionReplyInput = {
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  discussionId: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ClubhousesCreateDiscussionReplyResponse = {
  __typename?: 'ClubhousesCreateDiscussionReplyResponse';
  comment?: Maybe<ClubhousesComment>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhousesCreateDiscussionResponse = {
  __typename?: 'ClubhousesCreateDiscussionResponse';
  discussion?: Maybe<Discussion>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhousesCreateSignedUploadUrlV2Input = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
};

export type ClubhousesCreateSignedUploadUrlV2Response = {
  __typename?: 'ClubhousesCreateSignedUploadUrlV2Response';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  inputFormFields?: Maybe<Array<KeyValuePairs>>;
  signedUrl: Scalars['String']['output'];
};

export type ClubhousesDeleteDiscussionInput = {
  id: Scalars['ID']['input'];
};

export type ClubhousesDeleteDiscussionReplyInput = {
  clubhouseSlug: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type ClubhousesDeleteDiscussionReplyResponse = {
  __typename?: 'ClubhousesDeleteDiscussionReplyResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhousesDeleteDiscussionResponse = {
  __typename?: 'ClubhousesDeleteDiscussionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhousesDiscussionNotificationUpdateInput = {
  discussionId: Scalars['Int']['input'];
  subscribe: Scalars['Boolean']['input'];
};

export type ClubhousesDiscussionNotificationUpdateResponse = {
  __typename?: 'ClubhousesDiscussionNotificationUpdateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhousesEditDiscussionInput = {
  assets?: InputMaybe<Array<ImageAssetInput>>;
  clubhouseName: Scalars['String']['input'];
  content: Scalars['String']['input'];
  discussionID: Scalars['ID']['input'];
  headline: Scalars['String']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  topicSlug: Scalars['String']['input'];
};

export type ClubhousesEditDiscussionReplyInput = {
  assets?: InputMaybe<Array<ImageAssetInput>>;
  commentID: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type ClubhousesEditDiscussionReplyResponse = {
  __typename?: 'ClubhousesEditDiscussionReplyResponse';
  comment?: Maybe<ClubhousesComment>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhousesEditDiscussionResponse = {
  __typename?: 'ClubhousesEditDiscussionResponse';
  discussion?: Maybe<Discussion>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhousesFomUserPagination = {
  __typename?: 'ClubhousesFomUserPagination';
  page: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ClubhousesFomUserResponse = {
  __typename?: 'ClubhousesFomUserResponse';
  clubhouses?: Maybe<Array<Clubhouse>>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<ClubhousesListPagination>;
};

export type ClubhousesFromUserInput = {
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type ClubhousesGenerateDigestInput = {
  frequency: ClubhouseDigestFrequency;
};

export type ClubhousesGenerateDigestResponse = {
  __typename?: 'ClubhousesGenerateDigestResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhousesGetCommentInput = {
  commentId: Scalars['ID']['input'];
};

export type ClubhousesGetCommentResponse = {
  __typename?: 'ClubhousesGetCommentResponse';
  comment?: Maybe<ClubhousesComment>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhousesGetDiscussionCommentThreadInput = {
  commentId: Scalars['ID']['input'];
  discussionId?: InputMaybe<Scalars['ID']['input']>;
  discussionSlug?: InputMaybe<Scalars['String']['input']>;
};

export type ClubhousesGetDiscussionCommentThreadResponse = {
  __typename?: 'ClubhousesGetDiscussionCommentThreadResponse';
  comments?: Maybe<Array<ClubhousesComment>>;
  discussion?: Maybe<Discussion>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhousesGetDiscussionInput = {
  discussionId?: InputMaybe<Scalars['ID']['input']>;
  discussionSlug?: InputMaybe<Scalars['String']['input']>;
  repliesLimit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<DiscussionSortBy>;
  sortOrder?: InputMaybe<DiscussionSortOrder>;
};

export type ClubhousesGetDiscussionRepliesInput = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  discussionId?: InputMaybe<Scalars['ID']['input']>;
  discussionSlug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<DiscussionSortBy>;
  sortOrder?: InputMaybe<DiscussionSortOrder>;
};

export type ClubhousesGetDiscussionRepliesResponse = {
  __typename?: 'ClubhousesGetDiscussionRepliesResponse';
  comments?: Maybe<Array<ClubhousesComment>>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<ClubhousesCommentsPagination>;
  /** @deprecated Use 'comments' instead */
  replies?: Maybe<Array<ClubhousesComment>>;
};

export type ClubhousesGetDiscussionResponse = {
  __typename?: 'ClubhousesGetDiscussionResponse';
  discussion?: Maybe<Discussion>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhousesGetDiscussionsByIdsInput = {
  discussionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ClubhousesGetDiscussionsByIdsResponse = {
  __typename?: 'ClubhousesGetDiscussionsByIdsResponse';
  discussions?: Maybe<Array<Discussion>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhousesGetSubscriberCountInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type ClubhousesGetSubscriberCountResponse = {
  __typename?: 'ClubhousesGetSubscriberCountResponse';
  dailyDigestSubscriberCount: Scalars['Int']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
  totalSubscriberCount: Scalars['Int']['output'];
  weeklyDigestSubscriberCount: Scalars['Int']['output'];
};

export type ClubhousesGetTopCommentedThreadsInput = {
  externalIds: Array<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  timeRange: TimeRange;
};

export type ClubhousesGetTopCommentedThreadsResponse = {
  __typename?: 'ClubhousesGetTopCommentedThreadsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
  topThreads?: Maybe<Array<TopCommentedThread>>;
};

export type ClubhousesGetUploadedInput = {
  assetId: Scalars['String']['input'];
};

export type ClubhousesGetUploadedResponse = {
  __typename?: 'ClubhousesGetUploadedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type ClubhousesGetUserStatsInput = {
  userId: Scalars['String']['input'];
};

export type ClubhousesGetUserStatsResponse = {
  __typename?: 'ClubhousesGetUserStatsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  stats: ClubhousesUserStats;
};

export type ClubhousesGiveTipToDiscussionInput = {
  discussionId: Scalars['ID']['input'];
};

export type ClubhousesGiveTipToDiscussionResponse = {
  __typename?: 'ClubhousesGiveTipToDiscussionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhousesLikeReplyInput = {
  commentId: Scalars['ID']['input'];
};

export type ClubhousesLikeReplyResponse = {
  __typename?: 'ClubhousesLikeReplyResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhousesListInput = {
  filter?: InputMaybe<ClubhouseType>;
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type ClubhousesListPagination = {
  __typename?: 'ClubhousesListPagination';
  page: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ClubhousesListResponse = {
  __typename?: 'ClubhousesListResponse';
  clubhouseTypes?: Maybe<Array<ClubhouseType>>;
  clubhouses?: Maybe<Array<Clubhouse>>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<ClubhousesListPagination>;
};

export enum ClubhousesMemberSortBy {
  JoinedAt = 'joinedAt',
  Name = 'name'
}

export type ClubhousesReactToDiscussionInput = {
  discussionId: Scalars['Int']['input'];
  reactionAction: ClubhousesReactionAction;
  reactionType: ClubhousesReactionType;
};

export type ClubhousesReactToDiscussionResponse = {
  __typename?: 'ClubhousesReactToDiscussionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export enum ClubhousesReactionAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export enum ClubhousesReactionType {
  Like = 'LIKE'
}

export type ClubhousesRemoveLikeReplyInput = {
  commentId: Scalars['ID']['input'];
};

export type ClubhousesRemoveLikeReplyResponse = {
  __typename?: 'ClubhousesRemoveLikeReplyResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ClubhousesTopDiscussionsListInput = {
  clubhouseSlug: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};

export type ClubhousesTopDiscussionsListResponse = {
  __typename?: 'ClubhousesTopDiscussionsListResponse';
  discussions?: Maybe<Array<DiscussionListItem>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type ClubhousesTopicDiscussionsListInput = {
  clubhouseSlug: Scalars['String']['input'];
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sortOptions: ClubhousesTopicDiscussionsSortOptions;
  topicSlug: Scalars['String']['input'];
};

export type ClubhousesTopicDiscussionsListResponse = {
  __typename?: 'ClubhousesTopicDiscussionsListResponse';
  discussions?: Maybe<Array<DiscussionListItem>>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<ClubhousesListPagination>;
};

export enum ClubhousesTopicDiscussionsSortOptions {
  AllTime = 'allTime',
  Top = 'top'
}

export type ClubhousesTopicsListInput = {
  clubhouseSlug: Scalars['String']['input'];
  discussionsCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ClubhousesTopicsListResponse = {
  __typename?: 'ClubhousesTopicsListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  topics?: Maybe<Array<Topic>>;
};

export type ClubhousesUploadCreateSignedUrlInput = {
  uploadFile: Scalars['String']['input'];
};

export type ClubhousesUploadCreateSignedUrlResponse = {
  __typename?: 'ClubhousesUploadCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type ClubhousesUserBalance = {
  __typename?: 'ClubhousesUserBalance';
  balance: Scalars['Int']['output'];
};

export type ClubhousesUserInput = {
  userId: Scalars['ID']['input'];
};

export type ClubhousesUserProfile = {
  __typename?: 'ClubhousesUserProfile';
  balance: ClubhousesUserBalance;
  stats: ClubhousesUserStats;
  user: PublicUserProfile;
};

export type ClubhousesUserResponse = {
  __typename?: 'ClubhousesUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  user?: Maybe<ClubhousesUserProfile>;
};

export type ClubhousesUserStats = {
  __typename?: 'ClubhousesUserStats';
  commentsStats: CommentsStats;
  discussionsStats: DiscussionsStats;
  userId: Scalars['ID']['output'];
};

export type ClubhousesUsersBatchInput = {
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ClubhousesUsersBatchResponse = {
  __typename?: 'ClubhousesUsersBatchResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  users?: Maybe<Array<ClubhousesUserProfile>>;
};

export type ClubhousesViewDiscussionInput = {
  discussionID: Scalars['ID']['input'];
};

export type ClubhousesViewDiscussionResponse = {
  __typename?: 'ClubhousesViewDiscussionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export enum CoinActionType {
  DownloadBackgroundRemovedImage = 'DownloadBackgroundRemovedImage',
  DownloadUpscaledImage = 'DownloadUpscaledImage',
  DownloadVectorizedImage = 'DownloadVectorizedImage',
  GenerateAiCameraAngle = 'GenerateAICameraAngle',
  GenerateAiCollage = 'GenerateAICollage',
  GenerateAiColoringPageMaker = 'GenerateAIColoringPageMaker',
  GenerateAiDoodlePet = 'GenerateAIDoodlePet',
  GenerateAiEtsyCoachAudit = 'GenerateAIEtsyCoachAudit',
  GenerateAiFreeformCad = 'GenerateAIFreeformCad',
  GenerateAiImageEdit = 'GenerateAIImageEdit',
  GenerateAiImageEditGemini3Point1FlashImagePreview = 'GenerateAIImageEditGemini3Point1FlashImagePreview',
  GenerateAiImageEditGemini3ProPreview = 'GenerateAIImageEditGemini3ProPreview',
  GenerateAiMarketplaceEditor = 'GenerateAIMarketplaceEditor',
  GenerateAiMeshGenerator = 'GenerateAIMeshGenerator',
  GenerateAiMusicElevenlabs10Seconds = 'GenerateAIMusicElevenlabs10Seconds',
  GenerateAiMusicElevenlabs30Seconds = 'GenerateAIMusicElevenlabs30Seconds',
  GenerateAiMusicElevenlabs60Seconds = 'GenerateAIMusicElevenlabs60Seconds',
  GenerateAiMusicElevenlabs120Seconds = 'GenerateAIMusicElevenlabs120Seconds',
  GenerateAiMusicElevenlabs180Seconds = 'GenerateAIMusicElevenlabs180Seconds',
  GenerateAiMusicLyria3FullSong = 'GenerateAIMusicLyria3FullSong',
  GenerateAiMusicLyria230Seconds = 'GenerateAIMusicLyria230Seconds',
  GenerateAiMusicLyria330Seconds = 'GenerateAIMusicLyria330Seconds',
  GenerateAiQuote = 'GenerateAIQuote',
  GenerateAiSoundElevenlabs1Seconds = 'GenerateAISoundElevenlabs1Seconds',
  GenerateAiSoundElevenlabs2Seconds = 'GenerateAISoundElevenlabs2Seconds',
  GenerateAiSoundElevenlabs3Seconds = 'GenerateAISoundElevenlabs3Seconds',
  GenerateAiSoundElevenlabs5Seconds = 'GenerateAISoundElevenlabs5Seconds',
  GenerateAiSoundElevenlabs10Seconds = 'GenerateAISoundElevenlabs10Seconds',
  GenerateAiSoundElevenlabs15Seconds = 'GenerateAISoundElevenlabs15Seconds',
  GenerateAiSoundElevenlabs30Seconds = 'GenerateAISoundElevenlabs30Seconds',
  GenerateAiSplatGenerator = 'GenerateAISplatGenerator',
  GenerateAiSvgGenerator = 'GenerateAISvgGenerator',
  GenerateAiSvgGeneratorQuiveraiArrow11 = 'GenerateAISvgGeneratorQuiveraiArrow11',
  GenerateAiThreeDModel = 'GenerateAIThreeDModel',
  GenerateAiToonFamily = 'GenerateAIToonFamily',
  GenerateAiWatermarkRemover = 'GenerateAIWatermarkRemover',
  GenerateAiWeddingInvite = 'GenerateAIWeddingInvite',
  GenerateDesignReview = 'GenerateDesignReview',
  GenerateFlowIteration = 'GenerateFlowIteration',
  GenerateFlowIterationGrokImageGen2 = 'GenerateFlowIterationGrokImageGen2',
  GenerateFlowIterationImageGen4 = 'GenerateFlowIterationImageGen4',
  GenerateFlowIterationNanoBanana = 'GenerateFlowIterationNanoBanana',
  GenerateFlowIterationNanoBanana2 = 'GenerateFlowIterationNanoBanana2',
  GenerateFlowIterationNanoBananaPro = 'GenerateFlowIterationNanoBananaPro',
  GenerateFont = 'GenerateFont',
  GenerateLogo = 'GenerateLogo',
  GenerateMoment = 'GenerateMoment',
  RemovePeopleFromBackground = 'RemovePeopleFromBackground',
  Unspecified = 'Unspecified'
}

export type CoinAvailableRewards = {
  __typename?: 'CoinAvailableRewards';
  projectPosts?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Scalars['Int']['output']>;
};

export type CoinEarnAmount = {
  __typename?: 'CoinEarnAmount';
  amount: Scalars['Int']['output'];
  earnType: CoinEarnType;
};

export enum CoinEarnType {
  StudioAiSubscriptionActivationBonus = 'StudioAISubscriptionActivationBonus'
}

export type CoinFee = {
  __typename?: 'CoinFee';
  actionType: CoinActionType;
  amount: Scalars['Int']['output'];
};

export type CoinOrigin = {
  __typename?: 'CoinOrigin';
  action: CoinTransactionOrigin;
  label?: Maybe<Scalars['String']['output']>;
  product?: Maybe<CoinProduct>;
  user?: Maybe<PublicUserProfile>;
};

export type CoinProduct = {
  __typename?: 'CoinProduct';
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum CoinProductType {
  Team = 'team'
}

export type CoinRewardsSettings = {
  __typename?: 'CoinRewardsSettings';
  postProductReview: Scalars['Int']['output'];
  postSocialProductProject: Scalars['Int']['output'];
  registerAccount: Scalars['Int']['output'];
};

export type CoinSettings = {
  __typename?: 'CoinSettings';
  errors?: Maybe<Array<ErrorMessage>>;
  rewards?: Maybe<CoinRewardsSettings>;
  spending?: Maybe<CoinSpendingSettings>;
};

export type CoinSpendingActionsSettings = {
  __typename?: 'CoinSpendingActionsSettings';
  tipPostAuthor: Scalars['Int']['output'];
  tipUser: Scalars['Int']['output'];
};

export type CoinSpendingProductsSettings = {
  __typename?: 'CoinSpendingProductsSettings';
  bundles: Scalars['Int']['output'];
  classes: Scalars['Int']['output'];
  communityGraphics: Scalars['Int']['output'];
  crafts: Scalars['Int']['output'];
};

export type CoinSpendingSettings = {
  __typename?: 'CoinSpendingSettings';
  actions: CoinSpendingActionsSettings;
  products: CoinSpendingProductsSettings;
};

export type CoinTransaction = {
  __typename?: 'CoinTransaction';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  origin: CoinOrigin;
  parent?: Maybe<CoinTransaction>;
  reason?: Maybe<Scalars['String']['output']>;
  status: CoinTransactionStatus;
  type: CoinTransactionType;
};

export enum CoinTransactionOrigin {
  AdminChange = 'adminChange',
  AiCameraAngleGenerated = 'aiCameraAngleGenerated',
  AiCollageGenerated = 'aiCollageGenerated',
  AiColoringPageGenerated = 'aiColoringPageGenerated',
  AiDoodlePetGenerated = 'aiDoodlePetGenerated',
  AiEtsyCoachAudit = 'aiEtsyCoachAudit',
  AiGeneratedLyrics = 'aiGeneratedLyrics',
  AiImageEditGenerated = 'aiImageEditGenerated',
  AiMarketplaceEditorGenerated = 'aiMarketplaceEditorGenerated',
  AiMockupGenerator = 'aiMockupGenerator',
  AiMusicGenerated = 'aiMusicGenerated',
  AiPeopleFromBackgroundRemoved = 'aiPeopleFromBackgroundRemoved',
  AiPhotoStyle = 'aiPhotoStyle',
  AiQuoteGenerated = 'aiQuoteGenerated',
  AiSoundGenerated = 'aiSoundGenerated',
  AiSpeechGenerated = 'aiSpeechGenerated',
  AiStudioSubscriptionActivationBonus = 'aiStudioSubscriptionActivationBonus',
  AiStudioSubscriptionPaid = 'aiStudioSubscriptionPaid',
  AiStudioSubscriptionRenewed = 'aiStudioSubscriptionRenewed',
  AiStudioSubscriptionTrial = 'aiStudioSubscriptionTrial',
  AiStudioSubscriptionTrialCancelled = 'aiStudioSubscriptionTrialCancelled',
  AiSvgGenerator = 'aiSvgGenerator',
  AiSvgGeneratorQuiveraiArrow11 = 'aiSvgGeneratorQuiveraiArrow11',
  AiThreeDModelGenerated = 'aiThreeDModelGenerated',
  AiVideoEdited = 'aiVideoEdited',
  AiVideoGenerated = 'aiVideoGenerated',
  AiVideoUpscaled = 'aiVideoUpscaled',
  AiWatermarkRemoved = 'aiWatermarkRemoved',
  AiWeddingInviteGenerated = 'aiWeddingInviteGenerated',
  BackgroundRemovedImageDownloaded = 'backgroundRemovedImageDownloaded',
  CoinPackSubscriptionRenewed = 'coinPackSubscriptionRenewed',
  CoinPackSubscriptionStarted = 'coinPackSubscriptionStarted',
  CoinsWalletTopUp = 'coinsWalletTopUp',
  DesignReviewed = 'designReviewed',
  FlowIterationGenerated = 'flowIterationGenerated',
  FontGenerated = 'fontGenerated',
  FreeformCadGenerated = 'freeformCadGenerated',
  LogoGenerated = 'logoGenerated',
  MeshGenerated = 'meshGenerated',
  MomentGenerated = 'momentGenerated',
  ProductDownloaded = 'productDownloaded',
  ProductProjectPosted = 'productProjectPosted',
  ProductReviewed = 'productReviewed',
  ReferralBonus = 'referralBonus',
  Rewards = 'rewards',
  SocialPostTipped = 'socialPostTipped',
  SplatGenerated = 'splatGenerated',
  ToonFamilyGenerated = 'toonFamilyGenerated',
  Unspecified = 'unspecified',
  UpscaledImageDownloaded = 'upscaledImageDownloaded',
  UserTipped = 'userTipped',
  VectorizedImageDownloaded = 'vectorizedImageDownloaded'
}

export type CoinTransactionResponse = {
  __typename?: 'CoinTransactionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  transaction?: Maybe<CoinTransaction>;
};

export enum CoinTransactionStatus {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Pending = 'pending'
}

export enum CoinTransactionType {
  Earn = 'earn',
  Spend = 'spend',
  TopUp = 'topUp'
}

export type CoinTransactionsResponse = {
  __typename?: 'CoinTransactionsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<Pagination>;
  transactions?: Maybe<Array<CoinTransaction>>;
};

export type CoinTransactionsResponseByProduct = {
  __typename?: 'CoinTransactionsResponseByProduct';
  errors?: Maybe<Array<ErrorMessage>>;
  transactions?: Maybe<Array<CoinTransaction>>;
};

export type CoinWallet = {
  __typename?: 'CoinWallet';
  availableRewards: CoinAvailableRewards;
  balance: Scalars['Int']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
  transactions: CoinWalletTransactions;
};


export type CoinWalletTransactionsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type CoinWalletTransactions = {
  __typename?: 'CoinWalletTransactions';
  pagination?: Maybe<Pagination>;
  transactions?: Maybe<Array<CoinTransaction>>;
};

export type CoinsActionFeesResponse = {
  __typename?: 'CoinsActionFeesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  fees?: Maybe<Array<CoinFee>>;
};

export type CoinsBundle = {
  __typename?: 'CoinsBundle';
  coins?: Maybe<CoinsBundleTransactionInfo>;
  craftsCharacteristic?: Maybe<Scalars['String']['output']>;
  fontCharacteristic?: Maybe<Scalars['String']['output']>;
  graphicCharacteristic?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isCoinRewardBundle?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: CoinsBundleType;
  url: Scalars['String']['output'];
};

export type CoinsBundleTransactionInfo = {
  __typename?: 'CoinsBundleTransactionInfo';
  amount?: Maybe<Scalars['Int']['output']>;
  spent?: Maybe<CoinTransaction>;
};

export type CoinsBundleType = {
  __typename?: 'CoinsBundleType';
  title: Scalars['String']['output'];
};

export type CoinsBundlesResponse = {
  __typename?: 'CoinsBundlesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  items: Array<CoinsBundle>;
};

export type CoinsDownload = {
  __typename?: 'CoinsDownload';
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CoinsDownloadMeta = {
  __typename?: 'CoinsDownloadMeta';
  total?: Maybe<Scalars['Int']['output']>;
};

export enum CoinsDownloadsOrderBy {
  DateAsc = 'dateAsc',
  DateDesc = 'dateDesc',
  Rand = 'rand'
}

export type CoinsDownloadsResponse = {
  __typename?: 'CoinsDownloadsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  items: Array<CoinsDownload>;
  meta?: Maybe<CoinsDownloadMeta>;
};

export type CoinsEarnAmountResponse = {
  __typename?: 'CoinsEarnAmountResponse';
  amounts?: Maybe<Array<CoinEarnAmount>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type CoinsEntityTipRequest = {
  entityId: Scalars['String']['input'];
  entityType: CoinsEntityType;
};

export type CoinsEntityTipResponse = {
  __typename?: 'CoinsEntityTipResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export enum CoinsEntityType {
  Font = 'font',
  Unspecified = 'unspecified'
}

export type CoinsGiveTipResponse = {
  __typename?: 'CoinsGiveTipResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  transactions?: Maybe<Array<CoinTransaction>>;
};

export type CoinsIsStudioAiSubscriptionMandatoryResponse = {
  __typename?: 'CoinsIsStudioAISubscriptionMandatoryResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  isMandatory: Scalars['Boolean']['output'];
};

export type CoinsPopularProduct = {
  __typename?: 'CoinsPopularProduct';
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: CoinsPopularProductCategory;
  url: Scalars['String']['output'];
};

export type CoinsPopularProductCategory = {
  __typename?: 'CoinsPopularProductCategory';
  slug: Scalars['String']['output'];
};

export type CoinsPopularResponse = {
  __typename?: 'CoinsPopularResponse';
  classes?: Maybe<Array<CoinsPopularProduct>>;
  crafts?: Maybe<Array<CoinsPopularProduct>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type CoinsSpendResponse = {
  __typename?: 'CoinsSpendResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  transaction?: Maybe<CoinTransaction>;
};

export type CoinsSpentForUserResponse = {
  __typename?: 'CoinsSpentForUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  spent: Scalars['Int']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  asset?: Maybe<AskCfAsset>;
  childComments?: Maybe<Array<Comment>>;
  comment: Scalars['String']['output'];
  commentCount: Scalars['Int']['output'];
  createTime: Scalars['DateTime']['output'];
  downvotes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDisliked: Scalars['Boolean']['output'];
  isLiked: Scalars['Boolean']['output'];
  upvotes: Scalars['Int']['output'];
  user: PublicUserProfile;
};

export type CommentsStats = {
  __typename?: 'CommentsStats';
  commentsCreatedCount: Scalars['Int']['output'];
  commentsReactedCount: Scalars['Int']['output'];
  reactionsReceivedCount: Scalars['Int']['output'];
};

export type CommunityLeader = {
  __typename?: 'CommunityLeader';
  clubhouseSlug: Scalars['String']['output'];
  createTime: Scalars['DateTime']['output'];
  rights?: Maybe<Array<CommunityLeaderRight>>;
  user: PublicUserProfile;
};

export type CommunityLeaderInfo = {
  __typename?: 'CommunityLeaderInfo';
  clubhouseSlug: Scalars['String']['output'];
  createTime: Scalars['DateTime']['output'];
  rights?: Maybe<Array<CommunityLeaderRight>>;
};

export enum CommunityLeaderRight {
  CanRemoveComments = 'canRemoveComments',
  CanRemoveDiscussions = 'canRemoveDiscussions',
  Unspecified = 'unspecified'
}

export type ConfirmMyAccountEmailResetInput = {
  token: Scalars['String']['input'];
};

export type ConfirmMyAccountEmailResetResponse = {
  __typename?: 'ConfirmMyAccountEmailResetResponse';
  error?: Maybe<ErrorGrowth>;
};

export type ContentAlternativeSlug = {
  __typename?: 'ContentAlternativeSlug';
  language: ContentLanguage;
  slug: Scalars['String']['output'];
};

export type ContentAsset = {
  __typename?: 'ContentAsset';
  downloadable: Scalars['Boolean']['output'];
  downloads_count: Scalars['Int']['output'];
  file_path: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  product_id: Scalars['ID']['output'];
  resolution?: Maybe<ContentAssetResolution>;
  size_bytes: Scalars['Int']['output'];
  type: ContentAssetType;
  variant: ContentAssetVariant;
};

export type ContentAssetResolution = {
  __typename?: 'ContentAssetResolution';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type ContentAssetResolutionV2 = {
  __typename?: 'ContentAssetResolutionV2';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export enum ContentAssetType {
  AssetTypeBackgroundRemoved = 'ASSET_TYPE_BACKGROUND_REMOVED',
  AssetTypeDownscaled = 'ASSET_TYPE_DOWNSCALED',
  AssetTypeOriginal = 'ASSET_TYPE_ORIGINAL',
  AssetTypeOriginalUnoptimized = 'ASSET_TYPE_ORIGINAL_UNOPTIMIZED',
  AssetTypePreview = 'ASSET_TYPE_PREVIEW',
  AssetTypePrintable = 'ASSET_TYPE_PRINTABLE',
  AssetTypeThumbnail = 'ASSET_TYPE_THUMBNAIL',
  AssetTypeUnspecified = 'ASSET_TYPE_UNSPECIFIED',
  AssetTypeUpscaled = 'ASSET_TYPE_UPSCALED'
}

export enum ContentAssetTypeV2 {
  /** This asset type is generated from the original image by applying a background remove algorithm. */
  AssetTypeBackgroundRemoved = 'ASSET_TYPE_BACKGROUND_REMOVED',
  AssetTypeDownscaled = 'ASSET_TYPE_DOWNSCALED',
  AssetTypeOriginal = 'ASSET_TYPE_ORIGINAL',
  AssetTypePreview = 'ASSET_TYPE_PREVIEW',
  AssetTypeThumbnail = 'ASSET_TYPE_THUMBNAIL',
  AssetTypeUnspecified = 'ASSET_TYPE_UNSPECIFIED',
  AssetTypeUpscaled = 'ASSET_TYPE_UPSCALED'
}

export type ContentAssetV2 = {
  __typename?: 'ContentAssetV2';
  downloadsCount: Scalars['Int']['output'];
  filePath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  resolution?: Maybe<ContentAssetResolutionV2>;
  sizeBytes: Scalars['Int']['output'];
  type: ContentAssetTypeV2;
  variant: ContentAssetVariantV2;
};

export enum ContentAssetVariant {
  AssetVariantDesktop = 'ASSET_VARIANT_DESKTOP',
  AssetVariantLarge = 'ASSET_VARIANT_LARGE',
  AssetVariantMedium = 'ASSET_VARIANT_MEDIUM',
  AssetVariantMobile = 'ASSET_VARIANT_MOBILE',
  AssetVariantSmall = 'ASSET_VARIANT_SMALL',
  AssetVariantUnspecified = 'ASSET_VARIANT_UNSPECIFIED',
  AssetVariantWatermarked = 'ASSET_VARIANT_WATERMARKED',
  AssetVariantXlarge = 'ASSET_VARIANT_XLARGE',
  AssetVariantXsmall = 'ASSET_VARIANT_XSMALL'
}

export enum ContentAssetVariantV2 {
  AssetVariantDesktop = 'ASSET_VARIANT_DESKTOP',
  AssetVariantLarge = 'ASSET_VARIANT_LARGE',
  AssetVariantMedium = 'ASSET_VARIANT_MEDIUM',
  AssetVariantMobile = 'ASSET_VARIANT_MOBILE',
  AssetVariantSmall = 'ASSET_VARIANT_SMALL',
  AssetVariantUnspecified = 'ASSET_VARIANT_UNSPECIFIED',
  AssetVariantWatermarked = 'ASSET_VARIANT_WATERMARKED',
  AssetVariantXlarge = 'ASSET_VARIANT_XLARGE'
}

export type ContentCategory = {
  __typename?: 'ContentCategory';
  _language: ContentLanguage;
  alternativeSlugs: Array<ContentCategorySlug>;
  ancestors: Array<Scalars['String']['output']>;
  contentBottom: Scalars['String']['output'];
  contentTop: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId: Scalars['String']['output'];
  parents: Array<ContentCategory>;
  root?: Maybe<ContentCategory>;
  seo: ContentCategorySeo;
  slug: Scalars['String']['output'];
  totalProducts: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type ContentCategorySeo = {
  __typename?: 'ContentCategorySEO';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ContentCategorySeoV2 = {
  __typename?: 'ContentCategorySeoV2';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ContentCategorySlug = {
  __typename?: 'ContentCategorySlug';
  language: ContentLanguage;
  slug: Scalars['String']['output'];
};

export type ContentCategorySlugV2 = {
  __typename?: 'ContentCategorySlugV2';
  language: ContentLanguageV2;
  slug: Scalars['String']['output'];
};

export type ContentCategoryV2 = {
  __typename?: 'ContentCategoryV2';
  _language: ContentLanguageV2;
  alternativeSlugs: Array<ContentCategorySlugV2>;
  ancestors: Array<Scalars['String']['output']>;
  contentBottom: Scalars['String']['output'];
  contentTop: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId: Scalars['String']['output'];
  parents: Array<ContentCategoryV2>;
  root?: Maybe<ContentCategoryV2>;
  seo: ContentCategorySeoV2;
  slug: Scalars['String']['output'];
  totalProducts: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type ContentCreateFavoriteListInput = {
  name: Scalars['String']['input'];
};

export type ContentCreateReview = {
  body: Scalars['String']['input'];
  getInTouch?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentDownloadAssetsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export enum ContentDownloadSource {
  Studio = 'Studio',
  Website = 'Website'
}

export type ContentEditReview = {
  body?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentFavorite = {
  __typename?: 'ContentFavorite';
  categories?: Maybe<Array<ContentCategory>>;
  categoryIds?: Maybe<Array<Scalars['ID']['output']>>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  listIds: Array<Scalars['ID']['output']>;
  lists: Array<ContentFavoriteList>;
  product: ContentProduct;
  productId: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  userId: Scalars['ID']['output'];
};

export type ContentFavoriteList = {
  __typename?: 'ContentFavoriteList';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userId: Scalars['ID']['output'];
};

export type ContentFetchLicenseInput = {
  key?: InputMaybe<Scalars['ID']['input']>;
  productID: Scalars['ID']['input'];
  source?: InputMaybe<ContentDownloadSource>;
};

export enum ContentLanguage {
  LanguageDe = 'LANGUAGE_DE',
  LanguageEn = 'LANGUAGE_EN',
  LanguageEs = 'LANGUAGE_ES',
  LanguageFr = 'LANGUAGE_FR',
  LanguageIt = 'LANGUAGE_IT',
  LanguageNl = 'LANGUAGE_NL',
  LanguagePl = 'LANGUAGE_PL',
  LanguagePtBr = 'LANGUAGE_PT_BR'
}

export enum ContentLanguageV2 {
  LanguageDe = 'LANGUAGE_DE',
  LanguageEn = 'LANGUAGE_EN',
  LanguageEs = 'LANGUAGE_ES',
  LanguageFr = 'LANGUAGE_FR',
  LanguageIt = 'LANGUAGE_IT',
  LanguageNl = 'LANGUAGE_NL',
  LanguagePl = 'LANGUAGE_PL',
  LanguagePtBr = 'LANGUAGE_PT_BR'
}

export type ContentLicense = {
  __typename?: 'ContentLicense';
  createdAt: Scalars['DateTime']['output'];
  key: Scalars['ID']['output'];
};

export type ContentLinkBlock = {
  __typename?: 'ContentLinkBlock';
  id: Scalars['ID']['output'];
  links: Array<ContentLinkBlockLink>;
  title: Scalars['String']['output'];
  type: ContentLinkBlockType;
};

export type ContentLinkBlockLink = {
  __typename?: 'ContentLinkBlockLink';
  anchor: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum ContentLinkBlockType {
  Generated = 'GENERATED',
  Manual = 'MANUAL'
}

export type ContentListFavoritesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  listId?: InputMaybe<Scalars['ID']['input']>;
};

export type ContentMetadata = {
  __typename?: 'ContentMetadata';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContentPagination = {
  __typename?: 'ContentPagination';
  categoryId: Scalars['ID']['output'];
  currentPage: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  products: Array<ContentProduct>;
  type: ContentPaginationType;
};

export enum ContentPaginationType {
  DiscoverMore = 'DiscoverMore',
  Popularity = 'Popularity',
  Recommended = 'Recommended',
  Unspecified = 'Unspecified'
}

export type ContentPaginationV2 = {
  __typename?: 'ContentPaginationV2';
  categoryId: Scalars['ID']['output'];
  currentPage: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  products: Array<ContentProductPreview>;
  type: ContentPaginationType;
};

export type ContentPaymentRequired = {
  __typename?: 'ContentPaymentRequired';
  paymentUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ContentProduct = {
  __typename?: 'ContentProduct';
  _language: ContentLanguage;
  alternativeSlugs?: Maybe<Array<ContentAlternativeSlug>>;
  assets: Array<ContentAsset>;
  author_id: Scalars['String']['output'];
  canonicalId: Scalars['String']['output'];
  category: ContentCategory;
  category_id: Scalars['String']['output'];
  created_at: Scalars['Time']['output'];
  deleted_at?: Maybe<Scalars['Time']['output']>;
  description: Scalars['String']['output'];
  downloads_count: Scalars['Int']['output'];
  format: ContentProductFormat;
  id: Scalars['String']['output'];
  licenses: Array<ContentLicense>;
  linkBlocks: Array<ContentLinkBlock>;
  metadata: Array<ContentMetadata>;
  pricing: ContentProductPricing;
  publicAssets: Array<ContentAsset>;
  /** @deprecated Use top-level fields instead, e.g: title, description */
  seo: ContentSeo;
  slug: Scalars['String']['output'];
  status: ContentProductStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  type: ContentProductType;
  updated_at: Scalars['Time']['output'];
  url: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  views_count: Scalars['Int']['output'];
  woocommerce_product_id?: Maybe<Scalars['Int']['output']>;
};

export type ContentProductFavoriteCount = {
  __typename?: 'ContentProductFavoriteCount';
  total: Scalars['Int']['output'];
  userIds: Array<Scalars['ID']['output']>;
  users: Array<PublicUserProfile>;
};

export enum ContentProductFormat {
  ProductFormatLandscape_3_2 = 'PRODUCT_FORMAT_LANDSCAPE_3_2',
  ProductFormatLandscape_16_9 = 'PRODUCT_FORMAT_LANDSCAPE_16_9',
  ProductFormatPortrait_2_3 = 'PRODUCT_FORMAT_PORTRAIT_2_3',
  ProductFormatPortrait_4_5 = 'PRODUCT_FORMAT_PORTRAIT_4_5',
  ProductFormatPortrait_9_16 = 'PRODUCT_FORMAT_PORTRAIT_9_16',
  ProductFormatSquare_1_1 = 'PRODUCT_FORMAT_SQUARE_1_1',
  ProductFormatUnspecified = 'PRODUCT_FORMAT_UNSPECIFIED'
}

export type ContentProductPreview = {
  __typename?: 'ContentProductPreview';
  authorId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  previewHeight: Scalars['Int']['output'];
  previewPath: Scalars['String']['output'];
  previewWidth: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ContentProductPricing = {
  __typename?: 'ContentProductPricing';
  price: Scalars['Int']['output'];
  sale_price?: Maybe<Scalars['Int']['output']>;
};

export type ContentProductReviews = {
  __typename?: 'ContentProductReviews';
  _language: ContentLanguage;
  cursor: Scalars['String']['output'];
  product: ContentProduct;
  productId: Scalars['ID']['output'];
  rating: ContentReviewRating;
  replies: Array<ContentReview>;
  reviews: Array<ContentReview>;
};

export type ContentProductReviewsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  language: ContentLanguage;
  limit: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
};

export type ContentProductStats = {
  __typename?: 'ContentProductStats';
  downloads: Scalars['Int']['output'];
  favorites: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export enum ContentProductStatus {
  StatusApproved = 'STATUS_APPROVED',
  StatusBlocked = 'STATUS_BLOCKED',
  StatusDeleted = 'STATUS_DELETED',
  StatusPending = 'STATUS_PENDING',
  StatusPublished = 'STATUS_PUBLISHED',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

export enum ContentProductType {
  ProductTypeCraft = 'PRODUCT_TYPE_CRAFT',
  ProductTypeGraphics = 'PRODUCT_TYPE_GRAPHICS',
  ProductTypeUnspecified = 'PRODUCT_TYPE_UNSPECIFIED'
}

export type ContentRegisterProductDownloadInput = {
  legacyProductId?: InputMaybe<Scalars['Int']['input']>;
  licenseId: Scalars['String']['input'];
  newLicenseGenerated: Scalars['Boolean']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ContentRegisterProductDownloadResponse = {
  __typename?: 'ContentRegisterProductDownloadResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ContentReview = {
  __typename?: 'ContentReview';
  body: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: PublicUserProfile;
  userId: Scalars['String']['output'];
};

export type ContentReviewRating = {
  __typename?: 'ContentReviewRating';
  average: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  groups: Array<ContentReviewRatingGroup>;
};

export type ContentReviewRatingGroup = {
  __typename?: 'ContentReviewRatingGroup';
  count: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
};

export type ContentSeo = {
  __typename?: 'ContentSeo';
  description: Scalars['String']['output'];
  h1: Scalars['String']['output'];
  image_alt: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ContentUpdateFavoriteInput = {
  listIds: Array<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};

export type ContentUpdateFavoriteListInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ContentUserFavoritesCountInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  language?: InputMaybe<ContentLanguage>;
};

export type ContentUserListCountPerCategory = {
  __typename?: 'ContentUserListCountPerCategory';
  category: ContentCategory;
  categoryId: Scalars['ID']['output'];
  language: ContentLanguage;
  total: Scalars['Int']['output'];
};

export type ContentUserListFavorites = {
  __typename?: 'ContentUserListFavorites';
  favorites?: Maybe<Array<ContentFavorite>>;
  total: Scalars['Int']['output'];
};

export type ContentUserListFavoritesCount = {
  __typename?: 'ContentUserListFavoritesCount';
  total: Scalars['Int']['output'];
  totalPerCategory?: Maybe<Array<ContentUserListCountPerCategory>>;
};

export type ContentUserListFavoritesInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  language: ContentLanguage;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type Contents = {
  __typename?: 'Contents';
  destinationUrl: Scalars['String']['output'];
  template: CampaignTemplateType;
  templateFormatImageOnly?: Maybe<TemplateFormatImageOnly>;
  templateFormatImagesAndLogo?: Maybe<TemplateFormatImagesAndLogo>;
  templateFormatImagesAndText?: Maybe<TemplateFormatImagesAndText>;
  templateFormatVideoAndImage?: Maybe<TemplateFormatVideoAndImage>;
  templateFormatVideoOnly?: Maybe<TemplateFormatVideoOnly>;
};

export type CoreFlag = {
  __typename?: 'CoreFlag';
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum CountryCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CraftMachine = {
  __typename?: 'CraftMachine';
  brand: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CraftMachineGetResponse = {
  __typename?: 'CraftMachineGetResponse';
  craftMachine?: Maybe<CraftMachine>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type CraftMachineListResponse = {
  __typename?: 'CraftMachineListResponse';
  craftMachines: Array<CraftMachine>;
  errors?: Maybe<Array<ErrorMessage>>;
  meta: CraftMachineResponseMeta;
};

export enum CraftMachineOrderBy {
  Brand = 'brand',
  Id = 'id',
  Name = 'name'
}

export type CraftMachineResponseMeta = {
  __typename?: 'CraftMachineResponseMeta';
  direction: SortOrder;
  hasMore: CfMainHasMore;
  limit: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  orderBy: CraftMachineOrderBy;
  previousCursor?: Maybe<Scalars['String']['output']>;
  secondaryKey: CraftMachineOrderBy;
};

export type CraftMaterial = {
  __typename?: 'CraftMaterial';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type CraftMaterialDeleteResponse = {
  __typename?: 'CraftMaterialDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type CraftMaterialGetResponse = {
  __typename?: 'CraftMaterialGetResponse';
  craftMaterial?: Maybe<CraftMaterial>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export enum CraftMaterialOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  Type = 'type'
}

export type CraftMaterialsListResponse = {
  __typename?: 'CraftMaterialsListResponse';
  craftMaterials: Array<CraftMaterial>;
  errors?: Maybe<Array<ErrorMessage>>;
  meta: CraftMaterialsResponseMeta;
};

export type CraftMaterialsResponseMeta = {
  __typename?: 'CraftMaterialsResponseMeta';
  direction: SortOrder;
  hasMore: CfMainHasMore;
  limit: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  orderBy: CraftMaterialOrderBy;
  previousCursor?: Maybe<Scalars['String']['output']>;
  secondaryKey: CraftMaterialOrderBy;
};

export type CraftTheme = {
  __typename?: 'CraftTheme';
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CraftThemeDeleteResponse = {
  __typename?: 'CraftThemeDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export enum CraftThemeOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type CraftThemesGetResponse = {
  __typename?: 'CraftThemesGetResponse';
  craftTheme?: Maybe<CraftTheme>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type CraftThemesListResponse = {
  __typename?: 'CraftThemesListResponse';
  craftThemes: Array<CraftTheme>;
  errors?: Maybe<Array<ErrorMessage>>;
  meta: CraftThemesResponseMeta;
};

export type CraftThemesResponseMeta = {
  __typename?: 'CraftThemesResponseMeta';
  direction: SortOrder;
  hasMore: CfMainHasMore;
  limit: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  orderBy: CraftThemeOrderBy;
  previousCursor?: Maybe<Scalars['String']['output']>;
  secondaryKey: CraftThemeOrderBy;
};

export type CraftingType = {
  __typename?: 'CraftingType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weight: Scalars['Int']['output'];
};

export enum CraftingTypeOrderBy {
  CreatedAt = 'createdAt',
  Id = 'id',
  Title = 'title',
  Weight = 'weight'
}

export type CraftingTypesListResponse = {
  __typename?: 'CraftingTypesListResponse';
  craftingTypes: Array<CraftingType>;
  errors?: Maybe<Array<ErrorMessage>>;
  meta: CraftingTypesResponseMeta;
};

export type CraftingTypesResponseMeta = {
  __typename?: 'CraftingTypesResponseMeta';
  direction: SortOrder;
  hasMore: CfMainHasMore;
  limit: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  orderBy: CraftingTypeOrderBy;
  previousCursor?: Maybe<Scalars['String']['output']>;
  secondaryKey: CraftingTypeOrderBy;
};

export type CreateSetupIntentInput = {
  country: Scalars['String']['input'];
  currencyCode: AvailableCurrencyCode;
};

export type CreateSetupIntentResponse = {
  __typename?: 'CreateSetupIntentResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  setupIntent?: Maybe<SetupIntent>;
};

export type Currency = {
  __typename?: 'Currency';
  code?: Maybe<CurrencyCode>;
  symbol: Scalars['String']['output'];
};

export enum CurrencyCode {
  Aud = 'aud',
  Cad = 'cad',
  Cny = 'cny',
  Dkk = 'dkk',
  Eur = 'eur',
  Gbp = 'gbp',
  Jpy = 'jpy',
  Pln = 'pln',
  Usd = 'usd'
}

export type Customer = {
  __typename?: 'Customer';
  country: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  taxId: Scalars['String']['output'];
};

export type DailyGifts = {
  __typename?: 'DailyGifts';
  categoryId: Scalars['String']['output'];
  freeProduct?: Maybe<DailyGiftsFreeProduct>;
  promoProducts?: Maybe<Array<DailyGiftsPromoProduct>>;
  title: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type DailyGiftsFreeProduct = {
  __typename?: 'DailyGiftsFreeProduct';
  downloadLink: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceCurrency: Scalars['String']['output'];
  shopName: Scalars['String']['output'];
  shopUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DailyGiftsPromoProduct = {
  __typename?: 'DailyGiftsPromoProduct';
  expiresAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  isDeal?: Maybe<Scalars['Boolean']['output']>;
  priceCurrency: Scalars['String']['output'];
  priceDiscount?: Maybe<Scalars['Float']['output']>;
  priceFull: Scalars['Float']['output'];
  shopName: Scalars['String']['output'];
  shopUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleTop: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum DateField {
  LastViewTime = 'lastViewTime',
  UpdateTime = 'updateTime'
}

export enum DateRange {
  Last30Days = 'last30Days',
  Last90Days = 'last90Days',
  LastYear = 'lastYear',
  Today = 'today',
  Yesterday = 'yesterday'
}

export type DeactivateAccountResponse = {
  __typename?: 'DeactivateAccountResponse';
  challenge?: Maybe<AuthChallenge>;
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Response for deleting a note. */
export type DeleteAdminProductNoteResponse = {
  __typename?: 'DeleteAdminProductNoteResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
};

export type DeleteUserAccountResponse = {
  __typename?: 'DeleteUserAccountResponse';
  deleted: Scalars['Boolean']['output'];
  error?: Maybe<ErrorGrowth>;
};

export type DeleteUserAvatarResponse = {
  __typename?: 'DeleteUserAvatarResponse';
  error?: Maybe<ErrorGrowth>;
  success: Scalars['Boolean']['output'];
};

export type DesignReview = {
  __typename?: 'DesignReview';
  alignmentAndProximity?: Maybe<ReviewAspect>;
  colorSchemeHarmonious?: Maybe<ReviewAspect>;
  colorSchemeSuitsPurpose?: Maybe<ReviewAspect>;
  compositionAndBalance?: Maybe<ReviewAspect>;
  consistency?: Maybe<ReviewAspect>;
  contrast?: Maybe<ReviewAspect>;
  graphicsAndImages?: Maybe<ReviewAspect>;
  hierarchyAndEmphasis?: Maybe<ReviewAspect>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<ReviewAspect>;
  status: DesignReviewStatusType;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  typographyFontChoices?: Maybe<ReviewAspect>;
  typographyLegibility?: Maybe<ReviewAspect>;
  whiteSpace?: Maybe<ReviewAspect>;
};

export enum DesignReviewStatusType {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Unspecified = 'unspecified'
}

export type DesignReviewerCancelReviewRequestInput = {
  id: Scalars['String']['input'];
};

export type DesignReviewerCancelReviewRequestResponse = {
  __typename?: 'DesignReviewerCancelReviewRequestResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type DesignReviewerDeleteAllReviewResponse = {
  __typename?: 'DesignReviewerDeleteAllReviewResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type DesignReviewerDeleteReviewInput = {
  id: Scalars['ID']['input'];
};

export type DesignReviewerDeleteReviewResponse = {
  __typename?: 'DesignReviewerDeleteReviewResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DesignReviewerGetReviewInput = {
  id: Scalars['ID']['input'];
};

export type DesignReviewerGetReviewResponse = {
  __typename?: 'DesignReviewerGetReviewResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  review?: Maybe<DesignReview>;
  success: Scalars['Boolean']['output'];
};

export type DesignReviewerListPagination = {
  __typename?: 'DesignReviewerListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type DesignReviewerListReviewsInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
};

export type DesignReviewerListReviewsResponse = {
  __typename?: 'DesignReviewerListReviewsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<DesignReviewerListPagination>;
  reviews?: Maybe<Array<DesignReview>>;
};

export type DesignReviewerUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String']['input'];
};

export type DesignReviewerUploadsCreateSignedUrlResponse = {
  __typename?: 'DesignReviewerUploadsCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type DesignerPreviewInfo = {
  __typename?: 'DesignerPreviewInfo';
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  shopUrl?: Maybe<Scalars['String']['output']>;
};

export type DesignerProfile = {
  __typename?: 'DesignerProfile';
  designerAvatar?: Maybe<Scalars['String']['output']>;
  designerId?: Maybe<Scalars['Int']['output']>;
  designerName?: Maybe<Scalars['String']['output']>;
  designerUrl?: Maybe<Scalars['String']['output']>;
  isPremium?: Maybe<Scalars['Boolean']['output']>;
  premiumLegalEntity?: Maybe<Scalars['String']['output']>;
};

export enum DesignerVerificationStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  SoftRejected = 'softRejected',
  Unknown = 'unknown',
  VerificationRequired = 'verificationRequired'
}

export type Discussion = {
  __typename?: 'Discussion';
  assets?: Maybe<Array<ImageAsset>>;
  clubhouseName: Scalars['String']['output'];
  coinsCount: Scalars['Int']['output'];
  comments?: Maybe<Array<ClubhousesComment>>;
  commentsCount: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  createTime: Scalars['DateTime']['output'];
  edited?: Maybe<Scalars['Boolean']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use 'assets' instead */
  images?: Maybe<Array<ImageAsset>>;
  isLiked: Scalars['Boolean']['output'];
  isSaved: Scalars['Boolean']['output'];
  isSubscribedToAllNotifications: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
  productCards?: Maybe<Array<SocialProductCard>>;
  slug?: Maybe<Scalars['String']['output']>;
  topicId: Scalars['Int']['output'];
  topicSlug?: Maybe<Scalars['String']['output']>;
  user?: Maybe<PublicUserProfile>;
  usersCount: Scalars['Int']['output'];
  viewsCount: Scalars['Int']['output'];
};

export type DiscussionListItem = {
  __typename?: 'DiscussionListItem';
  clubhouseSlug: Scalars['String']['output'];
  commentsCount: Scalars['Int']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  topicSlug: Scalars['String']['output'];
  usersCount: Scalars['Int']['output'];
};

export enum DiscussionSortBy {
  Activity = 'activity',
  CreatedTime = 'createdTime',
  Reactions = 'reactions',
  Unspecified = 'unspecified'
}

export enum DiscussionSortOrder {
  Ascending = 'ascending',
  Descending = 'descending',
  Unspecified = 'unspecified'
}

export type DiscussionsStats = {
  __typename?: 'DiscussionsStats';
  reactionsReceivedCount: Scalars['Int']['output'];
  topicsCount: Scalars['Int']['output'];
};

export type DropdownItem = {
  __typename?: 'DropdownItem';
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Input for editing a note. */
export type EditAdminProductNoteInput = {
  /** Updated note message */
  message: Scalars['String']['input'];
  /** Note ID */
  noteId: Scalars['Int']['input'];
};

/** Response for editing a note. */
export type EditAdminProductNoteResponse = {
  __typename?: 'EditAdminProductNoteResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** The updated message content */
  message: Scalars['String']['output'];
};

export type EditMyAccountEmailPasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password1?: InputMaybe<Scalars['String']['input']>;
  password2?: InputMaybe<Scalars['String']['input']>;
  passwordCurrent?: InputMaybe<Scalars['String']['input']>;
};

export type EditMyAccountEmailPasswordResponse = {
  __typename?: 'EditMyAccountEmailPasswordResponse';
  error?: Maybe<ErrorGrowth>;
};

export type EditUserProfileInput = {
  isChecked?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type EditUserProfileResponse = {
  __typename?: 'EditUserProfileResponse';
  error?: Maybe<ErrorGrowth>;
};

export type EmailAddress = {
  __typename?: 'EmailAddress';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type EmailAddressInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EmailNotificationSettings = {
  __typename?: 'EmailNotificationSettings';
  commentedOnYourPost?: Maybe<Scalars['Boolean']['output']>;
  followedUserNewPost?: Maybe<Scalars['Boolean']['output']>;
  repliedToYourComment?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailNotificationSettingsInput = {
  commentedOnYourPost?: InputMaybe<Scalars['Boolean']['input']>;
  followedUserNewPost?: InputMaybe<Scalars['Boolean']['input']>;
  repliedToYourComment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnterpriseRequest = {
  __typename?: 'EnterpriseRequest';
  asset: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  employees: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  job?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<Scalars['Int']['output']>;
  project?: Maybe<Scalars['String']['output']>;
  usages: Array<EnterpriseRequestUsage>;
};

export enum EnterpriseRequestEmployees {
  ElevenToFifty = 'ELEVEN_TO_FIFTY',
  FiftyOneToOneHundred = 'FIFTY_ONE_TO_ONE_HUNDRED',
  MoreThanFiveHundred = 'MORE_THAN_FIVE_HUNDRED',
  OneHundredOneToFiveHundred = 'ONE_HUNDRED_ONE_TO_FIVE_HUNDRED',
  OneToTen = 'ONE_TO_TEN'
}

export type EnterpriseRequestUsage = {
  __typename?: 'EnterpriseRequestUsage';
  answer: Scalars['String']['output'];
  enterpriseReqId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  usage: Scalars['String']['output'];
};

export type EntityDownloadInput = {
  entityId: Scalars['ID']['input'];
  entityType: StudioSocialReactionEntityType;
};

export type EntityDownloadResponse = {
  __typename?: 'EntityDownloadResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type EntityLoveInput = {
  entityId: Scalars['ID']['input'];
  entityType: StudioSocialReactionEntityType;
};

export type EntityLoveResponse = {
  __typename?: 'EntityLoveResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type EntityReactDeleteInput = {
  entityId: Scalars['ID']['input'];
  entityType: StudioSocialReactionEntityType;
};

export type EntityReactDeleteResponse = {
  __typename?: 'EntityReactDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type EntityReactInput = {
  entityId: Scalars['ID']['input'];
  entityType: StudioSocialReactionEntityType;
  reaction: EntityReactionType;
};

export type EntityReactResponse = {
  __typename?: 'EntityReactResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  reaction?: Maybe<EntityReaction>;
  success: Scalars['Boolean']['output'];
};

export type EntityReaction = {
  __typename?: 'EntityReaction';
  createTime: Scalars['DateTime']['output'];
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  entityId: Scalars['ID']['output'];
  entityType: StudioSocialReactionEntityType;
  id: Scalars['ID']['output'];
  reaction: EntityReactionType;
  user: PublicUserProfile;
};

export enum EntityReactionType {
  Favorite = 'Favorite',
  Unspecified = 'Unspecified'
}

export type EntityReactionsInput = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  entityId: Scalars['ID']['input'];
  entityType: StudioSocialReactionEntityType;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EntityReactionsResponse = {
  __typename?: 'EntityReactionsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  reactions?: Maybe<Array<EntityReaction>>;
};

export type EntityStatsResponse = {
  __typename?: 'EntityStatsResponse';
  downloads: Scalars['Int']['output'];
  entityId: Scalars['ID']['output'];
  entityType: StudioSocialReactionEntityType;
  loves: Scalars['Int']['output'];
  onlineViewers: Scalars['Int']['output'];
  tips: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export type EntityViewInput = {
  entityId: Scalars['ID']['input'];
  entityType: StudioSocialReactionEntityType;
};

export enum ErrorCode {
  Aborted = 'aborted',
  BadRequest = 'badRequest',
  Conflict = 'conflict',
  /** Password reset key is past its expiry. */
  ExpiredKey = 'expiredKey',
  FailedPrecondition = 'failedPrecondition',
  Forbidden = 'forbidden',
  Internal = 'internal',
  /** Password reset key does not match the account. */
  InvalidKey = 'invalidKey',
  NotFound = 'notFound',
  /** Password does not meet the requirements. */
  PasswordInvalid = 'passwordInvalid',
  PermissionDenied = 'permissionDenied',
  TooManyRequests = 'tooManyRequests',
  Unauthorized = 'unauthorized'
}

export type ErrorGrowth = {
  __typename?: 'ErrorGrowth';
  context?: Maybe<Scalars['Map']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type: ErrorTypeGrowth;
};

export type ErrorMessage = {
  __typename?: 'ErrorMessage';
  code: ErrorCode;
  fields?: Maybe<Array<Maybe<FieldError>>>;
  message: Scalars['String']['output'];
};

export enum ErrorTypeGrowth {
  AllPasswordFieldsMustBeFilledOut = 'allPasswordFieldsMustBeFilledOut',
  CurrentPasswordIsIncorrect = 'currentPasswordIsIncorrect',
  CurrentPasswordNotProvided = 'currentPasswordNotProvided',
  EitherNewEmailAndOrPasswordMustBeProvided = 'eitherNewEmailAndOrPasswordMustBeProvided',
  EmailAddressAlreadyRegistered = 'emailAddressAlreadyRegistered',
  EmailAddressNotProvided = 'emailAddressNotProvided',
  ExistingEmailAddress = 'existingEmailAddress',
  Forbidden = 'forbidden',
  Internal = 'internal',
  NewPasswordsDoNotMatch = 'newPasswordsDoNotMatch',
  ProvideValidEmailAddress = 'provideValidEmailAddress',
  ReEnterYourPassword = 'reEnterYourPassword',
  SocialLoginAccountsLinked = 'socialLoginAccountsLinked',
  TokenExpired = 'tokenExpired',
  WrongToken = 'wrongToken'
}

export type ExtendSubscriptionResult = {
  __typename?: 'ExtendSubscriptionResult';
  maxExtensionsReached?: Maybe<Scalars['Boolean']['output']>;
  nextPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  payInvoiceUrl?: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus;
  userBanned?: Maybe<Scalars['Boolean']['output']>;
};

export type ExtendSubscriptionToPlanInput = {
  extendToPlan?: InputMaybe<SubscriptionPlan>;
  subscriptionId: Scalars['String']['input'];
};

export type ExtendSubscriptionToPlanResponse = {
  __typename?: 'ExtendSubscriptionToPlanResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  subscription?: Maybe<SubscriptionPayload>;
};

export type FieldError = {
  __typename?: 'FieldError';
  errors: Array<Scalars['String']['output']>;
  field: Scalars['String']['output'];
};

export type Flow = {
  __typename?: 'Flow';
  createTime: Scalars['DateTime']['output'];
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  hasMoreIterations?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  iterations: Array<FlowIteration>;
  lastIteration: FlowIteration;
  owner: Scalars['Boolean']['output'];
  stats?: Maybe<FlowStats>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['DateTime']['output']>;
  user: PublicUserProfile;
  visibility: FlowVisibility;
};

export enum FlowAspectRatio {
  AutoResize = 'auto_resize',
  Landscape_4_3 = 'landscape_4_3',
  Landscape_16_9 = 'landscape_16_9',
  Portrait_3_4 = 'portrait_3_4',
  Portrait_9_16 = 'portrait_9_16',
  Square = 'square'
}

export type FlowCancelIterationPageInput = {
  id: Scalars['ID']['input'];
};

export type FlowCancelIterationPageResponse = {
  __typename?: 'FlowCancelIterationPageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export enum FlowEffect {
  Analog = 'analog',
  Glitch = 'glitch',
  LessSaturated = 'lessSaturated',
  MoreSaturated = 'moreSaturated',
  None = 'none',
  Pixelate = 'pixelate',
  Poster = 'poster',
  Sepia = 'sepia',
  Sketch = 'sketch',
  ThreeDGlasses = 'threeDGlasses'
}

export type FlowFeed = {
  __typename?: 'FlowFeed';
  /** @deprecated use items field instead */
  flows: Array<Flow>;
  items: Array<FlowFeedItem>;
};

export type FlowFeedItem = {
  __typename?: 'FlowFeedItem';
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  visibility: FlowVisibility;
};

export type FlowFlowsTippedInput = {
  id: Scalars['String']['input'];
};

export type FlowGenerationsCountResponse = {
  __typename?: 'FlowGenerationsCountResponse';
  created: Scalars['Int']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
  hasUnlimited: Scalars['Boolean']['output'];
  remaining?: Maybe<Scalars['Int']['output']>;
};

export type FlowGetIterationPageRatingInput = {
  pageId: Scalars['String']['input'];
};

export type FlowGetIterationPageRatingResponse = {
  __typename?: 'FlowGetIterationPageRatingResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  rating: IterationRating;
};

export type FlowImage = {
  __typename?: 'FlowImage';
  chosenTool?: Maybe<FlowTool>;
  createTime: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  published: Scalars['Boolean']['output'];
  state: FlowImageState;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type FlowImageFlowInput = {
  imageId: Scalars['ID']['input'];
};

export type FlowImageFlowResponse = {
  __typename?: 'FlowImageFlowResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  flow?: Maybe<Flow>;
};

export type FlowImageGetFavoritesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};

export type FlowImageGetFavoritesResponse = {
  __typename?: 'FlowImageGetFavoritesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  favorites?: Maybe<Array<FlowImageReaction>>;
  hasMore: Scalars['Boolean']['output'];
};

export type FlowImageGetReactions = {
  __typename?: 'FlowImageGetReactions';
  counter?: Maybe<FlowImageReactionsCounter>;
  imageId: Scalars['ID']['output'];
  userReaction?: Maybe<ImageReaction>;
};

export type FlowImageGetReactionsInput = {
  imageIds: Array<Scalars['ID']['input']>;
};

export type FlowImageGetReactionsResponse = {
  __typename?: 'FlowImageGetReactionsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  reactions?: Maybe<Array<FlowImageGetReactions>>;
  success: Scalars['Boolean']['output'];
};

export type FlowImageInput = {
  id: Scalars['ID']['input'];
};

export type FlowImageReactInput = {
  imageId: Scalars['ID']['input'];
  reaction: ImageReaction;
};

export type FlowImageReactResponse = {
  __typename?: 'FlowImageReactResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FlowImageReaction = {
  __typename?: 'FlowImageReaction';
  flowId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  imageId: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  reactionTime: Scalars['DateTime']['output'];
  thumbnailUrl: Scalars['String']['output'];
};

export type FlowImageReactionsCounter = {
  __typename?: 'FlowImageReactionsCounter';
  Like: Scalars['Int']['output'];
};

export type FlowImageRemoveReactInput = {
  imageId: Scalars['ID']['input'];
};

export type FlowImageRemoveReactResponse = {
  __typename?: 'FlowImageRemoveReactResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FlowImageReportInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['ID']['input'];
  reason: FlowImageReportReason;
};

export enum FlowImageReportReason {
  ChildEndangerment = 'ChildEndangerment',
  CopyRight = 'CopyRight',
  HateDiscrimination = 'HateDiscrimination',
  Nudity = 'Nudity',
  Spam = 'Spam',
  UnlawfulContent = 'UnlawfulContent',
  Unspecified = 'Unspecified',
  Violence = 'Violence'
}

export type FlowImageReportResponse = {
  __typename?: 'FlowImageReportResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FlowImageResponse = {
  __typename?: 'FlowImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  image?: Maybe<FlowImage>;
};

export enum FlowImageSource {
  None = 'none',
  Uploaded = 'uploaded'
}

export enum FlowImageState {
  Failed = 'failed',
  Generated = 'generated'
}

export type FlowImageTop = {
  __typename?: 'FlowImageTop';
  aspectRatio: FlowAspectRatio;
  counter: FlowImageReactionsCounter;
  flowId: Scalars['ID']['output'];
  imageId: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  iterationId: Scalars['ID']['output'];
  prompt: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type FlowImagesTopAllTimeInput = {
  after?: InputMaybe<Scalars['Int']['input']>;
  includeNSFW?: InputMaybe<Scalars['Boolean']['input']>;
  take: Scalars['Int']['input'];
};

export type FlowImagesTopAllTimeResponse = {
  __typename?: 'FlowImagesTopAllTimeResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore: Scalars['Boolean']['output'];
  images?: Maybe<Array<FlowImageTop>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FlowImagesTopInput = {
  after: Scalars['Int']['input'];
  includeNSFW?: InputMaybe<Scalars['Boolean']['input']>;
  take: Scalars['Int']['input'];
};

export type FlowImagesTopResponse = {
  __typename?: 'FlowImagesTopResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore: Scalars['Boolean']['output'];
  images?: Maybe<Array<FlowImageTop>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FlowInteractionInput = {
  id: Scalars['ID']['input'];
};

export type FlowInteractionResponse = {
  __typename?: 'FlowInteractionResponse';
  downloadsTotal?: Maybe<Scalars['Int']['output']>;
  heartsTotal?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageReactionsTotal?: Maybe<FlowInteractionImageReactionTotal>;
  tipsTotal?: Maybe<Scalars['Int']['output']>;
  viewsTotal?: Maybe<Scalars['Int']['output']>;
};

export type FlowIteration = {
  __typename?: 'FlowIteration';
  aspectRatio?: Maybe<FlowAspectRatio>;
  createTime: Scalars['DateTime']['output'];
  /** @deprecated No longer supported */
  effect?: Maybe<FlowEffect>;
  fileType?: Maybe<FlowIterationFileType>;
  id: Scalars['ID']['output'];
  imageId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  model?: Maybe<FlowModel>;
  pages: Array<FlowIterationPage>;
  pagesTotal: Scalars['Int']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  quality?: Maybe<FlowQuality>;
  resolution?: Maybe<Scalars['String']['output']>;
  results: Array<FlowImage>;
  style: FlowStyle;
  type: FlowType;
};

export enum FlowIterationFileType {
  Png = 'png',
  Svg = 'svg',
  Unknown = 'unknown'
}

export type FlowIterationPage = {
  __typename?: 'FlowIterationPage';
  cancelled: Scalars['Boolean']['output'];
  pageID: Scalars['String']['output'];
  results: Array<FlowImage>;
};

export type FlowIterationPagesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  iterationId: Scalars['ID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FlowIterationPagesResponse = {
  __typename?: 'FlowIterationPagesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore: Scalars['Boolean']['output'];
  pages: Array<FlowIterationPage>;
};

export type FlowIterationRateInput = {
  iterationId: Scalars['String']['input'];
  rating: IterationRating;
};

export type FlowIterationRateResponse = {
  __typename?: 'FlowIterationRateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FlowIterationsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export enum FlowModel {
  Default = 'Default',
  GrokImageGen2 = 'GrokImageGen2',
  ImageGen4 = 'ImageGen4',
  NanoBanana = 'NanoBanana',
  NanoBanana2 = 'NanoBanana2',
  NanoBananaPro = 'NanoBananaPro',
  OpenAigptImage2 = 'OpenAIGPTImage2'
}

export type FlowPreview = {
  __typename?: 'FlowPreview';
  flowId: Scalars['ID']['output'];
  isGenerating: Scalars['Boolean']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  visibility: FlowVisibility;
};

export enum FlowPreviewSort {
  Newest = 'newest',
  Top = 'top'
}

export type FlowPublishImageInput = {
  id: Scalars['String']['input'];
};

export type FlowPublishImageResponse = {
  __typename?: 'FlowPublishImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  upload?: Maybe<StudioUploadsFile>;
};

export enum FlowQuality {
  High = 'high',
  Low = 'low'
}

export type FlowQueue = {
  __typename?: 'FlowQueue';
  flowID: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export type FlowRateIterationPageInput = {
  pageId: Scalars['String']['input'];
  rating: IterationRating;
};

export type FlowRateIterationPageResponse = {
  __typename?: 'FlowRateIterationPageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FlowSettingsInput = {
  aspectRatio?: InputMaybe<FlowAspectRatio>;
  effect?: InputMaybe<FlowEffect>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  imageSource?: InputMaybe<FlowImageSource>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<FlowModel>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<FlowQuality>;
  source?: InputMaybe<FlowSource>;
  style?: InputMaybe<FlowStyle>;
  type: FlowType;
  visibility?: InputMaybe<FlowVisibility>;
};

export enum FlowSource {
  Lumo = 'lumo',
  None = 'none'
}

export type FlowStats = {
  __typename?: 'FlowStats';
  downloads: Scalars['Int']['output'];
  hearts: Scalars['Int']['output'];
  tips: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export type FlowStatus = {
  __typename?: 'FlowStatus';
  active: Scalars['Boolean']['output'];
  flowId: Scalars['ID']['output'];
};

export enum FlowStyle {
  CfVanillaClipart512x001 = 'CFVanillaClipart512x001',
  Deliberate = 'deliberate',
  Magic = 'magic',
  NoStyle = 'no_style',
  Openjourney = 'openjourney',
  Photoreal = 'photoreal',
  Protogen = 'protogen',
  Redshift = 'redshift',
  Synthwave = 'synthwave',
  V2Cartoon = 'v2_cartoon',
  V2Cyberpunk = 'v2_cyberpunk',
  V2InkBlot = 'v2_inkBlot',
  V2Kawaii = 'v2_kawaii',
  V2LowPoly = 'v2_lowPoly',
  V2None = 'v2_none',
  V2Photoreal = 'v2_photoreal',
  V2Style3d = 'v2_style3d',
  V2Watercolor = 'v2_watercolor',
  Vectorartz = 'vectorartz'
}

export enum FlowTool {
  Bgr = 'bgr',
  Grayscale = 'grayscale',
  None = 'none',
  Pixelate = 'pixelate',
  Rhinestone = 'rhinestone',
  Silhouette = 'silhouette',
  Text2Image = 'text2Image',
  Upscale = 'upscale',
  Vectorizer = 'vectorizer'
}

export enum FlowType {
  Animation = 'animation',
  Full = 'full',
  Pattern = 'pattern',
  Svg = 'svg',
  Transparent = 'transparent',
  V2Full = 'v2_full',
  V2Pattern = 'v2_pattern',
  V2Transparent = 'v2_transparent',
  V3SmartRender = 'v3_smart_render'
}

export type FlowViewersResponse = {
  __typename?: 'FlowViewersResponse';
  activeUsers: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  totalViewers: Scalars['Int']['output'];
};

export enum FlowVisibility {
  Private = 'private',
  PrivateLocked = 'privateLocked',
  Public = 'public'
}

export type FlowsFlowTippedResponse = {
  __typename?: 'FlowsFlowTippedResponse';
  tipped: Scalars['Boolean']['output'];
};

export type FlowsPreviewUserFlowsInput = {
  afterId?: InputMaybe<Scalars['String']['input']>;
  createdByUserId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<FlowPreviewSort>;
  take: Scalars['Int']['input'];
};

export type FlowsPreviewUserFlowsResponse = {
  __typename?: 'FlowsPreviewUserFlowsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore: Scalars['Boolean']['output'];
  previews: Array<FlowPreview>;
};

export type Font = {
  __typename?: 'Font';
  category: FontCategory;
  /** @deprecated use createdAt */
  claimedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  /** @deprecated use subscription stats values */
  downloads: Scalars['Int']['output'];
  fontThumbnailUrl: Scalars['String']['output'];
  /** @deprecated No longer supported */
  fontUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated use subscription stats values */
  loves: Scalars['Int']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  reactions: Scalars['Int']['output'];
  /** @deprecated shouldn't be used */
  status?: Maybe<GeneratedFontStatus>;
  title: Scalars['String']['output'];
  user: PublicUserProfile;
  userReaction?: Maybe<EntityReactionType>;
  /** @deprecated use subscription stats values */
  views: Scalars['Int']['output'];
};

export type FontArticle = {
  __typename?: 'FontArticle';
  imageUrl: Scalars['String']['output'];
  intro: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FontArticleSection = {
  __typename?: 'FontArticleSection';
  articles: Array<FontArticle>;
  readAllText: Scalars['String']['output'];
  readAllUrl: Scalars['String']['output'];
};

export enum FontCategory {
  Artistic = 'Artistic',
  Decorative = 'Decorative',
  Fancy = 'Fancy',
  SansSerif = 'SansSerif',
  Undefined = 'Undefined'
}

export type FontGeneratorAcceptSymbolResponse = {
  __typename?: 'FontGeneratorAcceptSymbolResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorCancelSymbolResponse = {
  __typename?: 'FontGeneratorCancelSymbolResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorFontCreateInput = {
  category?: InputMaybe<GeneratedFontCategory>;
  fontCategory: FontCategory;
  prompt: Scalars['String']['input'];
  visibility?: InputMaybe<GeneratedFontVisibility>;
};

export type FontGeneratorFontCreateResponse = {
  __typename?: 'FontGeneratorFontCreateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  fontId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorFontDownloadResponse = {
  __typename?: 'FontGeneratorFontDownloadResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  font?: Maybe<GeneratedFont>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorFontInput = {
  id: Scalars['ID']['input'];
};

export type FontGeneratorFontProgressResponse = {
  __typename?: 'FontGeneratorFontProgressResponse';
  readiness: Scalars['Int']['output'];
};

export type FontGeneratorFontResponse = {
  __typename?: 'FontGeneratorFontResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  font?: Maybe<GeneratedFont>;
};

export enum FontGeneratorFontUpdateFields {
  Title = 'title',
  Visibility = 'visibility'
}

export type FontGeneratorFontUpdateInput = {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updateFields: Array<FontGeneratorFontUpdateFields>;
  visibility?: InputMaybe<GeneratedFontVisibility>;
};

export type FontGeneratorFontUpdateResponse = {
  __typename?: 'FontGeneratorFontUpdateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorFontsFeedInput = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<GeneratedFontCategory>;
  sort?: InputMaybe<FontsFeedSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FontGeneratorFontsFeedResponse = {
  __typename?: 'FontGeneratorFontsFeedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  fonts?: Maybe<Array<Font>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
};

export type FontGeneratorFontsInput = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<GeneratedFontCategory>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FontGeneratorFontsResponse = {
  __typename?: 'FontGeneratorFontsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  fonts?: Maybe<Array<GeneratedFont>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
};

export type FontGeneratorSymbolGenerateInput = {
  fontId: Scalars['ID']['input'];
  fontSymbol: FontSymbolName;
};

export type FontGeneratorSymbolGenerateResponse = {
  __typename?: 'FontGeneratorSymbolGenerateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorSymbolProgressResponse = {
  __typename?: 'FontGeneratorSymbolProgressResponse';
  readiness: Scalars['Int']['output'];
};

export type FontGeneratorUserFontCreateInput = {
  category: FontCategory;
  prompt: Scalars['String']['input'];
  visibility?: InputMaybe<GeneratedFontVisibility>;
};

export type FontGeneratorUserFontCreateResponse = {
  __typename?: 'FontGeneratorUserFontCreateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  fontId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorUserFontDeleteAllResponse = {
  __typename?: 'FontGeneratorUserFontDeleteAllResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorUserFontDeleteInput = {
  id: Scalars['ID']['input'];
};

export type FontGeneratorUserFontDeleteResponse = {
  __typename?: 'FontGeneratorUserFontDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorUserFontInput = {
  id: Scalars['ID']['input'];
};

export type FontGeneratorUserFontPackResponse = {
  __typename?: 'FontGeneratorUserFontPackResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  font?: Maybe<GeneratedFont>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorUserFontProgressResponse = {
  __typename?: 'FontGeneratorUserFontProgressResponse';
  readiness: Scalars['Int']['output'];
};

export type FontGeneratorUserFontResponse = {
  __typename?: 'FontGeneratorUserFontResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  font?: Maybe<GeneratedFont>;
};

export type FontGeneratorUserFontUpdateInput = {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updateFields: Array<FontGeneratorFontUpdateFields>;
  visibility?: InputMaybe<GeneratedFontVisibility>;
};

export type FontGeneratorUserFontUpdateResponse = {
  __typename?: 'FontGeneratorUserFontUpdateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type FontGeneratorUserFontsInput = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<FontCategory>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FontGeneratorUserFontsResponse = {
  __typename?: 'FontGeneratorUserFontsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  fonts?: Maybe<Array<GeneratedFont>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
};

export type FontSymbol = {
  __typename?: 'FontSymbol';
  createdAt: Scalars['String']['output'];
  fontSymbol: FontSymbolName;
  fontSymbolUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: FontSymbolStatus;
};

export enum FontSymbolName {
  Ampersand = 'ampersand',
  Apostrophe = 'apostrophe',
  Asterisk = 'asterisk',
  CircumflexAccent = 'circumflex_accent',
  Colon = 'colon',
  Comma = 'comma',
  CommercialAt = 'commercial_at',
  DollarSign = 'dollar_sign',
  Eight = 'eight',
  EqualsSign = 'equals_sign',
  Euro = 'euro',
  ExclamationMark = 'exclamation_mark',
  Five = 'five',
  Four = 'four',
  FullStop = 'full_stop',
  GraveAccent = 'grave_accent',
  GreaterThanSign = 'greater_than_sign',
  HyphenMinus = 'hyphen_minus',
  LeftCurlyBracket = 'left_curly_bracket',
  LeftParenthesis = 'left_parenthesis',
  LeftSquareBracket = 'left_square_bracket',
  LessThanSign = 'less_than_sign',
  LowLine = 'low_line',
  LowerA = 'lower_a',
  LowerB = 'lower_b',
  LowerC = 'lower_c',
  LowerD = 'lower_d',
  LowerE = 'lower_e',
  LowerF = 'lower_f',
  LowerG = 'lower_g',
  LowerH = 'lower_h',
  LowerI = 'lower_i',
  LowerJ = 'lower_j',
  LowerK = 'lower_k',
  LowerL = 'lower_l',
  LowerM = 'lower_m',
  LowerN = 'lower_n',
  LowerO = 'lower_o',
  LowerP = 'lower_p',
  LowerQ = 'lower_q',
  LowerR = 'lower_r',
  LowerS = 'lower_s',
  LowerT = 'lower_t',
  LowerU = 'lower_u',
  LowerV = 'lower_v',
  LowerW = 'lower_w',
  LowerX = 'lower_x',
  LowerY = 'lower_y',
  LowerZ = 'lower_z',
  Nine = 'nine',
  NumberSign = 'number_sign',
  One = 'one',
  PercentSign = 'percent_sign',
  PlusSign = 'plus_sign',
  Pound = 'pound',
  QuestionMark = 'question_mark',
  QuotationMark = 'quotation_mark',
  ReverseSolidus = 'reverse_solidus',
  RightCurlyBracket = 'right_curly_bracket',
  RightParenthesis = 'right_parenthesis',
  RightSquareBracket = 'right_square_bracket',
  Semicolon = 'semicolon',
  Seven = 'seven',
  Six = 'six',
  Solidus = 'solidus',
  Three = 'three',
  Tilde = 'tilde',
  Two = 'two',
  Unspecified = 'unspecified',
  UpperA = 'upper_a',
  UpperB = 'upper_b',
  UpperC = 'upper_c',
  UpperD = 'upper_d',
  UpperE = 'upper_e',
  UpperF = 'upper_f',
  UpperG = 'upper_g',
  UpperH = 'upper_h',
  UpperI = 'upper_i',
  UpperJ = 'upper_j',
  UpperK = 'upper_k',
  UpperL = 'upper_l',
  UpperM = 'upper_m',
  UpperN = 'upper_n',
  UpperO = 'upper_o',
  UpperP = 'upper_p',
  UpperQ = 'upper_q',
  UpperR = 'upper_r',
  UpperS = 'upper_s',
  UpperT = 'upper_t',
  UpperU = 'upper_u',
  UpperV = 'upper_v',
  UpperW = 'upper_w',
  UpperX = 'upper_x',
  UpperY = 'upper_y',
  UpperZ = 'upper_z',
  VerticalLine = 'vertical_line',
  Zero = 'zero'
}

export enum FontSymbolStatus {
  Accepted = 'accepted',
  Discarded = 'discarded',
  Error = 'error',
  Generated = 'generated',
  Generating = 'generating',
  Unspecified = 'unspecified'
}

export enum FontType {
  Otf = 'otf',
  Ttf = 'ttf',
  Undefined = 'undefined',
  Woff = 'woff',
  Woff2 = 'woff2'
}

export type FontsFeedFontBrowserInput = {
  category?: InputMaybe<FontCategory>;
  id: Scalars['ID']['input'];
  sort: FontsFeedSort;
};

export type FontsFeedFontBrowserResponse = {
  __typename?: 'FontsFeedFontBrowserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  nextId?: Maybe<Scalars['ID']['output']>;
  previousId?: Maybe<Scalars['ID']['output']>;
};

export type FontsFeedFontResponse = {
  __typename?: 'FontsFeedFontResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  font?: Maybe<Font>;
};

export type FontsFeedInput = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<FontCategory>;
  sort?: InputMaybe<FontsFeedSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FontsFeedResponse = {
  __typename?: 'FontsFeedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  fonts?: Maybe<Array<Font>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
};

export enum FontsFeedSort {
  CreateTime = 'CreateTime',
  Reactions = 'Reactions',
  Unspecified = 'Unspecified'
}

export type FontsFeedUpdatesResponse = {
  __typename?: 'FontsFeedUpdatesResponse';
  font: Font;
};

export type FreebiesPageData = {
  __typename?: 'FreebiesPageData';
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  products?: Maybe<FreebiesProducts>;
  totalFreebiesCount?: Maybe<Scalars['Int']['output']>;
};

export type FreebiesProductGroup = {
  __typename?: 'FreebiesProductGroup';
  count?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
  products: Array<ProductBox>;
};

export type FreebiesProducts = {
  __typename?: 'FreebiesProducts';
  new?: Maybe<FreebiesProductGroup>;
  popularity?: Maybe<FreebiesProductGroup>;
};

export enum Gender {
  Female = 'female',
  Male = 'male',
  RatherNotSay = 'ratherNotSay'
}

export type GeneratedFont = {
  __typename?: 'GeneratedFont';
  /** @deprecated use font category */
  category: GeneratedFontCategory;
  /** @deprecated No longer supported */
  claimedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fontCategory: FontCategory;
  fontSymbols?: Maybe<Array<FontSymbol>>;
  fontThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  fontUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  missingGlyphs?: Maybe<Array<FontSymbolName>>;
  /** @deprecated No longer supported */
  originalUrl?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  status: GeneratedFontStatus;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  visibility: GeneratedFontVisibility;
};

export enum GeneratedFontCategory {
  Artistic = 'Artistic',
  Decorative = 'Decorative',
  Fancy = 'Fancy',
  Undefined = 'Undefined'
}

export enum GeneratedFontStatus {
  Customizing = 'customizing',
  Error = 'error',
  Finalized = 'finalized',
  Generated = 'generated',
  Generating = 'generating',
  Packing = 'packing',
  Unspecified = 'unspecified'
}

export enum GeneratedFontVisibility {
  Private = 'Private',
  Public = 'Public',
  Undefined = 'Undefined'
}

export type GeneratedFontsDeleteAllForUserResponse = {
  __typename?: 'GeneratedFontsDeleteAllForUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type GeneratedFontsDeleteInput = {
  id: Scalars['ID']['input'];
};

export type GeneratedFontsDeleteResponse = {
  __typename?: 'GeneratedFontsDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

/** Response for retrieving the admin dashboard menu structure. */
export type GetAdminDashboardMenuResponse = {
  __typename?: 'GetAdminDashboardMenuResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** The complete menu structure with access flags computed for the current user */
  menu?: Maybe<AdminDashboardMenu>;
};

/** Response for retrieving admin product files. */
export type GetAdminProductFilesResponse = {
  __typename?: 'GetAdminProductFilesResponse';
  /** Product category slug, used by FE to determine if files are editable */
  category: Scalars['String']['output'];
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** List of downloadable files */
  files?: Maybe<Array<AdminProductFile>>;
};

/** Response for retrieving admin product history. */
export type GetAdminProductHistoryResponse = {
  __typename?: 'GetAdminProductHistoryResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** List of history entries, ordered by date descending */
  history?: Maybe<Array<AdminProductHistoryEntry>>;
};

/** Response for retrieving admin product images. */
export type GetAdminProductImagesResponse = {
  __typename?: 'GetAdminProductImagesResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** List of product images */
  images?: Maybe<Array<AdminProductImage>>;
};

/** Response for retrieving admin product info. */
export type GetAdminProductInfoResponse = {
  __typename?: 'GetAdminProductInfoResponse';
  /** Whether the current user can delete this product */
  canDelete: Scalars['Boolean']['output'];
  /** Designer information */
  designer?: Maybe<AdminProductDesignerInfo>;
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** Product details */
  product?: Maybe<AdminProduct>;
};

/** Response for retrieving admin product notes. */
export type GetAdminProductNotesResponse = {
  __typename?: 'GetAdminProductNotesResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** List of notes for the product */
  notes?: Maybe<Array<AdminProductNote>>;
  /** Pagination information */
  pagination?: Maybe<AdminPagination>;
};

/** Response for retrieving admin product removal reasons. */
export type GetAdminProductRemovalReasonsResponse = {
  __typename?: 'GetAdminProductRemovalReasonsResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** List of removal reasons */
  reasons?: Maybe<Array<AdminProductRemovalReason>>;
};

/** Response for retrieving admin product reports. */
export type GetAdminProductReportsResponse = {
  __typename?: 'GetAdminProductReportsResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** Pagination information */
  pagination?: Maybe<AdminPagination>;
  /** List of reports for the product */
  reports?: Maybe<Array<AdminProductReport>>;
};

/** Response for admin product search. */
export type GetAdminProductSearchResponse = {
  __typename?: 'GetAdminProductSearchResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** List of matching products */
  results?: Maybe<Array<AdminProductSearchResult>>;
};

/** Response for retrieving admin product tags. */
export type GetAdminProductTagsResponse = {
  __typename?: 'GetAdminProductTagsResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** List of tags for the product */
  tags?: Maybe<Array<AdminProductTag>>;
};

/** Response for admin user search. */
export type GetAdminUserSearchResponse = {
  __typename?: 'GetAdminUserSearchResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
  /** List of matching users */
  results?: Maybe<Array<AdminUserSearchResult>>;
};

export type GetClassesPreviewInfoInput = {
  ids: Scalars['String']['input'];
};

export type GetClassesPreviewInfoResponse = {
  __typename?: 'GetClassesPreviewInfoResponse';
  classes?: Maybe<Array<Class>>;
  error?: Maybe<ErrorGrowth>;
};

export type GetClubhouseInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type GetClubhouseResponse = {
  __typename?: 'GetClubhouseResponse';
  clubhouse?: Maybe<Clubhouse>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type GetClubhouseTopicInput = {
  clubhouseSlug: Scalars['String']['input'];
  topicSlug: Scalars['String']['input'];
};

export type GetClubhouseTopicResponse = {
  __typename?: 'GetClubhouseTopicResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  topic: Topic;
};

export type GetContentCategoryProductsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type GetContentCategoryProductsResponse = {
  __typename?: 'GetContentCategoryProductsResponse';
  articleSection?: Maybe<FontArticleSection>;
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  categories: Array<CategoryLink>;
  error?: Maybe<ErrorGrowth>;
  faqSection?: Maybe<Array<CategoryFaq>>;
  footerDescription: Scalars['String']['output'];
  pageDescription?: Maybe<Scalars['String']['output']>;
  pagination: CategoryPagination;
  products: Array<ProductBox>;
  seo?: Maybe<SeoData>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GetCoreFlagsResponse = {
  __typename?: 'GetCoreFlagsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  flags?: Maybe<Array<CoreFlag>>;
};

/**
 * Response for retrieving a designer's "About Your Store" content.
 * Returns the custom description text the designer has set for their store.
 */
export type GetDesignerAboutStoreResponse = {
  __typename?: 'GetDesignerAboutStoreResponse';
  /**
   * The designer's custom store description text.
   * Returns an empty string if no description has been set.
   */
  aboutYourStore: Scalars['String']['output'];
  /** Error details should the request fail */
  error?: Maybe<ErrorGrowth>;
};

/**
 * Response for retrieving a designer's favorites count.
 * Returns the total number of items favorited by the designer.
 */
export type GetDesignerFavoritesCountResponse = {
  __typename?: 'GetDesignerFavoritesCountResponse';
  /** Error details should the request fail */
  error?: Maybe<ErrorGrowth>;
  /**
   * The total number of items favorited by the designer.
   * Represents the count of all items in the designer's favorites collection.
   */
  favoritesCount: Scalars['Int']['output'];
};

/**
 * Response for retrieving a designer's identity verification status.
 * Returns the completion status of the multi-step verification process which includes
 * personal details, identity document verification (via SumSub), and phone verification.
 */
export type GetDesignerIdentityVerificationStatusResponse = {
  __typename?: 'GetDesignerIdentityVerificationStatusResponse';
  /** Error details should the request fail */
  error?: Maybe<ErrorGrowth>;
  /**
   * Whether the designer's identity has been verified through SumSub.
   * Requires personal details to also be verified.
   */
  identityVerified: Scalars['Boolean']['output'];
  /**
   * True when all verification steps are complete:
   * personal details verified, identity verified, and phone verified.
   */
  isComplete: Scalars['Boolean']['output'];
  /** Whether the designer has submitted and verified their personal details. */
  personalDetailsVerified: Scalars['Boolean']['output'];
  /** Whether the designer has verified their phone number. */
  phoneVerified: Scalars['Boolean']['output'];
};

/**
 * Response for retrieving a designer's promotion settings.
 * Includes shop promotion opt-in status, discount percentage, and POD enablement.
 */
export type GetDesignerPromotionSettingsResponse = {
  __typename?: 'GetDesignerPromotionSettingsResponse';
  /**
   * The discount percentage applied to shop promotions.
   * Value ranges from 0 to 100. Returns 0 if no discount is configured.
   */
  discountPercentage: Scalars['Int']['output'];
  /** Error details should the request fail */
  error?: Maybe<ErrorGrowth>;
  /**
   * Whether Print-on-Demand (POD) is enabled for the designer.
   * Indicates if the designer has POD functionality active.
   */
  podEnabled: Scalars['Boolean']['output'];
  /**
   * Whether shop promotions are enabled for the designer.
   * Indicates if the designer has opted in to promotional activities.
   */
  shopPromotionEnabled: Scalars['Boolean']['output'];
};

/**
 * Response for retrieving a designer's shop banner information.
 * Indicates whether a banner exists and provides the banner URL if available.
 */
export type GetDesignerShopBannerResponse = {
  __typename?: 'GetDesignerShopBannerResponse';
  /**
   * The URL of the shop banner image.
   * Returns the full URL to the banner image, or empty string if no banner is set.
   */
  bannerUrl: Scalars['String']['output'];
  /** Error details should the request fail */
  error?: Maybe<ErrorGrowth>;
  /**
   * Whether the designer has a shop banner configured.
   * Indicates if a banner image is set for the designer's store.
   */
  hasBanner: Scalars['Boolean']['output'];
};

/**
 * Response for retrieving a designer's total lifetime earnings.
 * Includes current wallet balance, legacy earnings, and all paid transactions.
 */
export type GetDesignerTotalEarningsResponse = {
  __typename?: 'GetDesignerTotalEarningsResponse';
  /** Error details should the request fail */
  error?: Maybe<ErrorGrowth>;
  /**
   * Total lifetime earnings in dollars, rounded to 2 decimal places.
   * Sum of wallet balance + legacy earnings + all paid transactions.
   */
  totalEarnings: Scalars['Float']['output'];
};

export type GetDesignerVerificationStatusInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type GetDesignerVerificationStatusResponse = {
  __typename?: 'GetDesignerVerificationStatusResponse';
  error?: Maybe<ErrorGrowth>;
  requestDate: Scalars['DateTime']['output'];
  status: DesignerVerificationStatus;
};

/**
 * Response for retrieving a designer's wallet information.
 * Includes current wallet balance and unsynced earnings from Silhouette.
 */
export type GetDesignerWalletResponse = {
  __typename?: 'GetDesignerWalletResponse';
  /** Error details should the request fail */
  error?: Maybe<ErrorGrowth>;
  /**
   * Unsynced earnings from Silhouette in dollars, rounded to 2 decimal places.
   * Earnings not yet reflected in the main wallet balance.
   */
  unsyncedEarnings: Scalars['Float']['output'];
  /**
   * Current wallet balance in dollars, rounded to 2 decimal places.
   * Represents funds available for withdrawal.
   */
  walletBalance: Scalars['Float']['output'];
};

export type GetDesignersPreviewInfoInput = {
  ids: Scalars['String']['input'];
};

export type GetDesignersPreviewInfoResponse = {
  __typename?: 'GetDesignersPreviewInfoResponse';
  designers?: Maybe<Array<DesignerPreviewInfo>>;
  error?: Maybe<ErrorGrowth>;
};

export type GetFreebiesPageDataInput = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GetFreebiesPageDataResponse = {
  __typename?: 'GetFreebiesPageDataResponse';
  error?: Maybe<ErrorGrowth>;
  pageData?: Maybe<FreebiesPageData>;
};

export type GetMyAccountBillingDetailsResponse = {
  __typename?: 'GetMyAccountBillingDetailsResponse';
  error?: Maybe<ErrorGrowth>;
  stripePortalUrl: Scalars['String']['output'];
};

export type GetMyAccountEditEmailPasswordContextResponse = {
  __typename?: 'GetMyAccountEditEmailPasswordContextResponse';
  error?: Maybe<ErrorGrowth>;
  hasLinkedAccount: Scalars['Boolean']['output'];
  /** @deprecated use editMyAccountEmailPassword mutation instead */
  nonce: Scalars['String']['output'];
  socialAccountsUrl: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

export type GetMyAccountProfileSettingsResponse = {
  __typename?: 'GetMyAccountProfileSettingsResponse';
  error?: Maybe<ErrorGrowth>;
  settings?: Maybe<MyAccountProfileSettings>;
};

export type GetMyAccountUserDobResponse = {
  __typename?: 'GetMyAccountUserDobResponse';
  dob: Scalars['String']['output'];
  error?: Maybe<ErrorGrowth>;
};

export type GetMyAccountUserProfileResponse = {
  __typename?: 'GetMyAccountUserProfileResponse';
  error?: Maybe<ErrorGrowth>;
  profile?: Maybe<MyAccountUserProfile>;
};

export type GetProductTagsInput = {
  language?: InputMaybe<Language>;
  productId: Scalars['Int']['input'];
};

export type GetRedeemRewardInput = {
  code: Scalars['String']['input'];
  provider: RedeemProvider;
};

export type GetUserSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export type GetUserSubscriptionResponse = {
  __typename?: 'GetUserSubscriptionResponse';
  error?: Maybe<ErrorGrowth>;
  subscription?: Maybe<CfSubscription>;
};

export type HalloweenSubscriptionPurchase = {
  __typename?: 'HalloweenSubscriptionPurchase';
  bundlePart1?: Maybe<Scalars['String']['output']>;
  bundlePart2?: Maybe<Scalars['String']['output']>;
  bundlePart3?: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
};

export type HealthCheckResponse = {
  __typename?: 'HealthCheckResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type HealthZResponse = {
  __typename?: 'HealthZResponse';
  timestamp: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export enum HelpChannel {
  Studio = 'studio'
}

export type HelpConversation = {
  __typename?: 'HelpConversation';
  id: Scalars['ID']['output'];
  messages: Array<HelpMessage>;
};

export type HelpMessage = {
  __typename?: 'HelpMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rate: HelpMessageRate;
  sender: HelpMessageSender;
  type: HelpMessageType;
};

export enum HelpMessageRate {
  Negative = 'negative',
  Positive = 'positive',
  Unspecified = 'unspecified'
}

export enum HelpMessageSender {
  Bot = 'bot',
  User = 'user'
}

export enum HelpMessageType {
  Audio = 'audio',
  Error = 'error',
  File = 'file',
  ForbiddenTopic = 'forbiddenTopic',
  Image = 'image',
  NegativeFeedback = 'negativeFeedback',
  NegativeSentiment = 'negativeSentiment',
  PositiveFeedback = 'positiveFeedback',
  ProposedReply = 'proposedReply',
  Text = 'text',
  Update = 'update',
  Video = 'video'
}

export type Image = {
  __typename?: 'Image';
  height?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImageAsset = {
  __typename?: 'ImageAsset';
  id: Scalars['ID']['output'];
  optimizedUrl?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ImageAssetInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  optimizedUrl?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export enum ImageReaction {
  Like = 'Like'
}

export type IncreaseDownloadCountInput = {
  productId: Scalars['ID']['input'];
};

export type IncreaseDownloadCountResponse = {
  __typename?: 'IncreaseDownloadCountResponse';
  errors: Array<ErrorMessage>;
  success: Scalars['Boolean']['output'];
};

export type InvalidateAuthCacheInput = {
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type InvalidateAuthCacheResponse = {
  __typename?: 'InvalidateAuthCacheResponse';
  accepted: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
};

export enum InvitationStatus {
  Accepted = 'Accepted',
  AlreadyInvited = 'AlreadyInvited',
  AwaitingAdminApproval = 'AwaitingAdminApproval',
  Invited = 'Invited',
  Unknown = 'Unknown'
}

export type InvitedTeamMember = {
  __typename?: 'InvitedTeamMember';
  email: Scalars['String']['output'];
  invitationId: Scalars['String']['output'];
  role: Role;
};

export enum InvoiceCompensationType {
  CoinsFree = 'COINS_FREE',
  FullRefund = 'FULL_REFUND',
  PartialRefund = 'PARTIAL_REFUND',
  YearFree = 'YEAR_FREE'
}

export type InvoicePayload = {
  __typename?: 'InvoicePayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
  hostedUrl: Scalars['String']['output'];
  isExtensionInProgress: Scalars['Boolean']['output'];
  paymentIntent?: Maybe<PaymentIntentPayload>;
};

export enum InvoiceStatus {
  InvoiceStatusDraft = 'INVOICE_STATUS_DRAFT',
  InvoiceStatusOpen = 'INVOICE_STATUS_OPEN',
  InvoiceStatusPaid = 'INVOICE_STATUS_PAID',
  InvoiceStatusUncollectible = 'INVOICE_STATUS_UNCOLLECTIBLE',
  InvoiceStatusUnspecified = 'INVOICE_STATUS_UNSPECIFIED',
  InvoiceStatusVoid = 'INVOICE_STATUS_VOID'
}

export type IsPropertyEnabled = {
  __typename?: 'IsPropertyEnabled';
  enabled: Scalars['Boolean']['output'];
};

export type IsPropertyEnabledInput = {
  property: Scalars['String']['input'];
};

export type IsSubscribedToDigestInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type IsSubscribedToDigestResponse = {
  __typename?: 'IsSubscribedToDigestResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  isSubscribed: Scalars['Boolean']['output'];
};

export type IsUploadAllowedRequest = {
  size: Scalars['Int']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type IsUploadAllowedResponse = {
  __typename?: 'IsUploadAllowedResponse';
  allowed: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
};

export type IsUserBlocklisted = {
  __typename?: 'IsUserBlocklisted';
  extensionPopup: Scalars['Boolean']['output'];
};

export enum IterationRating {
  Disliked = 'Disliked',
  Liked = 'Liked',
  Unspecified = 'Unspecified'
}

export enum JwtAuthOrigin {
  Login = 'LOGIN',
  Registration = 'REGISTRATION'
}

export type JwtAuthOutcomeInput = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  origin: JwtAuthOrigin;
  result: JwtAuthResult;
};

export type JwtAuthOutcomeResponse = {
  __typename?: 'JwtAuthOutcomeResponse';
  accepted: Scalars['Boolean']['output'];
};

export enum JwtAuthResult {
  Blocked = 'BLOCKED',
  HttpError = 'HTTP_ERROR',
  NetworkError = 'NETWORK_ERROR',
  Ok = 'OK',
  RetryExhausted = 'RETRY_EXHAUSTED',
  SkippedDomain = 'SKIPPED_DOMAIN'
}

export type KeyValuePairs = {
  __typename?: 'KeyValuePairs';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum Language {
  Az = 'az',
  Bg = 'bg',
  Bn = 'bn',
  Cs = 'cs',
  Da = 'da',
  De = 'de',
  El = 'el',
  En = 'en',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fil = 'fil',
  Fr = 'fr',
  Gu = 'gu',
  Hi = 'hi',
  Hr = 'hr',
  Hu = 'hu',
  Id = 'id',
  It = 'it',
  Ja = 'ja',
  Ka = 'ka',
  Kk = 'kk',
  Kn = 'kn',
  Ko = 'ko',
  Lt = 'lt',
  Lv = 'lv',
  Ml = 'ml',
  Mn = 'mn',
  Mr = 'mr',
  Ms = 'ms',
  Nl = 'nl',
  No = 'no',
  Pa = 'pa',
  Pl = 'pl',
  Pt = 'pt',
  Ro = 'ro',
  Ru = 'ru',
  Sk = 'sk',
  Sr = 'sr',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Te = 'te',
  Th = 'th',
  Tr = 'tr',
  Uk = 'uk',
  Uz = 'uz',
  Vi = 'vi',
  ZhHans = 'zh_Hans',
  ZhHant = 'zh_Hant'
}

export type LegacyAuthor = {
  __typename?: 'LegacyAuthor';
  avatar?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LegacyCategory = {
  __typename?: 'LegacyCategory';
  id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LegacyCustomMeta = {
  __typename?: 'LegacyCustomMeta';
  craftsCharacteristic: Scalars['String']['output'];
  fontCharacteristic: Scalars['String']['output'];
  graphicCharacteristic: Scalars['String']['output'];
  isCoinRewardBundle: Scalars['Boolean']['output'];
};

export type LegacyLicense = {
  __typename?: 'LegacyLicense';
  DateCreated?: Maybe<Scalars['Time']['output']>;
  Email: Scalars['String']['output'];
  FirstName: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  LastName: Scalars['String']['output'];
  LicenseKey: Scalars['String']['output'];
  OrderID: Scalars['Int']['output'];
  ProductID: Scalars['Int']['output'];
  SubscriptionID: Scalars['Int']['output'];
  UserID: Scalars['Int']['output'];
};

export type LegacyListUserFavoritesInput = {
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LegacyPpeMeta = {
  __typename?: 'LegacyPPEMeta';
  limit: Scalars['Int']['output'];
  nextOffset: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  orderBy?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type LegacyPpeResponse = {
  __typename?: 'LegacyPPEResponse';
  meta: LegacyPpeMeta;
  products: Array<LegacyProduct>;
};

export type LegacyProduct = {
  __typename?: 'LegacyProduct';
  author: LegacyAuthor;
  customMeta?: Maybe<LegacyCustomMeta>;
  description: Scalars['String']['output'];
  favoriteCount: Scalars['Int']['output'];
  favoriteDate?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isSkipTrial?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<LegacyLicense>;
  productMainCategory?: Maybe<LegacyCategory>;
  productSubCategory?: Maybe<LegacyCategory>;
  rating: Scalars['Float']['output'];
  regularPrice: Scalars['Float']['output'];
  reviewCount: Scalars['Int']['output'];
  salePrice: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  sparkType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
  thumbnail?: Maybe<Array<Scalars['String']['output']>>;
  thumbnailGallery?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  visibility?: Maybe<Scalars['String']['output']>;
};

export type LegacyProductsListPpeProductsInput = {
  categories?: InputMaybe<Array<Category>>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkedProfile = {
  __typename?: 'LinkedProfile';
  account: Scalars['String']['output'];
  loginTimestamp: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerTitle: Scalars['String']['output'];
  unlinkUrl: Scalars['String']['output'];
};

export type ListAccountNoticesResponse = {
  __typename?: 'ListAccountNoticesResponse';
  error?: Maybe<ErrorGrowth>;
  notices: Array<MyAccountNotice>;
};

export type ListCraftMachinesForUserInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CraftMachineOrderBy>;
  orderDirection?: InputMaybe<SortOrder>;
  pageDirection?: InputMaybe<PageDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  userID: Scalars['Int']['input'];
};

export type ListCraftMachinesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CraftMachineOrderBy>;
  orderDirection?: InputMaybe<SortOrder>;
  pageDirection?: InputMaybe<PageDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListCraftMaterialsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CraftMaterialOrderBy>;
  orderDirection?: InputMaybe<SortOrder>;
  pageDirection?: InputMaybe<CfMainPageDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListCraftThemesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CraftThemeOrderBy>;
  orderDirection?: InputMaybe<SortOrder>;
  pageDirection?: InputMaybe<CfMainPageDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListCraftingTypesForUserInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CraftingTypeOrderBy>;
  orderDirection?: InputMaybe<SortOrder>;
  pageDirection?: InputMaybe<CfMainPageDirection>;
  search?: InputMaybe<Scalars['String']['input']>;
  userID: Scalars['Int']['input'];
};

export type ListDailyGiftsResponse = {
  __typename?: 'ListDailyGiftsResponse';
  dailyGifts: Array<DailyGifts>;
  error?: Maybe<ErrorGrowth>;
  facebookShareUrl: Scalars['String']['output'];
  freeBundleId: Scalars['Int']['output'];
  freeBundleUrl: Scalars['String']['output'];
};

export type ListMyAccountDownloadsLicKeysInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ListMyAccountDownloadsLicKeysResponse = {
  __typename?: 'ListMyAccountDownloadsLicKeysResponse';
  downloads?: Maybe<Array<Maybe<MyAccountDownload>>>;
  error?: Maybe<ErrorGrowth>;
  exportLicenseKeysNonce: Scalars['String']['output'];
  hasLicenseKeyDownloadAccess: Scalars['Boolean']['output'];
  itemsPerPage: Scalars['Int']['output'];
  keysAreBeingGenerated: Scalars['Boolean']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ListMyAccountNotificationSettingsResponse = {
  __typename?: 'ListMyAccountNotificationSettingsResponse';
  error?: Maybe<ErrorGrowth>;
  newsletterNotificationSettings: Array<MyAccountNotificationSettings>;
  notificationSettings: Array<MyAccountNotificationSettings>;
};

export type ListMyClassesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ListMyClassesResponse = {
  __typename?: 'ListMyClassesResponse';
  classes?: Maybe<Array<Class>>;
  error?: Maybe<ErrorGrowth>;
  itemsPerPage: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ListRedeemedCodesInput = {
  provider: RedeemProvider;
};

export type ListSocialLoginAccountsResponse = {
  __typename?: 'ListSocialLoginAccountsResponse';
  error?: Maybe<ErrorGrowth>;
  linkedProfiles: Array<LinkedProfile>;
  socialProviders: Array<SocialProvider>;
};

export type ListTransfersInput = {
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sort: TransferSort;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListTransfersResponse = {
  __typename?: 'ListTransfersResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination: ProjectListPagination;
  transfers?: Maybe<Array<Transfer>>;
};

export type ListUserActivityInput = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ListUserActivityResponse = {
  __typename?: 'ListUserActivityResponse';
  error?: Maybe<ErrorGrowth>;
  items: Array<ActivityItem>;
  pagination: ActivityPagination;
};

export type ListUserOrdersInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ListUserOrdersResponse = {
  __typename?: 'ListUserOrdersResponse';
  error?: Maybe<ErrorGrowth>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  orders: Array<CfOrder>;
};

export type ListUserSubscriptionsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ListUserSubscriptionsResponse = {
  __typename?: 'ListUserSubscriptionsResponse';
  error?: Maybe<ErrorGrowth>;
  subscriptions: Array<CfSubscription>;
};

export type LocalizedStrings = {
  __typename?: 'LocalizedStrings';
  de?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  it?: Maybe<Scalars['String']['output']>;
  nl?: Maybe<Scalars['String']['output']>;
  pl?: Maybe<Scalars['String']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
};

export type LoginInput = {
  deviceId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  otp?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  remember?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  challenge?: Maybe<AuthChallenge>;
  errors?: Maybe<Array<ErrorMessage>>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  logout?: Maybe<StatusMessage>;
};

export type LostPasswordInput = {
  email: Scalars['String']['input'];
  /**
   * Product that requested the reset. Omitted requests keep the Creative Fabrica
   * email and the creativefabrica.com link. Studio and Idea.ai requests send an
   * Idea.ai email.
   */
  origin?: InputMaybe<LostPasswordOrigin>;
  /**
   * Page the reset link should return to. Only the host is used, and only when
   * it is on the allowlist. The link path is /reset-password.
   */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum LostPasswordOrigin {
  CreativeFabrica = 'CREATIVE_FABRICA',
  Idea = 'IDEA',
  Studio = 'STUDIO',
  Team = 'TEAM'
}

export type LostPasswordResponse = {
  __typename?: 'LostPasswordResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type Machine = {
  __typename?: 'Machine';
  brand: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MarketPlaceTagPageRelatedTagsItem = {
  __typename?: 'MarketPlaceTagPageRelatedTagsItem';
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MarketPlaceTagPageTagItem = {
  __typename?: 'MarketPlaceTagPageTagItem';
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MarketplaceArticle = {
  __typename?: 'MarketplaceArticle';
  image: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MarketplaceCategoryPageBreadcrumbItem = {
  __typename?: 'MarketplaceCategoryPageBreadcrumbItem';
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MarketplaceCategoryPageContent = {
  __typename?: 'MarketplaceCategoryPageContent';
  description: Scalars['String']['output'];
  faq: Array<MarketplaceCategoryPageFaqItem>;
  footer: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MarketplaceCategoryPageData = {
  __typename?: 'MarketplaceCategoryPageData';
  articles: Array<MarketplaceArticle>;
  breadcrumb: Array<MarketplaceCategoryPageBreadcrumbItem>;
  linkBlocks: Array<ContentLinkBlock>;
  pageContent?: Maybe<MarketplaceCategoryPageContent>;
  relatedCategories: Array<MarketplaceCategoryPageRelatedCategoriesItem>;
  seo?: Maybe<MarketplaceCategoryPageSeo>;
};

export type MarketplaceCategoryPageFaqItem = {
  __typename?: 'MarketplaceCategoryPageFaqItem';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type MarketplaceCategoryPageRelatedCategoriesItem = {
  __typename?: 'MarketplaceCategoryPageRelatedCategoriesItem';
  childCategories: Array<MarketplaceCategoryPageRelatedCategoriesItem>;
  image: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MarketplaceCategoryPageSeo = {
  __typename?: 'MarketplaceCategoryPageSeo';
  canonicalUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MarketplaceImageItem = {
  __typename?: 'MarketplaceImageItem';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type MarketplaceImageSizes = {
  __typename?: 'MarketplaceImageSizes';
  mainImage?: Maybe<MarketplaceImageItem>;
  shopSingle?: Maybe<MarketplaceImageItem>;
  woocommerceSingle?: Maybe<MarketplaceImageItem>;
  woocommerceThumbnail?: Maybe<MarketplaceImageItem>;
};

export enum MarketplaceLanguage {
  LanguageDe = 'LANGUAGE_DE',
  LanguageEn = 'LANGUAGE_EN',
  LanguageEs = 'LANGUAGE_ES',
  LanguageFr = 'LANGUAGE_FR',
  LanguageIt = 'LANGUAGE_IT',
  LanguageNl = 'LANGUAGE_NL',
  LanguagePl = 'LANGUAGE_PL',
  LanguagePt = 'LANGUAGE_PT'
}

export type MarketplaceListProductsInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  legacyCategoryId?: InputMaybe<Scalars['Int']['input']>;
  legacyTagId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<MarketplaceLanguage>;
  pagination: MarketplacePaginationRequest;
  sortType: MarketplaceProductSortOrder;
  tagId?: InputMaybe<Scalars['String']['input']>;
  tagSlug?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceListProductsResponse = {
  __typename?: 'MarketplaceListProductsResponse';
  categoryPageData?: Maybe<MarketplaceCategoryPageData>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<MarketplacePagination>;
  products?: Maybe<Array<MarketplaceProduct>>;
  tagPageData?: Maybe<MarketplaceTagPageData>;
};

export type MarketplaceListPromoProductsInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  legacyCategoryId?: InputMaybe<Scalars['Int']['input']>;
  legacyTagId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<MarketplaceLanguage>;
  pagination: MarketplacePaginationRequest;
  promoType: MarketplacePromoType;
  sortType: MarketplaceProductSortOrder;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceListPromoProductsResponse = {
  __typename?: 'MarketplaceListPromoProductsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<MarketplacePagination>;
  products?: Maybe<Array<MarketplaceProduct>>;
};

export type MarketplacePagination = {
  __typename?: 'MarketplacePagination';
  currentPage: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type MarketplacePaginationRequest = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type MarketplaceProduct = {
  __typename?: 'MarketplaceProduct';
  cardCategory: Scalars['String']['output'];
  categoriesDetails?: Maybe<Array<Maybe<ProductCategoryDetails>>>;
  designer: MarketplaceProductDesigner;
  legacyProductId: Scalars['Int']['output'];
  mainImageSizes?: Maybe<MarketplaceImageSizes>;
  productCountdown: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  productImage: Scalars['String']['output'];
  productTitle: Scalars['String']['output'];
  productUrl: Scalars['String']['output'];
};

export type MarketplaceProductDesigner = {
  __typename?: 'MarketplaceProductDesigner';
  designerId: Scalars['Int']['output'];
};

export enum MarketplaceProductSortOrder {
  ProductSortOrderMostPopular = 'PRODUCT_SORT_ORDER_MOST_POPULAR',
  ProductSortOrderMostRecent = 'PRODUCT_SORT_ORDER_MOST_RECENT',
  ProductSortOrderUnspecified = 'PRODUCT_SORT_ORDER_UNSPECIFIED'
}

export enum MarketplacePromoType {
  PromoTypeDailyGift = 'PROMO_TYPE_DAILY_GIFT',
  PromoTypeFreebie = 'PROMO_TYPE_FREEBIE',
  PromoTypeUnspecified = 'PROMO_TYPE_UNSPECIFIED'
}

export type MarketplaceTagPageContent = {
  __typename?: 'MarketplaceTagPageContent';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MarketplaceTagPageData = {
  __typename?: 'MarketplaceTagPageData';
  extraContent?: Maybe<MarketplaceTagPageExtraContent>;
  pageContent?: Maybe<MarketplaceTagPageContent>;
  randomizedTags?: Maybe<Array<MarketPlaceTagPageTagItem>>;
  relatedTags?: Maybe<Array<MarketPlaceTagPageRelatedTagsItem>>;
  seo?: Maybe<MarketplaceTagPageSeo>;
};

export type MarketplaceTagPageExtraContent = {
  __typename?: 'MarketplaceTagPageExtraContent';
  dailyGiftImageUrl: Scalars['String']['output'];
  fontsImageUrl: Scalars['String']['output'];
  freeFontImageUrl: Scalars['String']['output'];
  freeFontUrl: Scalars['String']['output'];
};

export type MarketplaceTagPageSeo = {
  __typename?: 'MarketplaceTagPageSeo';
  canonicalUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MembersListInput = {
  clubhouseSlug: Scalars['String']['input'];
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sortBy?: InputMaybe<ClubhousesMemberSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type MembersListResponse = {
  __typename?: 'MembersListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  lastAddedMembers: Scalars['Int']['output'];
  members?: Maybe<Array<PublicUserProfile>>;
  pagination?: Maybe<ClubhousesListPagination>;
  totalMembers: Scalars['Int']['output'];
};

export type MonthlyAction = {
  __typename?: 'MonthlyAction';
  actionDate?: Maybe<Scalars['String']['output']>;
  campaign_id: Scalars['String']['output'];
  clickCount?: Maybe<Scalars['Int']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Add a note to a product.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  addAdminProductNote: AddAdminProductNoteResponse;
  advertisingCreateCampaign: AdvertisingCreateCampaignResponse;
  advertisingDeleteCampaign: AdvertisingDeleteCampaignResponse;
  advertisingIncreaseClickForCampaign: AdvertisingIncreaseClickForCampaignResponse;
  advertisingIncreaseViewForCampaign: AdvertisingIncreaseViewForCampaignResponse;
  advertisingUpdateCampaign: AdvertisingUpdateCampaignResponse;
  advertisingUploadsCreateSignedUrl: AdvertisingUploadsCreateSignedUrlResponse;
  askCFConfirmQuestion: AskCfConfirmQuestionResponse;
  askCFConfirmTopic: AskCfConfirmTopicResponse;
  askCFCreateSignedUploadUrlV2: AskCfCreateSignedUploadUrlV2Response;
  askCFDeleteAnswer: AskCfDeleteAnswerResponse;
  askCFDeleteAnswersFromUser: AskCfDeleteAnswersFromUserResponse;
  askCFDeleteQuestion: AskCfDeleteQuestionResponse;
  askCFDeleteQuestionsFromUser: AskCfDeleteQuestionsFromUserResponse;
  askCFDeleteTopic: AskCfTopicDeleteResponse;
  askCFDiscardQuestion: AskCfDiscardQuestionResponse;
  askCFDislikeAnswer: AskCfDislikeAnswerResponse;
  askCFDislikeComment: AskCfDislikeCommentResponse;
  askCFFollowQuestion: AskCfFollowQuestionResponse;
  askCFGiveTipToAnswer: AskCfGiveTipToAnswerResponse;
  askCFLikeAnswer: AskCfLikeAnswerResponse;
  askCFLikeComment: AskCfLikeCommentResponse;
  askCFPostAnswer: AskCfPostAnswerResponse;
  askCFPostComment: AskCfPostCommentResponse;
  askCFPostQuestion: AskCfPostQuestionResponse;
  askCFSetBestAnswer: AskCfSetBestAnswerResponse;
  askCFUnfollowQuestion: AskCfUnfollowQuestionResponse;
  /** @deprecated Use askCFUploadsCreateSignedUrlV2 instead */
  askCFUploadsCreateSignedUrl: AskCfUploadCreateSignedUrlResponse;
  askCFUserDigestSubscribe: AskCfUserDigestSubscribeResponse;
  askCFUserDigestUnsubscribe: AskCfUserDigestUnsubscribeResponse;
  cancelSubscription: CancelSubscriptionResponse;
  cfmainCreateEnterpriseRequest: CfMainEnterpriseRequestResponse;
  cfmainUpdateEnterpriseRequest: CfMainUpdateEnterpriseRequestResponse;
  /**
   * Change download file URLs for a product.
   * Requires authentication and dashboard_access capability.
   */
  changeAdminProductFileUrl: ChangeAdminProductFileUrlResponse;
  clubhousesAcceptInvite: ClubhouseAcceptInviteResponse;
  clubhousesAdminUploadsCreateSignedUrl: ClubhousesAdminUploadCreateSignedUrlResponse;
  clubhousesCreateCommunityLeader: ClubhousesCreateCommunityLeaderResponse;
  clubhousesCreateDiscussion: ClubhousesCreateDiscussionResponse;
  clubhousesCreateDiscussionReply: ClubhousesCreateDiscussionReplyResponse;
  clubhousesCreateSignedUploadUrlV2: ClubhousesCreateSignedUploadUrlV2Response;
  clubhousesDeleteDiscussion: ClubhousesDeleteDiscussionResponse;
  clubhousesDeleteDiscussionReply: ClubhousesDeleteDiscussionReplyResponse;
  clubhousesDiscussionNotificationUpdate: ClubhousesDiscussionNotificationUpdateResponse;
  clubhousesEditDiscussion: ClubhousesEditDiscussionResponse;
  clubhousesEditDiscussionReply: ClubhousesEditDiscussionReplyResponse;
  /** Private schema for generating Clubhouse digests. */
  clubhousesGenerateDigest: ClubhousesGenerateDigestResponse;
  clubhousesGiveTipToDiscussion: ClubhousesGiveTipToDiscussionResponse;
  clubhousesInvite: ClubhouseInviteResponse;
  clubhousesJoin: ClubhouseJoinResponse;
  clubhousesLeave: ClubhouseLeaveResponse;
  clubhousesLikeReply: ClubhousesLikeReplyResponse;
  clubhousesReactToDiscussion: ClubhousesReactToDiscussionResponse;
  clubhousesRemoveLikeReply: ClubhousesRemoveLikeReplyResponse;
  /** @deprecated Use clubhousesUpdateDigestPreference instead */
  clubhousesSubscribeToDigest: SubscribeToClubhouseDigestResponse;
  /** @deprecated Use clubhousesUpdateDigestPreference instead */
  clubhousesUnsubscribeToDigest: UnsubscribeToClubhouseDigestResponse;
  clubhousesUpdateDigestPreference: ClubhouseUpdateDigestPreferenceResponse;
  clubhousesUpdateNotificationSettings: ClubhouseUpdateNotificationSettingsResponse;
  /** @deprecated Use clubhousesUploadsCreateSignedUrlV2 instead */
  clubhousesUploadsCreateSignedUrl: ClubhousesUploadCreateSignedUrlResponse;
  clubhousesViewDiscussion: ClubhousesViewDiscussionResponse;
  coinsEntityTip: CoinsEntityTipResponse;
  coinsGiveTip: CoinsGiveTipResponse;
  coinsSpendOnProduct: CoinsSpendResponse;
  coinsUpdateTransactionStatus: UpdateCoinTransactionStatusResponse;
  confirmMyAccountEmailReset: ConfirmMyAccountEmailResetResponse;
  contentCreateFavoriteList: Scalars['String']['output'];
  contentCreateReview: Scalars['Boolean']['output'];
  contentDeleteFavoriteList: Scalars['Boolean']['output'];
  contentDeleteReview: Scalars['Boolean']['output'];
  contentEditReview: Scalars['Boolean']['output'];
  contentFavoriteProduct: Scalars['Boolean']['output'];
  contentIncreaseDownloadCount: Scalars['Boolean']['output'];
  contentRegisterProductDownload: ContentRegisterProductDownloadResponse;
  contentUnfavoriteProduct: Scalars['Boolean']['output'];
  contentUpdateFavorite: Scalars['Boolean']['output'];
  contentUpdateFavoriteList: Scalars['Boolean']['output'];
  /** @deprecated Use flowCreateDownloadUrl */
  createDownloadUrl: Scalars['String']['output'];
  /** @deprecated Use flowCreate */
  createFlow: Flow;
  /** @deprecated Use flowCreateIterationPage */
  createFlowIterationPage: FlowIterationPage;
  /** @deprecated Use flowCreateUploadUrl */
  createUploadUrl: Scalars['String']['output'];
  deactivateAccount?: Maybe<DeactivateAccountResponse>;
  /**
   * Delete a product note.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  deleteAdminProductNote: DeleteAdminProductNoteResponse;
  /** @deprecated Use flowDeleteAll */
  deleteAllFlows: Scalars['Boolean']['output'];
  deleteCraftMaterial?: Maybe<CraftMaterialDeleteResponse>;
  deleteCraftTheme?: Maybe<CraftThemeDeleteResponse>;
  /** @deprecated Use flowDelete */
  deleteFlow: Scalars['Boolean']['output'];
  deleteUserAccount: DeleteUserAccountResponse;
  deleteUserAvatar: DeleteUserAvatarResponse;
  designReviewerCancelReview: DesignReviewerCancelReviewRequestResponse;
  designReviewerDeleteAllReview: DesignReviewerDeleteAllReviewResponse;
  designReviewerDeleteReview: DesignReviewerDeleteReviewResponse;
  designReviewerUploadsCreateSignedUrl: DesignReviewerUploadsCreateSignedUrlResponse;
  /**
   * Edit a product note.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  editAdminProductNote: EditAdminProductNoteResponse;
  editMyAccountEmailPassword: EditMyAccountEmailPasswordResponse;
  editUserProfile: EditUserProfileResponse;
  entityDownload: EntityDownloadResponse;
  entityLove: EntityLoveResponse;
  entityReact: EntityReactResponse;
  entityReactDelete: EntityReactDeleteResponse;
  flowCancelIterationPage: FlowCancelIterationPageResponse;
  flowCreate: Flow;
  flowCreateDownloadUrl: Scalars['String']['output'];
  flowCreateIterationPage: FlowIterationPage;
  flowCreateUploadUrl: Scalars['String']['output'];
  flowDelete: Scalars['Boolean']['output'];
  flowDeleteAll: Scalars['Boolean']['output'];
  flowGiveTip: Scalars['Boolean']['output'];
  flowImageReact: FlowImageReactResponse;
  flowImageRemoveReact: FlowImageRemoveReactResponse;
  flowImageReport: FlowImageReportResponse;
  /** @deprecated Use flowIterationPageRate instead */
  flowIterationRate: FlowIterationRateResponse;
  flowLike: Scalars['Boolean']['output'];
  flowPublishImage: FlowPublishImageResponse;
  flowRateIterationPage: FlowRateIterationPageResponse;
  flowUpdate: Flow;
  flowUpdateVisibility: Flow;
  flowView: Scalars['Int']['output'];
  /** @deprecated Use userFollow */
  followUser: Scalars['Boolean']['output'];
  /** @deprecated use fontGeneratorUserFontCreate */
  fontGeneratorFontCreate: FontGeneratorFontCreateResponse;
  /** @deprecated use fontGeneratorUserFontPack */
  fontGeneratorFontDownload: FontGeneratorFontDownloadResponse;
  /** @deprecated use fontGeneratorUserFontUpdate */
  fontGeneratorFontUpdate: FontGeneratorFontUpdateResponse;
  fontGeneratorSymbolAccept: FontGeneratorAcceptSymbolResponse;
  fontGeneratorSymbolCancel: FontGeneratorCancelSymbolResponse;
  fontGeneratorSymbolGenerate: FontGeneratorSymbolGenerateResponse;
  fontGeneratorUserFontCreate: FontGeneratorUserFontCreateResponse;
  fontGeneratorUserFontDelete: FontGeneratorUserFontDeleteResponse;
  fontGeneratorUserFontDeleteAll: FontGeneratorUserFontDeleteAllResponse;
  fontGeneratorUserFontPack: FontGeneratorUserFontPackResponse;
  fontGeneratorUserFontUpdate: FontGeneratorUserFontUpdateResponse;
  /** @deprecated use fontGeneratorUserFontDelete */
  generatedFontsDelete: GeneratedFontsDeleteResponse;
  /** @deprecated use generatedFontsDeleteAllForUser */
  generatedFontsDeleteAllForUser: GeneratedFontsDeleteAllForUserResponse;
  /** @deprecated Use method flowGiveTip for Flow tips and coinGiveTip for coin tips */
  giveTip: Scalars['Boolean']['output'];
  helpRateMessage?: Maybe<HelpMessage>;
  helpSendMessage?: Maybe<HelpConversation>;
  invalidateAuthCache?: Maybe<InvalidateAuthCacheResponse>;
  /** @deprecated Use flowLike */
  likeFlow: Scalars['Boolean']['output'];
  login?: Maybe<LoginResponse>;
  loginWithSocial?: Maybe<AuthResponse>;
  loginWithSocialRedirect?: Maybe<SocialRedirectLoginResponse>;
  logout?: Maybe<LogoutResponse>;
  lostPassword?: Maybe<LostPasswordResponse>;
  paymentsActivateTrial: ActivateTrialResponse;
  paymentsAutoStartSubscription: PaymentsAutoStartSubscriptionResponse;
  paymentsAutoStartTrial: PaymentsAutoStartTrialResult;
  paymentsBuildPaymentDataForSubscription: BuildPaymentDataForSubscriptionResult;
  paymentsBuildPaymentForSubscription: Payment;
  paymentsBuyCoins: PaymentsBuyCoinsResult;
  paymentsChangeSubscriptionPlan: PaymentsChangeSubscriptionPlanResponse;
  paymentsCompensateInvoice: PaymentsCompensateInvoiceResponse;
  paymentsCreateSetupIntent: CreateSetupIntentResponse;
  paymentsExtendSubscription: ExtendSubscriptionResult;
  paymentsExtendSubscriptionToPlan: ExtendSubscriptionToPlanResponse;
  paymentsExtendTrial: PaymentsExtendTrialResponse;
  paymentsSubmitSubscriptionCheckout: SubmitSubscriptionCheckoutResponse;
  paymentsUpdateCustomer: UpdateCustomerResponse;
  paymentsUpgradeSubscription: UpgradeSubscriptionResult;
  physicalProductOpenOrderDelete: PhysicalProductOpenOrderDeleteResponse;
  physicalProductOpenOrderShippingDetailUpdate: PhysicalProductOpenOrderShippingDetailUpdateResponse;
  physicalProductOrderCreate: PhysicalProductOrderCreateResponse;
  printOnDemandCreateOrUpdateShippingAddress: PrintOnDemandShippingAddressCreateOrUpdateResponse;
  publishImage: Scalars['Boolean']['output'];
  publishedTemplatesAddFavorite: PublishedTemplatesAddFavoriteResponse;
  publishedTemplatesRemoveFavorite: PublishedTemplatesRemoveFavoriteResponse;
  publisherCreateTemplateSubmission: PublisherCreateTemplateSubmissionResponse;
  publisherDeleteTemplateSubmission: PublisherDeleteTemplateSubmissionResponse;
  publisherFinaliseTemplateSubmission: PublisherFinaliseTemplateSubmissionResponse;
  publisherRegenerateTemplateSubmissionFields: PublisherRegenerateTemplateSubmissionFieldsResponse;
  publisherUploadsCreateSignedUrl: PublisherUploadsCreateSignedUrlResponse;
  redeemCode: Scalars['Boolean']['output'];
  refreshToken?: Maybe<RefreshTokenResponse>;
  register?: Maybe<RegisterResponse>;
  /**
   * Remove a product from the marketplace.
   * Requires authentication and dashboard_remove capability.
   */
  removeAdminProduct: RemoveAdminProductResponse;
  reportJwtAuthOutcome?: Maybe<JwtAuthOutcomeResponse>;
  resetMyAccountEmail: ResetMyAccountEmailResponse;
  resetPassword?: Maybe<ResetPasswordResponse>;
  saveMyAccountNotificationSettings: SaveMyAccountNotificationSettingsResponse;
  setCoreFlag: SetCoreFlagResponse;
  snippetsCreateSnippet: SnippetsCreateSnippetResponse;
  snippetsDeleteSnippet: SnippetsDeleteSnippetResponse;
  snippetsUpdateSnippet: SnippetsUpdateSnippetResponse;
  socialBlockUser: SocialBlockUserResponse;
  socialCommentDelete: SocialCommentDeleteResponse;
  socialCommentLike: SocialCommentLikeResponse;
  socialCommentLikeRemove: SocialCommentLikeRemoveResponse;
  socialCreateComment: SocialCreateCommentResponse;
  socialCreateSignedUploadUrlV2: SocialCreateSignedUploadUrlV2Response;
  socialGiveTipToPost: SocialGiveTipToPostResponse;
  socialPostClass: SocialPostResponse;
  socialPostDelete: SocialPostDeleteResponse;
  socialPostDeleteFromUser: SocialPostDeleteFromUserResponse;
  socialPostLike: SocialPostLikeResponse;
  socialPostLikeRemove: SocialPostLikeRemoveResponse;
  socialPostProject: SocialPostResponse;
  socialPostSave: SocialPostSaveResponse;
  socialPostSaveRemove: SocialPostSaveRemoveResponse;
  socialUnblockUser: SocialUnblockUserResponse;
  socialUpdateEmailNotificationsSettings: SocialUpdateEmailNotificationsSettingsResponse;
  /** @deprecated Use socialUploadsCreateSignedUrlV2 instead */
  socialUploadsCreateSignedUrl: SocialUploadCreateSignedUrlResponse;
  sparkArtDelete: SparkArtDeleteResponse;
  sparkArtGenerate: SparkArtGenerateResponse;
  sparkCrystallineDelete: SparkCrystallineDeleteResponse;
  sparkCrystallineGenerate: SparkCrystallineGenerateResponse;
  sparkImageMixDelete: SparkImageMixDeleteResponse;
  sparkImageMixDeleteAll: SparkImageMixDeleteAllResponse;
  sparkImageMixGenerate: SparkImageMixGenerateResponse;
  sparkInpaintDelete: SparkInpaintDeleteResponse;
  sparkInpaintDeleteAll: SparkInpaintDeleteAllResponse;
  sparkInpaintImage: SparkInpaintImageResponse;
  sparkOutpaintDelete: SparkOutpaintDeleteResponse;
  sparkOutpaintDeleteAll: SparkOutpaintDeleteAllResponse;
  sparkOutpaintImage: SparkOutpaintImageResponse;
  sparkRegisterAnonymousArtToUser: SparkRegisterArtResponse;
  sparkRegisterAnonymousBackgroundRemovedToUser: SparkRegisterBackgroundRemovedResponse;
  sparkRegisterAnonymousCrystallineToUser: SparkRegisterCrystallineResponse;
  sparkRegisterAnonymousImageMixToUser: SparkRegisterImageMixResponse;
  sparkRegisterAnonymousInpaintToUser: SparkRegisterInpaintResponse;
  sparkRegisterAnonymousOutpaintToUser: SparkRegisterOutpaintResponse;
  sparkRemoveBackground: SparkRemoveBackgroundResponse;
  sparkRemovedBackgroundCancel: SparkRemovedBackgroundCancelResponse;
  sparkRemovedBackgroundDelete: SparkRemovedBackgroundDeleteResponse;
  sparkRemovedBackgroundDeleteAll: SparkRemovedBackgroundDeleteAllResponse;
  sparkRemovedBackgroundPublishImage: RemoveBackgroundPublishImageResponse;
  sparkRemovedBackgroundUploadsCreateSignedUrl: SparkRemovedBackgroundUploadsCreateSignedUrlResponse;
  /** @deprecated Use uploadsCreateSignedUrlV3 instead. */
  sparkUploadsCreateSignedUrl: SparkUploadsCreateSignedUrlResponse;
  /** @deprecated use coinsSpendOnProduct */
  spendCoinsOnProduct: CoinsSpendResponse;
  statisticsRecordStudioEvent: StatisticsRecordStudioEventResponse;
  storageEnableOverages: StorageEnableOveragesResponse;
  storageUpdateSize: StorageUpdateSizeResponse;
  storeUserSearch: UserSearch;
  studioCommentReact: StudioCommentReactResponse;
  studioCommentReactDelete: StudioCommentReactDeleteResponse;
  studioProjectsAddMember: StudioProjectsAddMemberResponse;
  studioProjectsAddUserToProjectSharingLink: StudioProjectsAddUserToProjectSharingLinkResponse;
  studioProjectsApproveInvite: StudioProjectsApproveInviteResponse;
  studioProjectsApproveProjectMemberUpdate: StudioProjectsApproveProjectMemberUpdateResponse;
  studioProjectsChangeUserRole: StudioProjectsChangeUserRoleResponse;
  studioProjectsConfirmInvite: StudioProjectsConfirmInviteResponse;
  studioProjectsCreateFolder: StudioProjectCreateFolderResponse;
  studioProjectsCreateFromTemplate: StudioProjectsCreateFromTemplateResponse;
  studioProjectsCreateProject: StudioProjectsCreateProjectResponse;
  studioProjectsCreateProjectComment: StudioProjectsCreateProjectCommentResponse;
  studioProjectsCreateProjectSharingLink: StudioProjectsCreateProjectSharingLinkResponse;
  studioProjectsDeleteProject: StudioProjectDeleteProjectResponse;
  studioProjectsEmptyTrash: StudioProjectEmptyTrashResponse;
  studioProjectsFolderDelete: StudioProjectFolderDeleteResponse;
  studioProjectsFolderRename: StudioProjectsFolderRenameResponse;
  studioProjectsFolderRestore: StudioProjectsFolderRestoreResponse;
  studioProjectsMarkProjectCommentDone: StudioProjectsMarkProjectCommentDoneResponse;
  studioProjectsMoveProjects: StudioProjectMoveProjectsResponse;
  studioProjectsOptimizeProject: StudioProjectOptimizeProjectResponse;
  studioProjectsRemoveUser: StudioProjectsRemoveUserResponse;
  studioProjectsRestoreProject: StudioProjectRestoreProjectResponse;
  studioProjectsUpdateProject: StudioProjectsUpdateProjectResponse;
  studioProjectsUpdateProjectLastView: StudioProjectsUpdateProjectLastViewResponse;
  studioSimpleCommentsCreate: StudioSimpleCommentsCreateResponse;
  studioSimpleCommentsDelete: StudioSimpleCommentsDeleteResponse;
  studioSimpleCommentsEdit: StudioSimpleCommentsEditResponse;
  studioSwitchWorkspace: StudioSwitchWorkspaceResponse;
  studioTemplateDelete: StudioTemplateDeleteResponse;
  studioTemplatePublishFromProject: StudioTemplatePublishFromProjectResponse;
  studioTemplateRestore: StudioTemplateRestoreResponse;
  studioUploadsAddTagToFiles: StudioUploadsAddTagToFilesResponse;
  studioUploadsCreateFolder: StudioUploadsCreateFolderResponse;
  studioUploadsCreateSignedDownloadUrl: StudioUploadsCreateSignedDownloadUrlResponse;
  studioUploadsCreateSignedUrl: StudioUploadsCreateSignedUrlResponse;
  studioUploadsCreateTag: StudioUploadsCreateTagResponse;
  studioUploadsDeleteFiles: StudioUploadsDeleteFilesResponse;
  studioUploadsDeleteFolder: StudioUploadsDeleteFolderResponse;
  studioUploadsDeleteTag: StudioUploadsDeleteTagResponse;
  studioUploadsMoveFiles: StudioUploadsMoveFilesResponse;
  studioUploadsRemoveTagFromFile: StudioUploadsRemoveTagFromFileResponse;
  studioUploadsRenameFolder: StudioUploadsRenameFolderResponse;
  studioUploadsUpdateTag: StudioUploadsUpdateTagResponse;
  subscribeToDigest: SubscribeToDigestResponse;
  subscriptionOptimisticallySetState?: Maybe<SubscriptionOptimisticallySetStateResponse>;
  teamsApproveAdminRequest: TeamsApproveAdminRequestResponse;
  teamsApproveNewTeamMember: TeamsApproveNewTeamMemberResponse;
  teamsApproveTeamMemberRoleChange: TeamsApproveTeamMemberRoleChangeResponse;
  teamsCancelInvite: TeamsCancelInviteResponse;
  teamsChangeUserRole: TeamsChangeUserRoleResponse;
  teamsConfirmInvite: TeamsConfirmInviteResponse;
  teamsCreateTeam: TeamsCreateTeamResponse;
  teamsDeactivateTeam: TeamsDeactivateTeamResponse;
  teamsGetCheckoutURL: TeamsGetCheckoutUrlResponse;
  teamsInviteUsers: TeamsInviteUsersResponse;
  teamsLeaveTeam: TeamsLeaveTeamResponse;
  teamsRemoveUsers: TeamsRemoveUsersResponse;
  teamsResendInvite: TeamsResendInviteResponse;
  teamsUpdateTeam: TeamsUpdateTeamResponse;
  transfersAddRecipients: TransfersAddRecipientsResponse;
  transfersCancel: TransfersCancelResponse;
  transfersConfirmOwnerEmail: TransfersConfirmOwnerEmailResponse;
  transfersCreateSignedDownloadUrl: TransfersCreateSignedDownloadUrlResponse;
  transfersDelete: TransfersDeleteResponse;
  transfersInitiateTransfer: TransfersInitiateTransferResponse;
  transfersInitiateTransferV2: TransfersInitiateTransferV2Response;
  transfersNotifyTransferDownloadCompleted: NotifyTransferDownloadCompletedResponse;
  transfersVerifyOwnerEmail: TransfersVerifyOwnerEmailResponse;
  /** @deprecated Use userUnfollow */
  unfollowUser: Scalars['Boolean']['output'];
  unsubscribeFromDigest: SubscribeToDigestResponse;
  /**
   * Update product tags (add and/or remove).
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  updateAdminProductTags: UpdateAdminProductTagsResponse;
  /** @deprecated Use flowUpdate */
  updateFlow: Flow;
  /** @deprecated Use flowUpdateVisibility */
  updateFlowVisibility: Flow;
  updatePersonalProfile: EditUserProfileResponse;
  updateUserGDPR: UpdateUserResponse;
  uploadUserAvatar: UploadUserAvatarResponse;
  /** @deprecated This method is replaced by another mutation. */
  uploadedFontsCreateSignedUrl: UploadedFontsCreateSignedUrlResponse;
  uploadedFontsCreateSignedUrlV2: UploadedFontsCreateSignedUrlV2Response;
  uploadedFontsDelete: UploadedFontsDeleteResponse;
  /** @deprecated Use uploadsCreateSignedUrlV3 instead. */
  uploadsCreateSignedUrlV2: UploadsCreateSignedUrlResponseV2;
  uploadsCreateSignedUrlV3: UploadsCreateSignedUrlV3Response;
  upscalerCancelImage: UpscalerCancelImageResponse;
  /** @deprecated Use uploadsCreateSignedUrlV3 instead. */
  upscalerCreateSignedUploadUrl: UpscalerCreateSignedUploadUrlResponse;
  upscalerDeleteAllImages: UpscalerDeleteAllImagesResponse;
  upscalerDeleteImage: UpscalerDeleteImageResponse;
  upscalerDownloadImage: UpscalerDownloadImageResponse;
  upscalerPublishImage: UpscalerPublishImageResponse;
  upscalerUpscaleImage: UpscalerUpscaleImageResponse;
  userFollow: Scalars['Boolean']['output'];
  userUnfollow: Scalars['Boolean']['output'];
  usersEditBan: UsersEditBanResponse;
  usersFavoriteProduct: UsersFavoriteProductResponse;
  usersSaveShippingAddress: UsersSaveShippingAddressResponse;
  usersUpdateCurrency: UpdateUserResponse;
  usersUpdateFlags: UpdateUserResponse;
  usersUpdateLanguage: UpdateUserResponse;
  vectorizerCancelVectorization: VectorizerCancelImageVectorizationResponse;
  vectorizerCreateImage: VectorizerCreateImageResponse;
  /** @deprecated Use uploadsCreateSignedUrlV3 instead */
  vectorizerCreateSignedUploadUrl: VectorizerCreateSignedUploadUrlResponse;
  vectorizerDeleteAllImages: VectorizerDeleteAllImagesResponse;
  vectorizerDeleteImage: VectorizerDeleteImageResponse;
  vectorizerPublishImage: VectorizerPublishImageResponse;
  vectorizerRegisterImagesToUser: VectorizerImagesRegisterToUserResponse;
  /** @deprecated Use flowView */
  viewFlow: Scalars['Int']['output'];
};


export type MutationAddAdminProductNoteArgs = {
  input: AddAdminProductNoteInput;
};


export type MutationAdvertisingCreateCampaignArgs = {
  input: AdvertisingCreateCampaignInput;
};


export type MutationAdvertisingDeleteCampaignArgs = {
  input: AdvertisingDeleteCampaignInput;
};


export type MutationAdvertisingIncreaseClickForCampaignArgs = {
  input: AdvertisingIncreaseClickForCampaignInput;
};


export type MutationAdvertisingIncreaseViewForCampaignArgs = {
  input: AdvertisingIncreaseViewForCampaignInput;
};


export type MutationAdvertisingUpdateCampaignArgs = {
  input: AdvertisingUpdateCampaignInput;
};


export type MutationAdvertisingUploadsCreateSignedUrlArgs = {
  input: AdvertisingUploadsCreateSignedUrlInput;
};


export type MutationAskCfConfirmQuestionArgs = {
  input: AskCfConfirmQuestionInput;
};


export type MutationAskCfConfirmTopicArgs = {
  input: AskCfConfirmTopicInput;
};


export type MutationAskCfCreateSignedUploadUrlV2Args = {
  input: AskCfCreateSignedUploadUrlV2Input;
};


export type MutationAskCfDeleteAnswerArgs = {
  input: AskCfDeleteAnswerInput;
};


export type MutationAskCfDeleteAnswersFromUserArgs = {
  input: AskCfDeleteAnswersFromUserInput;
};


export type MutationAskCfDeleteQuestionArgs = {
  input: AskCfDeleteQuestionInput;
};


export type MutationAskCfDeleteQuestionsFromUserArgs = {
  input: AskCfDeleteQuestionsFromUserInput;
};


export type MutationAskCfDeleteTopicArgs = {
  input: AskCfTopicDeleteInput;
};


export type MutationAskCfDiscardQuestionArgs = {
  input: AskCfDiscardQuestionInput;
};


export type MutationAskCfDislikeAnswerArgs = {
  input: AskCfDislikeAnswerInput;
};


export type MutationAskCfDislikeCommentArgs = {
  input: AskCfDislikeCommentInput;
};


export type MutationAskCfFollowQuestionArgs = {
  input: AskCfFollowQuestionInput;
};


export type MutationAskCfGiveTipToAnswerArgs = {
  input: AskCfGiveTipToAnswerInput;
};


export type MutationAskCfLikeAnswerArgs = {
  input: AskCfLikeAnswerInput;
};


export type MutationAskCfLikeCommentArgs = {
  input: AskCfLikeCommentInput;
};


export type MutationAskCfPostAnswerArgs = {
  input: AskCfPostAnswerInput;
};


export type MutationAskCfPostCommentArgs = {
  input: AskCfPostCommentInput;
};


export type MutationAskCfPostQuestionArgs = {
  input: AskCfPostQuestionInput;
};


export type MutationAskCfSetBestAnswerArgs = {
  input: AskCfSetBestAnswerInput;
};


export type MutationAskCfUnfollowQuestionArgs = {
  input: AskCfUnfollowQuestionInput;
};


export type MutationAskCfUploadsCreateSignedUrlArgs = {
  input: AskCfUploadCreateSignedUrlInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCfmainCreateEnterpriseRequestArgs = {
  input: CfMainEnterpriseRequestInput;
};


export type MutationCfmainUpdateEnterpriseRequestArgs = {
  input: CfMainUpdateEnterpriseRequestInput;
};


export type MutationChangeAdminProductFileUrlArgs = {
  input: ChangeAdminProductFileUrlInput;
};


export type MutationClubhousesAcceptInviteArgs = {
  input: ClubhouseAcceptInviteInput;
};


export type MutationClubhousesAdminUploadsCreateSignedUrlArgs = {
  input: ClubhousesAdminUploadCreateSignedUrlInput;
};


export type MutationClubhousesCreateCommunityLeaderArgs = {
  input: ClubhousesCreateCommunityLeaderInput;
};


export type MutationClubhousesCreateDiscussionArgs = {
  input: ClubhousesCreateDiscussionInput;
};


export type MutationClubhousesCreateDiscussionReplyArgs = {
  input: ClubhousesCreateDiscussionReplyInput;
};


export type MutationClubhousesCreateSignedUploadUrlV2Args = {
  input: ClubhousesCreateSignedUploadUrlV2Input;
};


export type MutationClubhousesDeleteDiscussionArgs = {
  input: ClubhousesDeleteDiscussionInput;
};


export type MutationClubhousesDeleteDiscussionReplyArgs = {
  input: ClubhousesDeleteDiscussionReplyInput;
};


export type MutationClubhousesDiscussionNotificationUpdateArgs = {
  input: ClubhousesDiscussionNotificationUpdateInput;
};


export type MutationClubhousesEditDiscussionArgs = {
  input: ClubhousesEditDiscussionInput;
};


export type MutationClubhousesEditDiscussionReplyArgs = {
  input: ClubhousesEditDiscussionReplyInput;
};


export type MutationClubhousesGenerateDigestArgs = {
  input: ClubhousesGenerateDigestInput;
};


export type MutationClubhousesGiveTipToDiscussionArgs = {
  input: ClubhousesGiveTipToDiscussionInput;
};


export type MutationClubhousesInviteArgs = {
  input: ClubhouseInviteInput;
};


export type MutationClubhousesJoinArgs = {
  input: ClubhouseJoinInput;
};


export type MutationClubhousesLeaveArgs = {
  input: ClubhouseLeaveInput;
};


export type MutationClubhousesLikeReplyArgs = {
  input: ClubhousesLikeReplyInput;
};


export type MutationClubhousesReactToDiscussionArgs = {
  input: ClubhousesReactToDiscussionInput;
};


export type MutationClubhousesRemoveLikeReplyArgs = {
  input: ClubhousesRemoveLikeReplyInput;
};


export type MutationClubhousesSubscribeToDigestArgs = {
  input: SubscribeToClubhouseDigestInput;
};


export type MutationClubhousesUnsubscribeToDigestArgs = {
  input: UnsubscribeToClubhouseDigestInput;
};


export type MutationClubhousesUpdateDigestPreferenceArgs = {
  input: ClubhouseUpdateDigestPreferenceInput;
};


export type MutationClubhousesUpdateNotificationSettingsArgs = {
  input: ClubhouseUpdateNotificationSettingsInput;
};


export type MutationClubhousesUploadsCreateSignedUrlArgs = {
  input: ClubhousesUploadCreateSignedUrlInput;
};


export type MutationClubhousesViewDiscussionArgs = {
  input: ClubhousesViewDiscussionInput;
};


export type MutationCoinsEntityTipArgs = {
  input: CoinsEntityTipRequest;
};


export type MutationCoinsGiveTipArgs = {
  recipientUserId: Scalars['String']['input'];
};


export type MutationCoinsSpendOnProductArgs = {
  productId: Scalars['String']['input'];
};


export type MutationCoinsUpdateTransactionStatusArgs = {
  id: Scalars['String']['input'];
  status: CoinTransactionStatus;
};


export type MutationConfirmMyAccountEmailResetArgs = {
  input: ConfirmMyAccountEmailResetInput;
};


export type MutationContentCreateFavoriteListArgs = {
  input: ContentCreateFavoriteListInput;
};


export type MutationContentCreateReviewArgs = {
  input: ContentCreateReview;
};


export type MutationContentDeleteFavoriteListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContentDeleteReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationContentEditReviewArgs = {
  input: ContentEditReview;
};


export type MutationContentFavoriteProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationContentIncreaseDownloadCountArgs = {
  productId: Scalars['ID']['input'];
  source?: InputMaybe<ContentDownloadSource>;
};


export type MutationContentRegisterProductDownloadArgs = {
  input: ContentRegisterProductDownloadInput;
};


export type MutationContentUnfavoriteProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationContentUpdateFavoriteArgs = {
  input: ContentUpdateFavoriteInput;
};


export type MutationContentUpdateFavoriteListArgs = {
  input: ContentUpdateFavoriteListInput;
};


export type MutationCreateDownloadUrlArgs = {
  imageId: Scalars['ID']['input'];
};


export type MutationCreateFlowArgs = {
  input: FlowSettingsInput;
};


export type MutationCreateFlowIterationPageArgs = {
  iterationId: Scalars['ID']['input'];
};


export type MutationCreateUploadUrlArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationDeactivateAccountArgs = {
  otp?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteAdminProductNoteArgs = {
  noteId: Scalars['Int']['input'];
};


export type MutationDeleteCraftMaterialArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCraftThemeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFlowArgs = {
  id: Scalars['String']['input'];
};


export type MutationDesignReviewerCancelReviewArgs = {
  input: DesignReviewerCancelReviewRequestInput;
};


export type MutationDesignReviewerDeleteReviewArgs = {
  input: DesignReviewerDeleteReviewInput;
};


export type MutationDesignReviewerUploadsCreateSignedUrlArgs = {
  input: DesignReviewerUploadsCreateSignedUrlInput;
};


export type MutationEditAdminProductNoteArgs = {
  input: EditAdminProductNoteInput;
};


export type MutationEditMyAccountEmailPasswordArgs = {
  input: EditMyAccountEmailPasswordInput;
};


export type MutationEditUserProfileArgs = {
  input: EditUserProfileInput;
};


export type MutationEntityDownloadArgs = {
  id: EntityDownloadInput;
};


export type MutationEntityLoveArgs = {
  id: EntityLoveInput;
};


export type MutationEntityReactArgs = {
  input: EntityReactInput;
};


export type MutationEntityReactDeleteArgs = {
  input: EntityReactDeleteInput;
};


export type MutationFlowCancelIterationPageArgs = {
  input: FlowCancelIterationPageInput;
};


export type MutationFlowCreateArgs = {
  input: FlowSettingsInput;
};


export type MutationFlowCreateDownloadUrlArgs = {
  imageId: Scalars['ID']['input'];
};


export type MutationFlowCreateIterationPageArgs = {
  iterationId: Scalars['ID']['input'];
};


export type MutationFlowCreateUploadUrlArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationFlowDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationFlowGiveTipArgs = {
  flowID: Scalars['ID']['input'];
};


export type MutationFlowImageReactArgs = {
  input: FlowImageReactInput;
};


export type MutationFlowImageRemoveReactArgs = {
  input: FlowImageRemoveReactInput;
};


export type MutationFlowImageReportArgs = {
  input: FlowImageReportInput;
};


export type MutationFlowIterationRateArgs = {
  input: FlowIterationRateInput;
};


export type MutationFlowLikeArgs = {
  flowID: Scalars['ID']['input'];
};


export type MutationFlowPublishImageArgs = {
  input: FlowPublishImageInput;
};


export type MutationFlowRateIterationPageArgs = {
  input: FlowRateIterationPageInput;
};


export type MutationFlowUpdateArgs = {
  id: Scalars['ID']['input'];
  input: FlowSettingsInput;
};


export type MutationFlowUpdateVisibilityArgs = {
  id: Scalars['ID']['input'];
  visibility: FlowVisibility;
};


export type MutationFlowViewArgs = {
  flowID: Scalars['ID']['input'];
};


export type MutationFollowUserArgs = {
  userID: Scalars['ID']['input'];
};


export type MutationFontGeneratorFontCreateArgs = {
  input: FontGeneratorFontCreateInput;
};


export type MutationFontGeneratorFontDownloadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFontGeneratorFontUpdateArgs = {
  input: FontGeneratorFontUpdateInput;
};


export type MutationFontGeneratorSymbolAcceptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFontGeneratorSymbolCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFontGeneratorSymbolGenerateArgs = {
  input: FontGeneratorSymbolGenerateInput;
};


export type MutationFontGeneratorUserFontCreateArgs = {
  input: FontGeneratorUserFontCreateInput;
};


export type MutationFontGeneratorUserFontDeleteArgs = {
  input: FontGeneratorUserFontDeleteInput;
};


export type MutationFontGeneratorUserFontPackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFontGeneratorUserFontUpdateArgs = {
  input: FontGeneratorUserFontUpdateInput;
};


export type MutationGeneratedFontsDeleteArgs = {
  input: GeneratedFontsDeleteInput;
};


export type MutationGiveTipArgs = {
  flowID: Scalars['ID']['input'];
};


export type MutationHelpRateMessageArgs = {
  messageId: Scalars['ID']['input'];
  rate: HelpMessageRate;
};


export type MutationHelpSendMessageArgs = {
  channel: HelpChannel;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Language>;
  message: Scalars['String']['input'];
};


export type MutationInvalidateAuthCacheArgs = {
  input: InvalidateAuthCacheInput;
};


export type MutationLikeFlowArgs = {
  flowID: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  input?: InputMaybe<LoginInput>;
};


export type MutationLoginWithSocialArgs = {
  input?: InputMaybe<SocialLoginInput>;
};


export type MutationLoginWithSocialRedirectArgs = {
  input?: InputMaybe<SocialRedirectLoginInput>;
};


export type MutationLostPasswordArgs = {
  input?: InputMaybe<LostPasswordInput>;
};


export type MutationPaymentsActivateTrialArgs = {
  applyBonus?: InputMaybe<Scalars['Boolean']['input']>;
  input: ActivateTrialInput;
};


export type MutationPaymentsAutoStartSubscriptionArgs = {
  input: PaymentsAutoStartSubscriptionInput;
};


export type MutationPaymentsAutoStartTrialArgs = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: AvailableCurrencyCode;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId: Scalars['String']['input'];
  subscriptionType?: InputMaybe<SubscriptionTypeAutoStartTrial>;
};


export type MutationPaymentsBuildPaymentDataForSubscriptionArgs = {
  subscriptionType: SubscriptionType;
};


export type MutationPaymentsBuildPaymentForSubscriptionArgs = {
  subscriptionType: SubscriptionType;
};


export type MutationPaymentsBuyCoinsArgs = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  coinPack: CoinPack;
  currencyCode: AvailableCurrencyCode;
  custom?: InputMaybe<BuyCoinsCustomInput>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPaymentsChangeSubscriptionPlanArgs = {
  input: PaymentsChangeSubscriptionPlanInput;
};


export type MutationPaymentsCompensateInvoiceArgs = {
  input: PaymentsCompensateInvoiceInput;
};


export type MutationPaymentsCreateSetupIntentArgs = {
  input: CreateSetupIntentInput;
};


export type MutationPaymentsExtendSubscriptionArgs = {
  stripeAccount?: InputMaybe<StripeAccount>;
  stripeSubscriptionId: Scalars['String']['input'];
};


export type MutationPaymentsExtendSubscriptionToPlanArgs = {
  input: ExtendSubscriptionToPlanInput;
};


export type MutationPaymentsExtendTrialArgs = {
  input: PaymentsExtendTrialInput;
};


export type MutationPaymentsSubmitSubscriptionCheckoutArgs = {
  input: SubmitSubscriptionCheckoutInput;
};


export type MutationPaymentsUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationPaymentsUpgradeSubscriptionArgs = {
  applyBonus?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSubscriptionId: Scalars['String']['input'];
  upgradeSource?: InputMaybe<Scalars['String']['input']>;
  upgradeTo?: InputMaybe<SubscriptionTypeUpgrade>;
};


export type MutationPhysicalProductOpenOrderDeleteArgs = {
  input: PhysicalProductOpenOrderDeleteInput;
};


export type MutationPhysicalProductOpenOrderShippingDetailUpdateArgs = {
  input: PhysicalProductOpenOrderShippingDetailUpdateInput;
};


export type MutationPhysicalProductOrderCreateArgs = {
  input: PhysicalProductOrderCreateInput;
};


export type MutationPrintOnDemandCreateOrUpdateShippingAddressArgs = {
  input: PrintOnDemandShippingAddressCreateOrUpdateInput;
};


export type MutationPublishImageArgs = {
  imageId: Scalars['ID']['input'];
};


export type MutationPublishedTemplatesAddFavoriteArgs = {
  input: PublishedTemplatesAddFavoriteInput;
};


export type MutationPublishedTemplatesRemoveFavoriteArgs = {
  input: PublishedTemplatesRemoveFavoriteInput;
};


export type MutationPublisherCreateTemplateSubmissionArgs = {
  input: PublisherCreateTemplateSubmissionInput;
};


export type MutationPublisherDeleteTemplateSubmissionArgs = {
  input: PublisherDeleteTemplateSubmissionInput;
};


export type MutationPublisherFinaliseTemplateSubmissionArgs = {
  input: PublisherFinaliseTemplateSubmissionInput;
};


export type MutationPublisherRegenerateTemplateSubmissionFieldsArgs = {
  input: PublisherRegenerateTemplateSubmissionFieldsInput;
};


export type MutationPublisherUploadsCreateSignedUrlArgs = {
  input: PublisherUploadsCreateSignedUrlInput;
};


export type MutationRedeemCodeArgs = {
  input: RedeemInput;
};


export type MutationRegisterArgs = {
  input?: InputMaybe<RegisterInput>;
};


export type MutationRemoveAdminProductArgs = {
  input: RemoveAdminProductInput;
};


export type MutationReportJwtAuthOutcomeArgs = {
  input: JwtAuthOutcomeInput;
};


export type MutationResetMyAccountEmailArgs = {
  input: ResetMyAccountEmailInput;
};


export type MutationResetPasswordArgs = {
  input?: InputMaybe<ResetPasswordInput>;
};


export type MutationSaveMyAccountNotificationSettingsArgs = {
  input: SaveMyAccountNotificationSettingsInput;
};


export type MutationSetCoreFlagArgs = {
  input?: InputMaybe<SetCoreFlagInput>;
};


export type MutationSnippetsCreateSnippetArgs = {
  input: SnippetsCreateSnippetInput;
};


export type MutationSnippetsDeleteSnippetArgs = {
  input: SnippetsDeleteSnippetInput;
};


export type MutationSnippetsUpdateSnippetArgs = {
  input: SnippetsUpdateSnippetInput;
};


export type MutationSocialBlockUserArgs = {
  input: SocialBlockUserInput;
};


export type MutationSocialCommentDeleteArgs = {
  input: SocialCommentDeleteInput;
};


export type MutationSocialCommentLikeArgs = {
  input: SocialCommentLikeInput;
};


export type MutationSocialCommentLikeRemoveArgs = {
  input: SocialCommentLikeRemoveInput;
};


export type MutationSocialCreateCommentArgs = {
  input: SocialCreateCommentInput;
};


export type MutationSocialCreateSignedUploadUrlV2Args = {
  input: SocialCreateSignedUploadUrlV2Input;
};


export type MutationSocialGiveTipToPostArgs = {
  input: SocialGiveTipToPostInput;
};


export type MutationSocialPostClassArgs = {
  input: SocialPostInput;
};


export type MutationSocialPostDeleteArgs = {
  input: SocialPostDeleteInput;
};


export type MutationSocialPostDeleteFromUserArgs = {
  input: SocialPostDeleteFromUserInput;
};


export type MutationSocialPostLikeArgs = {
  input: SocialPostLikeInput;
};


export type MutationSocialPostLikeRemoveArgs = {
  input: SocialPostLikeRemoveInput;
};


export type MutationSocialPostProjectArgs = {
  input: SocialPostInput;
};


export type MutationSocialPostSaveArgs = {
  input: SocialPostSaveInput;
};


export type MutationSocialPostSaveRemoveArgs = {
  input: SocialPostSaveRemoveInput;
};


export type MutationSocialUnblockUserArgs = {
  input: SocialUnblockUserInput;
};


export type MutationSocialUpdateEmailNotificationsSettingsArgs = {
  input: SocialUpdateEmailNotificationsSettingsInput;
};


export type MutationSocialUploadsCreateSignedUrlArgs = {
  input: SocialUploadCreateSignedUrlInput;
};


export type MutationSparkArtDeleteArgs = {
  input: SparkArtDeleteInput;
};


export type MutationSparkArtGenerateArgs = {
  input: SparkArtGenerateInput;
};


export type MutationSparkCrystallineDeleteArgs = {
  input: SparkCrystallineDeleteInput;
};


export type MutationSparkCrystallineGenerateArgs = {
  input: SparkCrystallineGenerateInput;
};


export type MutationSparkImageMixDeleteArgs = {
  input: SparkImageMixDeleteInput;
};


export type MutationSparkImageMixGenerateArgs = {
  input: SparkImageMixGenerateInput;
};


export type MutationSparkInpaintDeleteArgs = {
  input: SparkInpaintDeleteInput;
};


export type MutationSparkInpaintImageArgs = {
  input: SparkInpaintImageInput;
};


export type MutationSparkOutpaintDeleteArgs = {
  input: SparkOutpaintDeleteInput;
};


export type MutationSparkOutpaintImageArgs = {
  input: SparkOutpaintImageInput;
};


export type MutationSparkRegisterAnonymousArtToUserArgs = {
  input: SparkArtRegisterInput;
};


export type MutationSparkRegisterAnonymousBackgroundRemovedToUserArgs = {
  input: SparkBackgroundRemovedRegisterInput;
};


export type MutationSparkRegisterAnonymousCrystallineToUserArgs = {
  input: SparkCrystallineRegisterInput;
};


export type MutationSparkRegisterAnonymousImageMixToUserArgs = {
  input: SparkImageMixRegisterInput;
};


export type MutationSparkRegisterAnonymousInpaintToUserArgs = {
  input: SparkInpaintRegisterInput;
};


export type MutationSparkRegisterAnonymousOutpaintToUserArgs = {
  input: SparkOutpaintRegisterInput;
};


export type MutationSparkRemoveBackgroundArgs = {
  input: SparkRemoveBackgroundInput;
};


export type MutationSparkRemovedBackgroundCancelArgs = {
  input: SparkRemovedBackgroundCancelInput;
};


export type MutationSparkRemovedBackgroundDeleteArgs = {
  input: SparkRemovedBackgroundDeleteInput;
};


export type MutationSparkRemovedBackgroundPublishImageArgs = {
  input: RemoveBackgroundPublishImageInput;
};


export type MutationSparkRemovedBackgroundUploadsCreateSignedUrlArgs = {
  input: SparkRemovedBackgroundUploadsCreateSignedUrlInput;
};


export type MutationSparkUploadsCreateSignedUrlArgs = {
  input: SparkUploadsCreateSignedUrlInput;
};


export type MutationSpendCoinsOnProductArgs = {
  productId: Scalars['String']['input'];
};


export type MutationStatisticsRecordStudioEventArgs = {
  input: StatisticsRecordStudioEventInput;
};


export type MutationStorageEnableOveragesArgs = {
  input: StorageEnableOveragesInput;
};


export type MutationStorageUpdateSizeArgs = {
  input: StorageUpdateSizeInput;
};


export type MutationStoreUserSearchArgs = {
  input: StoreUserSearchInput;
};


export type MutationStudioCommentReactArgs = {
  input: StudioCommentReactInput;
};


export type MutationStudioCommentReactDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStudioProjectsAddMemberArgs = {
  input: StudioProjectsAddMemberInput;
};


export type MutationStudioProjectsAddUserToProjectSharingLinkArgs = {
  input: StudioProjectsAddUserToProjectSharingLinkInput;
};


export type MutationStudioProjectsApproveInviteArgs = {
  input: StudioProjectsApproveInviteInput;
};


export type MutationStudioProjectsApproveProjectMemberUpdateArgs = {
  input: StudioProjectsApproveProjectMemberUpdateInput;
};


export type MutationStudioProjectsChangeUserRoleArgs = {
  input: StudioProjectsChangeUserRoleInput;
};


export type MutationStudioProjectsConfirmInviteArgs = {
  input: StudioProjectsConfirmInviteInput;
};


export type MutationStudioProjectsCreateFolderArgs = {
  input: StudioProjectCreateFolderInput;
};


export type MutationStudioProjectsCreateFromTemplateArgs = {
  input: StudioProjectsCreateFromTemplateInput;
};


export type MutationStudioProjectsCreateProjectArgs = {
  input: StudioProjectsCreateProjectInput;
};


export type MutationStudioProjectsCreateProjectCommentArgs = {
  input: StudioProjectsCreateProjectCommentInput;
};


export type MutationStudioProjectsCreateProjectSharingLinkArgs = {
  input: StudioProjectsCreateProjectSharingLinkInput;
};


export type MutationStudioProjectsDeleteProjectArgs = {
  input: StudioProjectDeleteProjectInput;
};


export type MutationStudioProjectsEmptyTrashArgs = {
  input: StudioProjectEmptyTrashInput;
};


export type MutationStudioProjectsFolderDeleteArgs = {
  input: StudioProjectFolderDeleteInput;
};


export type MutationStudioProjectsFolderRenameArgs = {
  input: StudioProjectsFolderRenameInput;
};


export type MutationStudioProjectsFolderRestoreArgs = {
  input: StudioProjectsFolderRestoreInput;
};


export type MutationStudioProjectsMarkProjectCommentDoneArgs = {
  input: StudioProjectsMarkProjectCommentDoneInput;
};


export type MutationStudioProjectsMoveProjectsArgs = {
  input: StudioProjectMoveProjectsInput;
};


export type MutationStudioProjectsOptimizeProjectArgs = {
  input: StudioProjectOptimizeProjectInput;
};


export type MutationStudioProjectsRemoveUserArgs = {
  input: StudioProjectsRemoveUserInput;
};


export type MutationStudioProjectsRestoreProjectArgs = {
  input: StudioProjectRestoreProjectInput;
};


export type MutationStudioProjectsUpdateProjectArgs = {
  input?: InputMaybe<StudioProjectsUpdateProjectInput>;
};


export type MutationStudioProjectsUpdateProjectLastViewArgs = {
  input: StudioProjectsUpdateProjectLastViewInput;
};


export type MutationStudioSimpleCommentsCreateArgs = {
  input: StudioSimpleCommentsCreateInput;
};


export type MutationStudioSimpleCommentsDeleteArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationStudioSimpleCommentsEditArgs = {
  input: StudioSimpleCommentsEditInput;
};


export type MutationStudioSwitchWorkspaceArgs = {
  teamId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStudioTemplateDeleteArgs = {
  input: StudioTemplateDeleteInput;
};


export type MutationStudioTemplatePublishFromProjectArgs = {
  input: StudioTemplatePublishFromProjectInput;
};


export type MutationStudioTemplateRestoreArgs = {
  input: StudioTemplateRestoreInput;
};


export type MutationStudioUploadsAddTagToFilesArgs = {
  input: StudioUploadsAddTagToFilesInput;
};


export type MutationStudioUploadsCreateFolderArgs = {
  input: StudioUploadsCreateFolderInput;
};


export type MutationStudioUploadsCreateSignedDownloadUrlArgs = {
  input: StudioUploadsCreateSignedDownloadUrlInput;
};


export type MutationStudioUploadsCreateSignedUrlArgs = {
  input: StudioUploadsCreateSignedUrlInput;
};


export type MutationStudioUploadsCreateTagArgs = {
  input: StudioUploadsCreateTagInput;
};


export type MutationStudioUploadsDeleteFilesArgs = {
  input: StudioUploadsDeleteFilesInput;
};


export type MutationStudioUploadsDeleteFolderArgs = {
  input: StudioUploadsDeleteFolderInput;
};


export type MutationStudioUploadsDeleteTagArgs = {
  input: StudioUploadsDeleteTagInput;
};


export type MutationStudioUploadsMoveFilesArgs = {
  input: StudioUploadsMoveFilesInput;
};


export type MutationStudioUploadsRemoveTagFromFileArgs = {
  input: StudioUploadsRemoveTagFromFileInput;
};


export type MutationStudioUploadsRenameFolderArgs = {
  input: StudioUploadsRenameFolderInput;
};


export type MutationStudioUploadsUpdateTagArgs = {
  input: StudioUploadsUpdateTagInput;
};


export type MutationSubscriptionOptimisticallySetStateArgs = {
  input: SubscriptionOptimisticallySetStateInput;
};


export type MutationTeamsApproveAdminRequestArgs = {
  input: TeamsApproveAdminRequestInput;
};


export type MutationTeamsApproveNewTeamMemberArgs = {
  input: TeamsApproveNewTeamMemberInput;
};


export type MutationTeamsApproveTeamMemberRoleChangeArgs = {
  input: TeamsApproveTeamMemberRoleChangeInput;
};


export type MutationTeamsCancelInviteArgs = {
  input: TeamsCancelInviteInput;
};


export type MutationTeamsChangeUserRoleArgs = {
  input: TeamsChangeUserRoleInput;
};


export type MutationTeamsConfirmInviteArgs = {
  input: TeamsConfirmInviteInput;
};


export type MutationTeamsCreateTeamArgs = {
  input: TeamsCreateTeamInput;
};


export type MutationTeamsDeactivateTeamArgs = {
  input: TeamsDeactivateTeamInput;
};


export type MutationTeamsGetCheckoutUrlArgs = {
  input: TeamsGetCheckoutUrlInput;
};


export type MutationTeamsInviteUsersArgs = {
  input: TeamsInviteUsersInput;
};


export type MutationTeamsLeaveTeamArgs = {
  input: TeamsLeaveTeamInput;
};


export type MutationTeamsRemoveUsersArgs = {
  input: TeamsRemoveUsersInput;
};


export type MutationTeamsResendInviteArgs = {
  input: TeamsResendInviteInput;
};


export type MutationTeamsUpdateTeamArgs = {
  input: TeamsUpdateTeamInput;
};


export type MutationTransfersAddRecipientsArgs = {
  input: TransfersAddRecipientsInput;
};


export type MutationTransfersCancelArgs = {
  input: TransfersCancelInput;
};


export type MutationTransfersConfirmOwnerEmailArgs = {
  input: TransfersConfirmOwnerEmailInput;
};


export type MutationTransfersCreateSignedDownloadUrlArgs = {
  input: TransfersCreateSignedDownloadUrlInput;
};


export type MutationTransfersDeleteArgs = {
  input: TransfersDeleteInput;
};


export type MutationTransfersInitiateTransferArgs = {
  input: TransfersInitiateTransferInput;
};


export type MutationTransfersInitiateTransferV2Args = {
  input: TransfersInitiateTransferV2Input;
};


export type MutationTransfersNotifyTransferDownloadCompletedArgs = {
  input: NotifyTransferDownloadCompletedInput;
};


export type MutationTransfersVerifyOwnerEmailArgs = {
  input: TransfersVerifyOwnerEmailInput;
};


export type MutationUnfollowUserArgs = {
  userID: Scalars['ID']['input'];
};


export type MutationUpdateAdminProductTagsArgs = {
  input: UpdateAdminProductTagsInput;
};


export type MutationUpdateFlowArgs = {
  id: Scalars['ID']['input'];
  input: FlowSettingsInput;
};


export type MutationUpdateFlowVisibilityArgs = {
  id: Scalars['ID']['input'];
  visibility: FlowVisibility;
};


export type MutationUpdatePersonalProfileArgs = {
  input: EditUserProfileInput;
};


export type MutationUpdateUserGdprArgs = {
  input: UserUpdateGdprInput;
};


export type MutationUploadUserAvatarArgs = {
  input: UploadUserAvatarInput;
};


export type MutationUploadedFontsCreateSignedUrlArgs = {
  input: UploadedFontsCreateSignedUrlInput;
};


export type MutationUploadedFontsCreateSignedUrlV2Args = {
  input: UploadedFontsCreateSignedUrlV2Input;
};


export type MutationUploadedFontsDeleteArgs = {
  input: UploadedFontsDeleteInput;
};


export type MutationUploadsCreateSignedUrlV2Args = {
  input: UploadsCreateSignedUrlInputV2;
};


export type MutationUploadsCreateSignedUrlV3Args = {
  input: UploadsCreateSignedUrlV3Input;
};


export type MutationUpscalerCancelImageArgs = {
  input: UpscalerCancelImageInput;
};


export type MutationUpscalerCreateSignedUploadUrlArgs = {
  input: UpscalerCreateSignedUploadUrl;
};


export type MutationUpscalerDeleteImageArgs = {
  input: UpscalerDeleteImageInput;
};


export type MutationUpscalerDownloadImageArgs = {
  input: UpscalerDownloadImageInput;
};


export type MutationUpscalerPublishImageArgs = {
  input: UpscalerPublishImageInput;
};


export type MutationUpscalerUpscaleImageArgs = {
  input: UpscalerUpscaleImageInput;
};


export type MutationUserFollowArgs = {
  userID: Scalars['ID']['input'];
};


export type MutationUserUnfollowArgs = {
  userID: Scalars['ID']['input'];
};


export type MutationUsersEditBanArgs = {
  input: UsersEditBanInput;
};


export type MutationUsersFavoriteProductArgs = {
  isFavorite: Scalars['Boolean']['input'];
  productID: Scalars['Int']['input'];
};


export type MutationUsersSaveShippingAddressArgs = {
  input: UsersSaveShippingAddressInput;
};


export type MutationUsersUpdateCurrencyArgs = {
  currency: CurrencyCode;
};


export type MutationUsersUpdateFlagsArgs = {
  input: UserUpdateFlagsInput;
};


export type MutationUsersUpdateLanguageArgs = {
  language: Language;
};


export type MutationVectorizerCancelVectorizationArgs = {
  input: VectorizerCancelImageVectorizationInput;
};


export type MutationVectorizerCreateImageArgs = {
  input: VectorizerCreateInput;
};


export type MutationVectorizerCreateSignedUploadUrlArgs = {
  input: VectorizerCreateSignedUploadUrl;
};


export type MutationVectorizerDeleteImageArgs = {
  input: VectorizerDeleteImageInput;
};


export type MutationVectorizerPublishImageArgs = {
  input: VectorizerPublishImageInput;
};


export type MutationVectorizerRegisterImagesToUserArgs = {
  input: VectorizerImagesRegisterToUserInput;
};


export type MutationViewFlowArgs = {
  flowID: Scalars['ID']['input'];
};

export type MyAccountDownload = {
  __typename?: 'MyAccountDownload';
  categoryTag: Scalars['String']['output'];
  licenseKey: Scalars['String']['output'];
  licenseUsageCount: Scalars['String']['output'];
  links?: Maybe<Array<Maybe<MyAccountDownloadLink>>>;
  productId: Scalars['String']['output'];
  productUrl: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MyAccountDownloadLink = {
  __typename?: 'MyAccountDownloadLink';
  title: Scalars['String']['output'];
  type: MyAccountDownloadLinkType;
  url: Scalars['String']['output'];
};

export enum MyAccountDownloadLinkType {
  Bonus = 'bonus',
  File = 'file',
  SewingPdf = 'sewingPdf',
  Unknown = 'unknown'
}

export type MyAccountNotice = {
  __typename?: 'MyAccountNotice';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MyAccountNotificationSettings = {
  __typename?: 'MyAccountNotificationSettings';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type MyAccountProfileSettings = {
  __typename?: 'MyAccountProfileSettings';
  userVisibilitySetting: Scalars['Int']['output'];
  visibilitySettings: Array<KeyValuePairs>;
};

export type MyAccountUserProfile = {
  __typename?: 'MyAccountUserProfile';
  avatarNonce: Scalars['String']['output'];
  avatarUrl: Scalars['String']['output'];
  avatarUrlSizes: Array<KeyValuePairs>;
  countries: Array<KeyValuePairs>;
  craftings: Array<KeyValuePairs>;
  dateOfBirth: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  interests: Array<KeyValuePairs>;
  lastName: Scalars['String']['output'];
  machines: Array<Machine>;
  profileUrl: Scalars['String']['output'];
  userBio: Scalars['String']['output'];
  userCountry: Scalars['String']['output'];
  userCraftings?: Maybe<Array<KeyValuePairs>>;
  userEtsyShop: Scalars['String']['output'];
  userGender: Gender;
  userId: Scalars['Int']['output'];
  userInterests?: Maybe<Array<KeyValuePairs>>;
  userMachines?: Maybe<Array<Scalars['String']['output']>>;
  userSocialMediaAccounts: SocialMediaAccounts;
  userSuperSkill: Scalars['String']['output'];
};

export type NewsletterPopup = {
  __typename?: 'NewsletterPopup';
  backgroundImageSrc: Scalars['String']['output'];
  button: NewsletterPopupButton;
  closeText: Scalars['String']['output'];
  footerText: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: SitePopupType;
};

export type NewsletterPopupButton = {
  __typename?: 'NewsletterPopupButton';
  backgroundColor: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type NotificationBanner = {
  __typename?: 'NotificationBanner';
  backgroundColor: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  button: NotificationBannerButton;
  countdown?: Maybe<SiteCountdown>;
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
  type: SiteBannerType;
};

export type NotificationBannerButton = {
  __typename?: 'NotificationBannerButton';
  backgroundColor: Scalars['String']['output'];
  hoverBackgroundColor: Scalars['String']['output'];
  hoverTextColor: Scalars['String']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
};

export type NotificationPopup = {
  __typename?: 'NotificationPopup';
  backgroundColor: Scalars['String']['output'];
  button: NotificationPopupButton;
  closeText: Scalars['String']['output'];
  countdown?: Maybe<SiteCountdown>;
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: SitePopupType;
};

export type NotificationPopupButton = {
  __typename?: 'NotificationPopupButton';
  backgroundColor: Scalars['String']['output'];
  hoverBackgroundColor: Scalars['String']['output'];
  hoverTextColor: Scalars['String']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
};

export type NotifyTransferDownloadCompletedInput = {
  accessCode: Scalars['String']['input'];
  transferId: Scalars['String']['input'];
};

export type NotifyTransferDownloadCompletedResponse = {
  __typename?: 'NotifyTransferDownloadCompletedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type OnHoldSubscriptionBanner = {
  __typename?: 'OnHoldSubscriptionBanner';
  backgroundColor: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: SiteBannerType;
};

export enum OwnedBy {
  Teams = 'teams',
  Users = 'users'
}

export enum PageDirection {
  Next = 'next',
  Previous = 'previous'
}

export type Pagination = {
  __typename?: 'Pagination';
  itemsPerPage: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  allowedPaymentMethodTypes: Array<AvailablePaymentMethod>;
  currency: PaymentCurrency;
  lineItems: Array<PaymentLineItem>;
  totals: PaymentTotals;
  user: User;
};

export type PaymentCurrency = {
  __typename?: 'PaymentCurrency';
  code: AvailableCurrencyCode;
  symbol: Scalars['String']['output'];
};

export type PaymentIntentPayload = {
  __typename?: 'PaymentIntentPayload';
  status: PaymentIntentStatus;
};

export enum PaymentIntentStatus {
  Cancelled = 'cancelled',
  Processing = 'processing',
  RequiresAction = 'requiresAction',
  RequiresCapture = 'requiresCapture',
  RequiresConfirmation = 'requiresConfirmation',
  RequiresPaymentMethod = 'requiresPaymentMethod',
  Succeeded = 'succeeded'
}

export type PaymentLineItem = {
  __typename?: 'PaymentLineItem';
  billingPeriod: BillingPeriod;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  trialPeriodDays: Scalars['Int']['output'];
};

export type PaymentLineItemInput = {
  billingPeriod: BillingPeriod;
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  trialPeriodDays: Scalars['Int']['input'];
};

export enum PaymentStatus {
  Failed = 'failed',
  Processing = 'processing',
  RequiresAction = 'requiresAction',
  Succeeded = 'succeeded'
}

export type PaymentTotals = {
  __typename?: 'PaymentTotals';
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalAfterTrial: Scalars['Int']['output'];
};

export type PaymentsAutoStartSubscriptionInput = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: AvailableCurrencyCode;
  isTrial: Scalars['Boolean']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  subscriptionPlan: SubscriptionPlan;
};

export type PaymentsAutoStartSubscriptionResponse = {
  __typename?: 'PaymentsAutoStartSubscriptionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  subscription?: Maybe<SubscriptionPayload>;
};

export type PaymentsChangeSubscriptionPlanInput = {
  newPlan: SubscriptionPlan;
  subscriptionId: Scalars['String']['input'];
};

export type PaymentsChangeSubscriptionPlanResponse = {
  __typename?: 'PaymentsChangeSubscriptionPlanResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  subscription?: Maybe<SubscriptionPayload>;
};

export type PaymentsCompensateInvoiceInput = {
  compensationType: InvoiceCompensationType;
  invoiceId: Scalars['ID']['input'];
};

export type PaymentsCompensateInvoiceResponse = {
  __typename?: 'PaymentsCompensateInvoiceResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type PaymentsCustomerResponse = {
  __typename?: 'PaymentsCustomerResponse';
  customer: Customer;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type PaymentsExtendTrialInput = {
  subscriptionId: Scalars['String']['input'];
};

export type PaymentsExtendTrialResponse = {
  __typename?: 'PaymentsExtendTrialResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  subscription?: Maybe<SubscriptionPayload>;
};

export type PaymentsSubscriptionResponse = {
  __typename?: 'PaymentsSubscriptionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  subscription?: Maybe<SubscriptionPayload>;
};

export type PhysicalProduct = {
  __typename?: 'PhysicalProduct';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  images: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  variations: Array<PhysicalProductVariation>;
};

export type PhysicalProductGetInput = {
  id: Scalars['String']['input'];
};

export type PhysicalProductGetResponse = {
  __typename?: 'PhysicalProductGetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  product?: Maybe<PhysicalProduct>;
};

export type PhysicalProductOpenOrderDeleteInput = {
  id: Scalars['String']['input'];
};

export type PhysicalProductOpenOrderDeleteResponse = {
  __typename?: 'PhysicalProductOpenOrderDeleteResponse';
  errors?: Maybe<Array<Maybe<ErrorMessage>>>;
  success: Scalars['Boolean']['output'];
};

export type PhysicalProductOpenOrderSearchInput = {
  productId: Scalars['String']['input'];
};

export type PhysicalProductOpenOrderSearchResponse = {
  __typename?: 'PhysicalProductOpenOrderSearchResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  order?: Maybe<PhysicalProductOrder>;
};

export type PhysicalProductOpenOrderShippingDetailUpdateInput = {
  id: Scalars['String']['input'];
  shippingDetails: PhysicalProductOrderShippingDetailsInput;
};

export type PhysicalProductOpenOrderShippingDetailUpdateResponse = {
  __typename?: 'PhysicalProductOpenOrderShippingDetailUpdateResponse';
  errors?: Maybe<Array<Maybe<ErrorMessage>>>;
  success: Scalars['Boolean']['output'];
};

export type PhysicalProductOrder = {
  __typename?: 'PhysicalProductOrder';
  customerStripeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  items: Array<PhysicalProductOrderItem>;
  mainProduct: PhysicalProduct;
  shippingDetails: PhysicalProductOrderShippingDetails;
  status: InvoiceStatus;
};

export type PhysicalProductOrderAddress = {
  __typename?: 'PhysicalProductOrderAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type PhysicalProductOrderAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PhysicalProductOrderCreateInput = {
  productId: Scalars['String']['input'];
  variations: Array<PhysicalProductOrderLineCreateInput>;
};

export type PhysicalProductOrderCreateResponse = {
  __typename?: 'PhysicalProductOrderCreateResponse';
  errors?: Maybe<Array<Maybe<ErrorMessage>>>;
  success: Scalars['Boolean']['output'];
};

export type PhysicalProductOrderItem = {
  __typename?: 'PhysicalProductOrderItem';
  product: PhysicalProductVariation;
  quantity: Scalars['Int']['output'];
};

export type PhysicalProductOrderLineCreateInput = {
  quantity: Scalars['Int']['input'];
  variationId: Scalars['String']['input'];
};

export type PhysicalProductOrderShippingDetails = {
  __typename?: 'PhysicalProductOrderShippingDetails';
  address: PhysicalProductOrderAddress;
  name: Scalars['String']['output'];
};

export type PhysicalProductOrderShippingDetailsInput = {
  address: PhysicalProductOrderAddressInput;
  name: Scalars['String']['input'];
};

export type PhysicalProductVariation = {
  __typename?: 'PhysicalProductVariation';
  color: Scalars['String']['output'];
  colorHex: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  unitAmount: Scalars['Int']['output'];
};

export type Post = {
  __typename?: 'Post';
  assets?: Maybe<Array<SocialAsset>>;
  childComments?: Maybe<Array<SocialComment>>;
  commentsCount: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  createTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  instructionItems?: Maybe<Array<SocialInstruction>>;
  instructions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isLiked: Scalars['Boolean']['output'];
  isSaved: Scalars['Boolean']['output'];
  level?: Maybe<ProjectLevel>;
  likesCount: Scalars['Int']['output'];
  machineItems?: Maybe<Array<DropdownItem>>;
  machines?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  materialItems?: Maybe<Array<DropdownItem>>;
  materials?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  postSlug?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `socialProducts` field instead */
  products?: Maybe<Array<LegacyProduct>>;
  socialProducts?: Maybe<Array<SocialProduct>>;
  themeItems?: Maybe<Array<DropdownItem>>;
  themes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: PostType;
  user: PublicUserProfile;
  videoAssets?: Maybe<Array<SocialVideoAsset>>;
};

export enum PostType {
  Class = 'class',
  Product = 'product'
}

export type PreviewSubscriptionTotalsInput = {
  address: AddressInput;
  currencyCode: AvailableCurrencyCode;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  subscriptionPlan: SubscriptionPlan;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type PreviewSubscriptionTotalsResponse = {
  __typename?: 'PreviewSubscriptionTotalsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  totals?: Maybe<Totals>;
};

export type PriceCalculationsResponse = {
  __typename?: 'PriceCalculationsResponse';
  data?: Maybe<CalculatePricesResponse>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type PrintOnDemandShippingAddress = {
  __typename?: 'PrintOnDemandShippingAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type PrintOnDemandShippingAddressCreateOrUpdateInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PrintOnDemandShippingAddressCreateOrUpdateResponse = {
  __typename?: 'PrintOnDemandShippingAddressCreateOrUpdateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  shippingAddress?: Maybe<PrintOnDemandShippingAddress>;
};

export type PrintOnDemandShippingAddressGetResponse = {
  __typename?: 'PrintOnDemandShippingAddressGetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  shippingAddress?: Maybe<PrintOnDemandShippingAddress>;
};

export type ProductBox = {
  __typename?: 'ProductBox';
  cardCategory?: Maybe<LocalizedStrings>;
  categoryUrl?: Maybe<Scalars['String']['output']>;
  classProperties?: Maybe<ClassProperties>;
  designer?: Maybe<DesignerProfile>;
  favorites?: Maybe<Scalars['Int']['output']>;
  imageAlt?: Maybe<Scalars['String']['output']>;
  productCountdown?: Maybe<Scalars['String']['output']>;
  productCountdownText?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productImage?: Maybe<Scalars['String']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
  productTitleLocalized?: Maybe<LocalizedStrings>;
  productUrl?: Maybe<Scalars['String']['output']>;
};

export type ProductCategoryDetails = {
  __typename?: 'ProductCategoryDetails';
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProductCounts = {
  __typename?: 'ProductCounts';
  crafts: Scalars['Int']['output'];
  embroidery: Scalars['Int']['output'];
  fonts: Scalars['Int']['output'];
  graphics: Scalars['Int']['output'];
  knitting: Scalars['Int']['output'];
  laserCutting: Scalars['Int']['output'];
  pngs: Scalars['Int']['output'];
  svgs: Scalars['Int']['output'];
  threeDPaperCrafts: Scalars['Int']['output'];
};

/**
 * ProductsDownloadContentWithBackgroundRemovedResponse defines the response emitted by the dedicated query
 * for accessing a shared content background removed asset type.
 */
export type ProductsDownloadContentWithBackgroundRemovedResponse = {
  __typename?: 'ProductsDownloadContentWithBackgroundRemovedResponse';
  errors: Array<ErrorMessage>;
  generatedImageUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  sourceImageUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<SparkState>;
};

export type ProfileNudgePopup = {
  __typename?: 'ProfileNudgePopup';
  button: ProfileNudgePopupButton;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: SitePopupType;
};

export type ProfileNudgePopupButton = {
  __typename?: 'ProfileNudgePopupButton';
  backgroundColor: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export enum ProjectEditor {
  Fabric = 'Fabric',
  Polotno = 'Polotno',
  StudioEngine = 'StudioEngine',
  Unspecified = 'Unspecified'
}

export enum ProjectLevel {
  Advanced = 'advanced',
  Beginner = 'beginner',
  Intermediate = 'intermediate',
  Unspecified = 'unspecified'
}

export type ProjectListPagination = {
  __typename?: 'ProjectListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
};

export type ProjectSort = {
  direction: SortDirection;
  field: ProjectSortField;
};

export enum ProjectSortField {
  CreateTime = 'createTime',
  DeleteTime = 'deleteTime',
  LastViewTime = 'lastViewTime',
  Name = 'name',
  Unknown = 'unknown',
  UpdateTime = 'updateTime'
}

export enum ProjectTemplateOrigin {
  Global = 'Global',
  Project = 'Project'
}

export type PublicUserProfile = {
  __typename?: 'PublicUserProfile';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  craftMachines?: Maybe<CraftMachineListResponse>;
  displayName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  following: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isBanned?: Maybe<Scalars['Boolean']['output']>;
  isCreativeFabrica?: Maybe<Scalars['Boolean']['output']>;
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  isPremium?: Maybe<Scalars['Boolean']['output']>;
  isProfilePublic?: Maybe<Scalars['Boolean']['output']>;
  isTemporary: Scalars['Boolean']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location: UserLocation;
  profileUrls?: Maybe<PublicUserProfileUrls>;
  shopName?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  socialMediaAccounts?: Maybe<Array<PublicUserProfileSocialMediaAccount>>;
  superSkill?: Maybe<Scalars['String']['output']>;
};

export type PublicUserProfileSocialMediaAccount = {
  __typename?: 'PublicUserProfileSocialMediaAccount';
  type: PublicUserProfileSocialMediaAccountType;
  url?: Maybe<Scalars['String']['output']>;
};

export enum PublicUserProfileSocialMediaAccountType {
  Behance = 'behance',
  Dribbble = 'dribbble',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Pinterest = 'pinterest',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Youtube = 'youtube'
}

export enum PublicUserProfileUrlType {
  Crafter = 'Crafter',
  Designer = 'Designer',
  Teacher = 'Teacher',
  TheArtistry = 'TheArtistry'
}

export type PublicUserProfileUrls = {
  __typename?: 'PublicUserProfileUrls';
  crafter?: Maybe<Scalars['String']['output']>;
  designer?: Maybe<Scalars['String']['output']>;
  teacher?: Maybe<Scalars['String']['output']>;
  theArtistry?: Maybe<Scalars['String']['output']>;
};

export type PublishedTemplate = {
  __typename?: 'PublishedTemplate';
  category: Scalars['String']['output'];
  createTime: Scalars['String']['output'];
  createdBy: PublicUserProfile;
  engine: PublishedTemplateEngine;
  feature: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  pricingMode: PublishedTemplatePricingMode;
  styles: Array<Scalars['String']['output']>;
  subcategory: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  themes: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  topic: Scalars['String']['output'];
  type: PublishedTemplateType;
  width: Scalars['Int']['output'];
};

export enum PublishedTemplateEngine {
  Fabric = 'fabric',
  Polotno = 'polotno',
  Unspecified = 'unspecified'
}

export enum PublishedTemplatePricingMode {
  Free = 'free',
  Paid = 'paid',
  Unspecified = 'unspecified'
}

export enum PublishedTemplateType {
  Graphic = 'graphic',
  Unspecified = 'unspecified'
}

export type PublishedTemplatesAddFavoriteInput = {
  templateId: Scalars['ID']['input'];
};

export type PublishedTemplatesAddFavoriteResponse = {
  __typename?: 'PublishedTemplatesAddFavoriteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type PublishedTemplatesFavoritedInput = {
  templateId: Scalars['ID']['input'];
};

export type PublishedTemplatesFavoritedResponse = {
  __typename?: 'PublishedTemplatesFavoritedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  favorited: Scalars['Boolean']['output'];
};

export type PublishedTemplatesListFavoritesInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
};

export type PublishedTemplatesListFavoritesResponse = {
  __typename?: 'PublishedTemplatesListFavoritesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<PublishedTemplatesPagination>;
  templates?: Maybe<Array<PublishedTemplate>>;
};

export type PublishedTemplatesPagination = {
  __typename?: 'PublishedTemplatesPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PublishedTemplatesRemoveFavoriteInput = {
  templateId: Scalars['ID']['input'];
};

export type PublishedTemplatesRemoveFavoriteResponse = {
  __typename?: 'PublishedTemplatesRemoveFavoriteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type PublisherCreateTemplateSubmissionInput = {
  imageFileUrl: Scalars['String']['input'];
  jsonFileUrl: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type PublisherCreateTemplateSubmissionResponse = {
  __typename?: 'PublisherCreateTemplateSubmissionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
};

export type PublisherDeleteTemplateSubmissionInput = {
  id: Scalars['String']['input'];
};

export type PublisherDeleteTemplateSubmissionResponse = {
  __typename?: 'PublisherDeleteTemplateSubmissionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type PublisherFinaliseTemplateSubmissionInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherFinaliseTemplateSubmissionResponse = {
  __typename?: 'PublisherFinaliseTemplateSubmissionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type PublisherRegenerateTemplateSubmissionFieldsInput = {
  id: Scalars['String']['input'];
};

export type PublisherRegenerateTemplateSubmissionFieldsResponse = {
  __typename?: 'PublisherRegenerateTemplateSubmissionFieldsResponse';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ErrorMessage>>;
  reachedMaxSuggestions?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublisherTemplateSubmissionInput = {
  id: Scalars['ID']['input'];
};

export type PublisherTemplateSubmissionResponse = {
  __typename?: 'PublisherTemplateSubmissionResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  template?: Maybe<TemplateSubmission>;
};

export type PublisherTemplateSubmissionUpdatedResponse = {
  __typename?: 'PublisherTemplateSubmissionUpdatedResponse';
  template?: Maybe<TemplateSubmission>;
};

export type PublisherTemplatesSubmissionsInput = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<TemplateSubmissionStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PublisherTemplatesSubmissionsResponse = {
  __typename?: 'PublisherTemplatesSubmissionsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  templates?: Maybe<Array<TemplateSubmission>>;
};

export type PublisherUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String']['input'];
};

export type PublisherUploadsCreateSignedUrlResponse = {
  __typename?: 'PublisherUploadsCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  advertisingGetCampaign: AdvertisingGetCampaignResponse;
  advertisingGetRandomNCampaigns: AdvertisingGetRandomNCampaignsResponse;
  advertisingGetTotalActionsByMonth: AdvertisingGetTotalActionsByMonthResponse;
  advertisingGetUploaded: AdvertisingGetUploadedResponse;
  advertisingListCampaign: AdvertisingListCampaignResponse;
  /** @deprecated Use coinsProductTransactions instead */
  allCoinTransactionsForProductId: CoinTransactionsResponseByProduct;
  askCFDiscoveryFeed: AskCfFeedResponse;
  askCFFollowedQuestionsFeed: AskCfFeedResponse;
  askCFFollowingFeed: AskCfFeedResponse;
  askCFGetGivenTopics: AskGetGivenTopicsResponse;
  askCFGetLatestQuestions: AskCfGetLatestQuestionsResponse;
  askCFGetQuestion: AskCfGetQuestionResponse;
  askCFGetQuestionPartialThread: AskCfGetQuestionPartialThreadResponse;
  askCFGetTopic: AskGetTopicResponse;
  askCFGetTopics: AskGetTopicsResponse;
  askCFGetUploaded: AskCfGetUploadedResponse;
  askCFGetUserDigestStatus: AskGetUserDigestStatusResponse;
  askCFGetUserStats: AskGetUserStatsResponse;
  /** @deprecated Use askCFDiscoveryFeed or askCFFollowingFeed instead */
  askCFHomeFeed: AskCfFeedResponse;
  askCFListComments: AskCfListCommentsResponse;
  askCFTopicFeed: AskCfFeedResponse;
  askCFUserAnsweredFeed: AskCfFeedResponse;
  askCFUserFeed: AskCfFeedResponse;
  cachedSiteData: SiteData;
  calculatePrices: PriceCalculationsResponse;
  cfmainAreUserFavorites: Array<CfMainIsUserFavorite>;
  cfmainGetEnterpriseRequest: CfMainGetEnterpriseRequestResponse;
  cfmainListEnterpriseRequests: CfMainListEnterpriseRequestsResponse;
  cfmainProductsFavoritesCount: CfMainProductsFavoritesCount;
  cfmainTopFollowed: Array<Scalars['Int']['output']>;
  chipsForImage: Array<Scalars['String']['output']>;
  chipsForPrompt: Array<Scalars['String']['output']>;
  clubhouseListPendingInvitations: ClubhouseListPendingInvitationResponse;
  clubhousesCommunityLeaderStatus: ClubhousesCommunityLeaderStatusResponse;
  clubhousesFriendsList: ClubhouseFriendsListResponse;
  clubhousesFromUser: ClubhousesFomUserResponse;
  clubhousesGetComment: ClubhousesGetCommentResponse;
  clubhousesGetDetails: GetClubhouseResponse;
  clubhousesGetDiscussion: ClubhousesGetDiscussionResponse;
  clubhousesGetDiscussionCommentThread: ClubhousesGetDiscussionCommentThreadResponse;
  clubhousesGetDiscussionReplies: ClubhousesGetDiscussionRepliesResponse;
  clubhousesGetDiscussionsByIds: ClubhousesGetDiscussionsByIdsResponse;
  clubhousesGetNotificationSettings: ClubhouseGetNotificationSettingsResponse;
  clubhousesGetSubscriberCount: ClubhousesGetSubscriberCountResponse;
  clubhousesGetTopCommentedThreads: ClubhousesGetTopCommentedThreadsResponse;
  clubhousesGetUploaded: ClubhousesGetUploadedResponse;
  clubhousesGetUserStats: ClubhousesGetUserStatsResponse;
  clubhousesIsClubhouseMember: ClubhouseIsMemberResponse;
  clubhousesIsSubscribedToDigest: IsSubscribedToDigestResponse;
  clubhousesListAll: ClubhousesListResponse;
  clubhousesListCommunityLeaders: ClubhousesCommunityLeadersListResponse;
  clubhousesListMembers: MembersListResponse;
  clubhousesListTopDiscussions: ClubhousesTopDiscussionsListResponse;
  clubhousesListTopicDiscussions: ClubhousesTopicDiscussionsListResponse;
  clubhousesListTopics: ClubhousesTopicsListResponse;
  clubhousesTopicsGetDetails: GetClubhouseTopicResponse;
  clubhousesUser?: Maybe<ClubhousesUserResponse>;
  clubhousesUsersBatch?: Maybe<ClubhousesUsersBatchResponse>;
  coinActionFees: CoinsActionFeesResponse;
  coinEarnAmounts: CoinsEarnAmountResponse;
  coins: CoinWallet;
  coinsBundles: CoinsBundlesResponse;
  coinsDownloads: CoinsDownloadsResponse;
  coinsIsStudioAISubscriptionMandatory: CoinsIsStudioAiSubscriptionMandatoryResponse;
  coinsPopularProducts: CoinsPopularResponse;
  coinsProductTransactions: CoinTransactionsResponseByProduct;
  coinsSettings: CoinSettings;
  coinsSpentForUser: CoinsSpentForUserResponse;
  coinsTransactionForProductId: CoinTransactionResponse;
  coinsTransactions: CoinTransactionsResponse;
  coinsTransactionsForUser: CoinTransactionsResponse;
  contentCountFavorites: ContentProductFavoriteCount;
  contentCountUserReviewsToday: Scalars['Int']['output'];
  contentDownloadAssets: Array<AssetDownloadResponse>;
  /**
   * Allows the download of one or more assets uniquely identify by their asset id.
   *     By default this query will not increase the download count on those products  you should use
   *     the "contentIncreaseDownloadCountV2" mutation for that.
   */
  contentDownloadAssetsV2?: Maybe<AssetsDownloadResponseV2>;
  contentFetchCategory: ContentCategory;
  contentFetchLicense?: Maybe<ContentLicense>;
  contentFetchReview: ContentReview;
  contentIsProductFavorited: Scalars['Boolean']['output'];
  contentLicenseCount: Scalars['Int']['output'];
  contentLinkBlock?: Maybe<ContentLinkBlock>;
  contentListFavoriteLists: Array<ContentFavoriteList>;
  contentListFavorites: Array<ContentFavorite>;
  /** @deprecated Use contentListProductsV2 instead */
  contentListProducts: ContentPagination;
  contentListProductsV2: ContentPaginationV2;
  contentMyReview?: Maybe<ContentReview>;
  contentProduct?: Maybe<ContentProduct>;
  contentProductAssets: Array<ContentAsset>;
  contentProductLicense?: Maybe<ContentLicense>;
  contentProductPublicAssets: Array<ContentAsset>;
  contentProductReviews: ContentProductReviews;
  contentProductStats: ContentProductStats;
  contentSearchCategory: Array<ContentCategory>;
  contentUserFavoritesCount: ContentUserListFavoritesCount;
  contentUserListFavorites: ContentUserListFavorites;
  currentSubscription?: Maybe<UserSubscription>;
  designReviewerGetReview: DesignReviewerGetReviewResponse;
  designReviewerListReviews: DesignReviewerListReviewsResponse;
  entityReactions: EntityReactionsResponse;
  flow?: Maybe<Flow>;
  flowFeed: FlowFeed;
  flowFeedStatus: Array<FlowStatus>;
  flowGenerationsCount: FlowGenerationsCountResponse;
  flowGetIterationPageRating: FlowGetIterationPageRatingResponse;
  flowImage: FlowImageResponse;
  flowImageFlow: FlowImageFlowResponse;
  flowImageGetFavorites: FlowImageGetFavoritesResponse;
  flowImageGetReactions: FlowImageGetReactionsResponse;
  flowImagesTop: FlowImagesTopResponse;
  flowImagesTopAllTime: FlowImagesTopAllTimeResponse;
  flowIterationPages: FlowIterationPagesResponse;
  flowMostLikedFlows: Array<Scalars['String']['output']>;
  flowMostViewedFlows: Array<Scalars['String']['output']>;
  flowQueue: Scalars['Int']['output'];
  flowStatus: FlowStatus;
  flowViewers: FlowViewersResponse;
  /** @deprecated Use flowsUserFlows */
  flows: Array<Flow>;
  flowsPreviewUserFlows: FlowsPreviewUserFlowsResponse;
  /** @deprecated use font fontGeneratorUserFont */
  fontGeneratorFont: FontGeneratorFontResponse;
  /** @deprecated use font fontGeneratorUserFonts */
  fontGeneratorFonts: FontGeneratorFontsResponse;
  /** @deprecated use fontsFeed */
  fontGeneratorFontsFeed: FontGeneratorFontsFeedResponse;
  fontGeneratorUserFont: FontGeneratorUserFontResponse;
  fontGeneratorUserFonts: FontGeneratorUserFontsResponse;
  fontsFeed: FontsFeedResponse;
  fontsFeedFont: FontsFeedFontResponse;
  fontsFeedFontBrowser: FontsFeedFontBrowserResponse;
  /**
   * Get the admin dashboard menu structure with access flags for the current user.
   * Requires authentication via cookies and appropriate admin/team role.
   * Returns 401 if not authenticated, 403 if user lacks admin dashboard access.
   */
  getAdminDashboardMenu: GetAdminDashboardMenuResponse;
  /**
   * Get downloadable files for a product.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  getAdminProductFiles: GetAdminProductFilesResponse;
  /**
   * Get operation history for a product.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  getAdminProductHistory: GetAdminProductHistoryResponse;
  /**
   * Get images for a product.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  getAdminProductImages: GetAdminProductImagesResponse;
  /**
   * Get product information for the admin product manager.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  getAdminProductInfo: GetAdminProductInfoResponse;
  /**
   * Get admin notes for a product with pagination.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  getAdminProductNotes: GetAdminProductNotesResponse;
  /**
   * Get product removal reasons for the remove product form.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  getAdminProductRemovalReasons: GetAdminProductRemovalReasonsResponse;
  /**
   * Get problem/copyright reports for a product with pagination.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  getAdminProductReports: GetAdminProductReportsResponse;
  /**
   * Search products by title for admin dashboard autocomplete.
   * Requires authentication and dashboard_general or dashboard_external capability.
   * Returns up to 50 published products.
   */
  getAdminProductSearch: GetAdminProductSearchResponse;
  /**
   * Get tags for a product.
   * Requires authentication and dashboard_general or dashboard_external capability.
   */
  getAdminProductTags: GetAdminProductTagsResponse;
  /**
   * Search users by email or display name for admin dashboard autocomplete.
   * Requires authentication and dashboard_general or dashboard_external capability.
   * Returns up to 50 results.
   */
  getAdminUserSearch: GetAdminUserSearchResponse;
  getCategoryProducts: GetContentCategoryProductsResponse;
  getClassesPreviewInfo: GetClassesPreviewInfoResponse;
  getCoreFlags: GetCoreFlagsResponse;
  getCraftMachineById: CraftMachineGetResponse;
  getCraftMaterialById: CraftMaterialGetResponse;
  getCraftThemeById: CraftThemesGetResponse;
  /**
   * Get the current designer's "About Your Store" content. Requires authentication
   * via cookies and designer role. Part of Designer & Admin dashboards migration.
   */
  getDesignerAboutStore: GetDesignerAboutStoreResponse;
  /**
   * Get the current designer's favorites count. Requires authentication
   * via cookies and designer role. Part of Designer & Admin dashboards migration.
   */
  getDesignerFavoritesCount: GetDesignerFavoritesCountResponse;
  /**
   * Get the current designer's identity verification status. Requires authentication
   * via cookies and designer role. Part of Designer & Admin dashboards migration.
   */
  getDesignerIdentityVerificationStatus: GetDesignerIdentityVerificationStatusResponse;
  /**
   * Get the current designer's promotion settings. Requires authentication
   * via cookies and designer role. Part of Designer & Admin dashboards migration.
   */
  getDesignerPromotionSettings: GetDesignerPromotionSettingsResponse;
  /**
   * Get the current designer's shop banner information. Requires authentication
   * via cookies and designer role. Part of Designer & Admin dashboards migration.
   */
  getDesignerShopBanner: GetDesignerShopBannerResponse;
  /**
   * Get the current designer's total lifetime earnings. Requires authentication
   * via cookies and designer role. Part of Designer & Admin dashboards migration.
   */
  getDesignerTotalEarnings: GetDesignerTotalEarningsResponse;
  getDesignerVerificationStatus: GetDesignerVerificationStatusResponse;
  /**
   * Get the current designer's wallet information. Requires authentication
   * via cookies and designer role. Part of Designer & Admin dashboards migration.
   */
  getDesignerWallet: GetDesignerWalletResponse;
  getDesignersPreviewInfo: GetDesignersPreviewInfoResponse;
  getFreebiesPageData: GetFreebiesPageDataResponse;
  getMyAccountBillingDetails: GetMyAccountBillingDetailsResponse;
  getMyAccountEditEmailPasswordContext: GetMyAccountEditEmailPasswordContextResponse;
  getMyAccountProfileSettings: GetMyAccountProfileSettingsResponse;
  getMyAccountUserDob: GetMyAccountUserDobResponse;
  getMyAccountUserProfile: GetMyAccountUserProfileResponse;
  getRedeemReward: RedeemReward;
  getUserSubscription: GetUserSubscriptionResponse;
  halloweenSubscriptionPurchase?: Maybe<HalloweenSubscriptionPurchase>;
  helpConversation?: Maybe<HelpConversation>;
  helpWelcomeMessage: Scalars['String']['output'];
  isPropertyEnabled: IsPropertyEnabled;
  isUploadAllowed: IsUploadAllowedResponse;
  legacyProductsFetchLicense?: Maybe<LegacyLicense>;
  legacyProductsFetchProduct?: Maybe<LegacyProduct>;
  legacyProductsFetchProducts: Array<LegacyProduct>;
  legacyProductsListPPEProducts: LegacyPpeResponse;
  legacyProductsListUserFavorites: Array<LegacyProduct>;
  listAccountNotices: ListAccountNoticesResponse;
  listCraftMachines: CraftMachineListResponse;
  listCraftMachinesForUser: CraftMachineListResponse;
  listCraftMaterials: CraftMaterialsListResponse;
  listCraftThemes: CraftThemesListResponse;
  listCraftingTypesForUser: CraftingTypesListResponse;
  listDailyGifts: ListDailyGiftsResponse;
  listMyAccountDownloadsLicKeys: ListMyAccountDownloadsLicKeysResponse;
  listMyAccountNotificationSettings: ListMyAccountNotificationSettingsResponse;
  listMyClasses: ListMyClassesResponse;
  listRedeemedCodes: Array<RedeemCode>;
  /** Lists linked social accounts. origin selects the return URL on unlink links. */
  listSocialLoginAccounts: ListSocialLoginAccountsResponse;
  listUserActivity: ListUserActivityResponse;
  listUserOrders: ListUserOrdersResponse;
  listUserSubscriptions: ListUserSubscriptionsResponse;
  marketplaceListProducts: MarketplaceListProductsResponse;
  marketplaceListPromoProducts: MarketplaceListPromoProductsResponse;
  me?: Maybe<AuthResponse>;
  /** @deprecated Use flowMostLikedFlows */
  mostLikedFlows: Array<Scalars['String']['output']>;
  /** @deprecated Use flowMostViewedFlows */
  mostViewedFlows: Array<Scalars['String']['output']>;
  paymentsAllowedPaymentMethodTypes: AllowedPaymentMethodTypesResponse;
  paymentsCalculateTax: PaymentTotals;
  paymentsCustomer: PaymentsCustomerResponse;
  paymentsPreviewSubscriptionTotals: PreviewSubscriptionTotalsResponse;
  paymentsStripeSubscriptionExtensionInfo?: Maybe<StripeSubscriptionExtensionInfo>;
  paymentsStripeSubscriptionIdToExtend?: Maybe<Scalars['String']['output']>;
  paymentsStripeSubscriptionIdToUpgrade?: Maybe<Scalars['String']['output']>;
  paymentsSubscription: PaymentsSubscriptionResponse;
  physicalProductGet: PhysicalProductGetResponse;
  physicalProductOpenOrderSearch: PhysicalProductOpenOrderSearchResponse;
  printOnDemandGetShippingAddress: PrintOnDemandShippingAddressGetResponse;
  /** Provides the query that can be used to retrieve the asset with the background removed for the specified product. */
  productsDownloadContentWithBackgroundRemoved: ProductsDownloadContentWithBackgroundRemovedResponse;
  publicUserProfile: PublicUserProfile;
  publicUserProfileById: PublicUserProfile;
  publishedTemplatesFavorited: PublishedTemplatesFavoritedResponse;
  publishedTemplatesListFavorites: PublishedTemplatesListFavoritesResponse;
  publisherTemplateSubmission: PublisherTemplateSubmissionResponse;
  publisherTemplateSubmissions: PublisherTemplatesSubmissionsResponse;
  searchPrompts: SearchPromptsResponse;
  siteData: SiteData;
  snippetsGetSnippet: SnippetsGetSnippetResponse;
  snippetsListSnippets: SnippetsListSnippetResponse;
  socialBlockUserList: SocialBlockUserListResponse;
  socialCuratedFeed: SocialCuratedFeedResponse;
  socialDiscoveryFeed: SocialFeedResponse;
  socialFollowersFeed: SocialFeedResponse;
  socialGetComment: SocialGetCommentResponse;
  socialGetEmailNotificationsSettings: SocialGetEmailNotificationsSettingsResponse;
  socialGetPost: SocialPostResponse;
  socialGetUploaded: SocialGetUploadedResponse;
  socialGetUsers: SocialGetUsersResponse;
  socialLatestDownloadImages: SocialLatestDownloadImagesResponse;
  socialListComments: SocialCommentsListResponse;
  socialListPostByProduct: SocialListPostByProductResponse;
  socialSavedFeed: SocialSavedFeedResponse;
  socialUserFeed: SocialFeedResponse;
  sparkArt: SparkArtGetResponse;
  sparkArtList: SparkArtListResponse;
  sparkCrystalline: SparkCrystallineGetResponse;
  sparkCrystallineList: SparkCrystallineListResponse;
  sparkGetUploaded: SparkGetUploadedResponse;
  sparkImageMixGet: SparkImageMixGetResponse;
  sparkImageMixList: SparkImageMixListResponse;
  sparkInpaintGet: SparkInpaintGetResponse;
  sparkInpaintList: SparkInpaintListResponse;
  sparkOutpaintGet: SparkOutpaintGetResponse;
  sparkOutpaintList: SparkOutpaintListResponse;
  sparkRemovedBackground: SparkRemoveBackgroundGetResponse;
  sparkRemovedBackgroundList: SparkRemovedBackgroundListResponse;
  storageInfo: StorageInfoResponse;
  studioAllSimpleComments: StudioSimpleCommentsResponse;
  studioCommentReactions: StudioCommentReactionsResponse;
  studioIsAllAccessUser: StudioIsAllAccessUserResponse;
  studioIsStudioAIUser: StudioIsAiStudioUserResponse;
  studioProjectDownloadAssets: StudioProjectDownloadAssetsResponse;
  studioProjectsFolderGet: StudioProjectsFolderGetResponse;
  studioProjectsGetProject: StudioProjectsGetProjectResponse;
  studioProjectsGetProjectComments: StudioProjectsGetProjectCommentsResponse;
  studioProjectsGetTeam: StudioProjectsGetTeamResponse;
  studioProjectsListItemsInTrash: StudioProjectsListItemsInTrashResponse;
  studioProjectsListMostRecent: StudioProjectsListMostRecentResponse;
  studioProjectsListProjects: StudioProjectsListProjectsResponse;
  studioProjectsListProjectsInTrash: StudioProjectsListProjectsInTrashResponse;
  studioProjectsListProjectsSharedWithMe: StudioProjectsListProjectsSharedWithMeResponse;
  studioSimpleCommentTaggableUsers: StudioSimpleCommentTaggableUsersResponse;
  studioSimpleComments: StudioSimpleCommentsResponse;
  studioTemplatesList: StudioTemplateListResponse;
  studioUploadsGetFolder: StudioUploadsGetFolderResponse;
  studioUploadsGetTagsForUploads: StudioUploadsGetTagsForUploadsResponse;
  studioUploadsSearchFiles: StudioUploadsSearchFilesResponse;
  studioUploadsTags: StudioUploadsTagsResponse;
  tagsGetProductTags: Array<Tag>;
  teamsFetchOutstandingInvoiceUrl: TeamsFetchOutstandingInvoiceUrlResponse;
  /** @deprecated Use teamsPreviewUpcomingCharges instead */
  teamsFetchUpcomingInvoiceUrl: TeamsFetchUpcomingInvoiceUrlResponse;
  teamsGet: TeamsGetTeamResponse;
  teamsPreviewUpcomingCharges: TeamsPreviewUpcomingChargesResponse;
  transfersGetTransfer: TransfersGetTransferResponse;
  transfersListTransfers: ListTransfersResponse;
  undoCancelSubscription: UndoCancelSubscriptionResponse;
  uploadedFontsSearch: UploadedFontsSearchResponse;
  upscalerImage: UpscalerGetImageResponse;
  upscalerImages: UpscalerImagesResponse;
  user?: Maybe<User>;
  userBalance: UserBalance;
  userCheckEarlyTrialCancel?: Maybe<UserCheckEarlyTrialCancelResponse>;
  userFollowers?: Maybe<UserFollowersResponse>;
  userFollowersCount?: Maybe<UserFollowersCountResponse>;
  userFollowing?: Maybe<UserFollowingResponse>;
  userListLegacyAndContentFavoriteProducts: Array<UserListFavoriteProduct>;
  usersBanStatusForCurrentUser: UsersBanResponse;
  usersBanStatusForUser: UsersBanResponse;
  usersCheckFollowing: Scalars['Boolean']['output'];
  usersEligibleForDeletion?: Maybe<UserEligibleForDeletionResponse>;
  usersLocation: UserLocationResponse;
  usersManageSubscription: UsersManageSubscriptionResponse;
  usersShippingAddress: UserShippingAddressResponse;
  validateToken?: Maybe<ValidateTokenResponse>;
  vectorizerGetImage: VectorizerGetImageResponse;
  /** @deprecated Use vectorizerListImagesV2 instead */
  vectorizerListImages: VectorizerListImagesResponse;
  vectorizerListImagesV2: VectorizerListImagesV2Response;
};


export type QueryAdvertisingGetCampaignArgs = {
  input: AdvertisingGetCampaignInput;
};


export type QueryAdvertisingGetRandomNCampaignsArgs = {
  input?: InputMaybe<AdvertisingGetRandomNCampaignsInput>;
};


export type QueryAdvertisingGetTotalActionsByMonthArgs = {
  input: AdvertisingGetTotalActionsByMonthInput;
};


export type QueryAdvertisingGetUploadedArgs = {
  input: AdvertisingGetUploadedInput;
};


export type QueryAdvertisingListCampaignArgs = {
  input: AdvertisingListCampaignInput;
};


export type QueryAllCoinTransactionsForProductIdArgs = {
  productId: Scalars['String']['input'];
};


export type QueryAskCfDiscoveryFeedArgs = {
  input: AskCfDiscoveryFeedInput;
};


export type QueryAskCfFollowedQuestionsFeedArgs = {
  input: AskCfFollowedQuestionsInput;
};


export type QueryAskCfFollowingFeedArgs = {
  input: AskCfFollowingFeedInput;
};


export type QueryAskCfGetGivenTopicsArgs = {
  input: AskCfGetGivenTopicsInput;
};


export type QueryAskCfGetLatestQuestionsArgs = {
  input: AskCfGetLatestQuestionsInput;
};


export type QueryAskCfGetQuestionArgs = {
  input: AskCfGetQuestionInput;
};


export type QueryAskCfGetQuestionPartialThreadArgs = {
  input: AskCfGetQuestionPartialThreadInput;
};


export type QueryAskCfGetTopicArgs = {
  input: AskCfGetTopicInput;
};


export type QueryAskCfGetUploadedArgs = {
  input: AskCfGetUploadedInput;
};


export type QueryAskCfGetUserStatsArgs = {
  input: AskCfGetUserStatsInput;
};


export type QueryAskCfHomeFeedArgs = {
  input: AskCfHomeFeedInput;
};


export type QueryAskCfListCommentsArgs = {
  input: AskCfListCommentsInput;
};


export type QueryAskCfTopicFeedArgs = {
  input: AskCfTopicFeedInput;
};


export type QueryAskCfUserAnsweredFeedArgs = {
  input: AskCfUserAnsweredFeedInput;
};


export type QueryAskCfUserFeedArgs = {
  input: AskCfUserFeedInput;
};


export type QueryCachedSiteDataArgs = {
  language?: InputMaybe<Language>;
};


export type QueryCalculatePricesArgs = {
  input: CalculatePricesInput;
};


export type QueryCfmainAreUserFavoritesArgs = {
  productIDs: Array<Scalars['Int']['input']>;
};


export type QueryCfmainGetEnterpriseRequestArgs = {
  input: CfMainGetEnterpriseRequestInput;
};


export type QueryCfmainListEnterpriseRequestsArgs = {
  input: CfMainListEnterpriseRequestsInput;
};


export type QueryCfmainProductsFavoritesCountArgs = {
  productIds: Array<Scalars['Int']['input']>;
};


export type QueryCfmainTopFollowedArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryChipsForImageArgs = {
  imageUrl: Scalars['String']['input'];
};


export type QueryChipsForPromptArgs = {
  prompt: Scalars['String']['input'];
};


export type QueryClubhouseListPendingInvitationsArgs = {
  input: ClubhouseListPendingInvitationInput;
};


export type QueryClubhousesCommunityLeaderStatusArgs = {
  input: ClubhousesCommunityLeaderStatusInput;
};


export type QueryClubhousesFriendsListArgs = {
  input: ClubhouseFriendsListInput;
};


export type QueryClubhousesFromUserArgs = {
  input: ClubhousesFromUserInput;
};


export type QueryClubhousesGetCommentArgs = {
  input: ClubhousesGetCommentInput;
};


export type QueryClubhousesGetDetailsArgs = {
  input: GetClubhouseInput;
};


export type QueryClubhousesGetDiscussionArgs = {
  input: ClubhousesGetDiscussionInput;
};


export type QueryClubhousesGetDiscussionCommentThreadArgs = {
  input: ClubhousesGetDiscussionCommentThreadInput;
};


export type QueryClubhousesGetDiscussionRepliesArgs = {
  input: ClubhousesGetDiscussionRepliesInput;
};


export type QueryClubhousesGetDiscussionsByIdsArgs = {
  input: ClubhousesGetDiscussionsByIdsInput;
};


export type QueryClubhousesGetNotificationSettingsArgs = {
  input: ClubhouseGetNotificationSettingsInput;
};


export type QueryClubhousesGetSubscriberCountArgs = {
  input: ClubhousesGetSubscriberCountInput;
};


export type QueryClubhousesGetTopCommentedThreadsArgs = {
  input: ClubhousesGetTopCommentedThreadsInput;
};


export type QueryClubhousesGetUploadedArgs = {
  input: ClubhousesGetUploadedInput;
};


export type QueryClubhousesGetUserStatsArgs = {
  input: ClubhousesGetUserStatsInput;
};


export type QueryClubhousesIsClubhouseMemberArgs = {
  input: ClubhouseIsMemberInput;
};


export type QueryClubhousesIsSubscribedToDigestArgs = {
  input: IsSubscribedToDigestInput;
};


export type QueryClubhousesListAllArgs = {
  input: ClubhousesListInput;
};


export type QueryClubhousesListCommunityLeadersArgs = {
  input: ClubhousesCommunityLeadersListInput;
};


export type QueryClubhousesListMembersArgs = {
  input: MembersListInput;
};


export type QueryClubhousesListTopDiscussionsArgs = {
  input: ClubhousesTopDiscussionsListInput;
};


export type QueryClubhousesListTopicDiscussionsArgs = {
  input: ClubhousesTopicDiscussionsListInput;
};


export type QueryClubhousesListTopicsArgs = {
  input: ClubhousesTopicsListInput;
};


export type QueryClubhousesTopicsGetDetailsArgs = {
  input: GetClubhouseTopicInput;
};


export type QueryClubhousesUserArgs = {
  input: ClubhousesUserInput;
};


export type QueryClubhousesUsersBatchArgs = {
  input: ClubhousesUsersBatchInput;
};


export type QueryCoinsDownloadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CoinsDownloadsOrderBy>;
};


export type QueryCoinsProductTransactionsArgs = {
  productId: Scalars['String']['input'];
};


export type QueryCoinsSpentForUserArgs = {
  startDate: Scalars['String']['input'];
  userID: Scalars['ID']['input'];
};


export type QueryCoinsTransactionForProductIdArgs = {
  productId: Scalars['String']['input'];
};


export type QueryCoinsTransactionsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCoinsTransactionsForUserArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryContentCountFavoritesArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryContentDownloadAssetsArgs = {
  ids: Array<Scalars['ID']['input']>;
  source?: InputMaybe<ContentDownloadSource>;
};


export type QueryContentDownloadAssetsV2Args = {
  input: ContentDownloadAssetsInput;
};


export type QueryContentFetchCategoryArgs = {
  id: Scalars['ID']['input'];
  language: ContentLanguage;
};


export type QueryContentFetchLicenseArgs = {
  input: ContentFetchLicenseInput;
};


export type QueryContentFetchReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentIsProductFavoritedArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryContentLicenseCountArgs = {
  currentSubscriptionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeFree?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentLinkBlockArgs = {
  id: Scalars['ID']['input'];
  language: ContentLanguage;
};


export type QueryContentListFavoriteListsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentListFavoritesArgs = {
  input?: InputMaybe<ContentListFavoritesInput>;
};


export type QueryContentListProductsArgs = {
  categoryId: Scalars['ID']['input'];
  language: ContentLanguage;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
  type: ContentPaginationType;
};


export type QueryContentListProductsV2Args = {
  categoryId: Scalars['ID']['input'];
  language: ContentLanguage;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
  type: ContentPaginationType;
};


export type QueryContentMyReviewArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryContentProductArgs = {
  id: Scalars['ID']['input'];
  increaseViewCount?: InputMaybe<Scalars['Boolean']['input']>;
  language: ContentLanguage;
};


export type QueryContentProductAssetsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentProductLicenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentProductPublicAssetsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentProductReviewsArgs = {
  input: ContentProductReviewsInput;
};


export type QueryContentProductStatsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentSearchCategoryArgs = {
  allLevels?: InputMaybe<Scalars['Boolean']['input']>;
  language: ContentLanguage;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentUserFavoritesCountArgs = {
  input?: InputMaybe<ContentUserFavoritesCountInput>;
};


export type QueryContentUserListFavoritesArgs = {
  input?: InputMaybe<ContentUserListFavoritesInput>;
};


export type QueryDesignReviewerGetReviewArgs = {
  input: DesignReviewerGetReviewInput;
};


export type QueryDesignReviewerListReviewsArgs = {
  input: DesignReviewerListReviewsInput;
};


export type QueryEntityReactionsArgs = {
  input?: InputMaybe<EntityReactionsInput>;
};


export type QueryFlowArgs = {
  id: Scalars['String']['input'];
  iterations?: InputMaybe<FlowIterationsInput>;
};


export type QueryFlowFeedArgs = {
  afterId?: InputMaybe<Scalars['String']['input']>;
  includeNSFW?: InputMaybe<Scalars['Boolean']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFlowGetIterationPageRatingArgs = {
  input: FlowGetIterationPageRatingInput;
};


export type QueryFlowImageArgs = {
  input: FlowImageInput;
};


export type QueryFlowImageFlowArgs = {
  input: FlowImageFlowInput;
};


export type QueryFlowImageGetFavoritesArgs = {
  input: FlowImageGetFavoritesInput;
};


export type QueryFlowImageGetReactionsArgs = {
  input: FlowImageGetReactionsInput;
};


export type QueryFlowImagesTopArgs = {
  input: FlowImagesTopInput;
};


export type QueryFlowImagesTopAllTimeArgs = {
  input: FlowImagesTopAllTimeInput;
};


export type QueryFlowIterationPagesArgs = {
  input?: InputMaybe<FlowIterationPagesInput>;
};


export type QueryFlowQueueArgs = {
  flowID: Scalars['String']['input'];
};


export type QueryFlowStatusArgs = {
  flowID: Scalars['ID']['input'];
};


export type QueryFlowViewersArgs = {
  flowID: Scalars['ID']['input'];
};


export type QueryFlowsArgs = {
  afterId?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};


export type QueryFlowsPreviewUserFlowsArgs = {
  input: FlowsPreviewUserFlowsInput;
};


export type QueryFontGeneratorFontArgs = {
  input: FontGeneratorFontInput;
};


export type QueryFontGeneratorFontsArgs = {
  input?: InputMaybe<FontGeneratorFontsInput>;
};


export type QueryFontGeneratorFontsFeedArgs = {
  input?: InputMaybe<FontGeneratorFontsFeedInput>;
};


export type QueryFontGeneratorUserFontArgs = {
  input: FontGeneratorUserFontInput;
};


export type QueryFontGeneratorUserFontsArgs = {
  input: FontGeneratorUserFontsInput;
};


export type QueryFontsFeedArgs = {
  input: FontsFeedInput;
};


export type QueryFontsFeedFontArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFontsFeedFontBrowserArgs = {
  input: FontsFeedFontBrowserInput;
};


export type QueryGetAdminProductFilesArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryGetAdminProductHistoryArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryGetAdminProductImagesArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryGetAdminProductInfoArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryGetAdminProductNotesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type QueryGetAdminProductReportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type QueryGetAdminProductSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryGetAdminProductTagsArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryGetAdminUserSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryGetCategoryProductsArgs = {
  input: GetContentCategoryProductsInput;
};


export type QueryGetClassesPreviewInfoArgs = {
  input?: InputMaybe<GetClassesPreviewInfoInput>;
};


export type QueryGetCraftMachineByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetCraftMaterialByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetCraftThemeByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetDesignerVerificationStatusArgs = {
  input?: InputMaybe<GetDesignerVerificationStatusInput>;
};


export type QueryGetDesignersPreviewInfoArgs = {
  input?: InputMaybe<GetDesignersPreviewInfoInput>;
};


export type QueryGetFreebiesPageDataArgs = {
  input?: InputMaybe<GetFreebiesPageDataInput>;
};


export type QueryGetMyAccountBillingDetailsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRedeemRewardArgs = {
  input: GetRedeemRewardInput;
};


export type QueryGetUserSubscriptionArgs = {
  input: GetUserSubscriptionInput;
};


export type QueryHelpConversationArgs = {
  channel: HelpChannel;
  conversationId: Scalars['ID']['input'];
};


export type QueryHelpWelcomeMessageArgs = {
  channel: HelpChannel;
  language?: InputMaybe<Language>;
};


export type QueryIsPropertyEnabledArgs = {
  input: IsPropertyEnabledInput;
};


export type QueryIsUploadAllowedArgs = {
  request?: InputMaybe<IsUploadAllowedRequest>;
};


export type QueryLegacyProductsFetchLicenseArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryLegacyProductsFetchProductArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLegacyProductsFetchProductsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLegacyProductsListPpeProductsArgs = {
  input?: InputMaybe<LegacyProductsListPpeProductsInput>;
};


export type QueryLegacyProductsListUserFavoritesArgs = {
  input?: InputMaybe<LegacyListUserFavoritesInput>;
};


export type QueryListCraftMachinesArgs = {
  input?: InputMaybe<ListCraftMachinesInput>;
};


export type QueryListCraftMachinesForUserArgs = {
  input: ListCraftMachinesForUserInput;
};


export type QueryListCraftMaterialsArgs = {
  input?: InputMaybe<ListCraftMaterialsInput>;
};


export type QueryListCraftThemesArgs = {
  input?: InputMaybe<ListCraftThemesInput>;
};


export type QueryListCraftingTypesForUserArgs = {
  input: ListCraftingTypesForUserInput;
};


export type QueryListMyAccountDownloadsLicKeysArgs = {
  input?: InputMaybe<ListMyAccountDownloadsLicKeysInput>;
};


export type QueryListMyClassesArgs = {
  input?: InputMaybe<ListMyClassesInput>;
};


export type QueryListRedeemedCodesArgs = {
  input: ListRedeemedCodesInput;
};


export type QueryListSocialLoginAccountsArgs = {
  origin?: InputMaybe<RegisterOrigin>;
};


export type QueryListUserActivityArgs = {
  input: ListUserActivityInput;
};


export type QueryListUserOrdersArgs = {
  input: ListUserOrdersInput;
};


export type QueryListUserSubscriptionsArgs = {
  input: ListUserSubscriptionsInput;
};


export type QueryMarketplaceListProductsArgs = {
  input: MarketplaceListProductsInput;
};


export type QueryMarketplaceListPromoProductsArgs = {
  input: MarketplaceListPromoProductsInput;
};


export type QueryPaymentsAllowedPaymentMethodTypesArgs = {
  input: AllowedPaymentMethodTypesInput;
};


export type QueryPaymentsCalculateTaxArgs = {
  address: AddressInput;
  currencyCode: AvailableCurrencyCode;
  euTaxId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<PaymentLineItemInput>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentsPreviewSubscriptionTotalsArgs = {
  input: PreviewSubscriptionTotalsInput;
};


export type QueryPaymentsStripeSubscriptionExtensionInfoArgs = {
  isPolling?: InputMaybe<Scalars['Boolean']['input']>;
  stripeAccount?: InputMaybe<StripeAccount>;
  stripeCustomerId: Scalars['String']['input'];
};


export type QueryPaymentsStripeSubscriptionIdToExtendArgs = {
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentsStripeSubscriptionIdToUpgradeArgs = {
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentsSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPhysicalProductGetArgs = {
  input: PhysicalProductGetInput;
};


export type QueryPhysicalProductOpenOrderSearchArgs = {
  input: PhysicalProductOpenOrderSearchInput;
};


export type QueryProductsDownloadContentWithBackgroundRemovedArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryPublicUserProfileArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicUserProfileByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedTemplatesFavoritedArgs = {
  input: PublishedTemplatesFavoritedInput;
};


export type QueryPublishedTemplatesListFavoritesArgs = {
  input: PublishedTemplatesListFavoritesInput;
};


export type QueryPublisherTemplateSubmissionArgs = {
  input: PublisherTemplateSubmissionInput;
};


export type QueryPublisherTemplateSubmissionsArgs = {
  input: PublisherTemplatesSubmissionsInput;
};


export type QuerySearchPromptsArgs = {
  input: SearchPromptsInput;
};


export type QuerySiteDataArgs = {
  source?: InputMaybe<Source>;
};


export type QuerySnippetsGetSnippetArgs = {
  input: SnippetsGetSnippetInput;
};


export type QuerySnippetsListSnippetsArgs = {
  input: SnippetsListSnippetInput;
};


export type QuerySocialBlockUserListArgs = {
  input: SocialBlockUserListInput;
};


export type QuerySocialCuratedFeedArgs = {
  input: SocialCuratedFeedInput;
};


export type QuerySocialDiscoveryFeedArgs = {
  input: SocialDiscoveryFeedInput;
};


export type QuerySocialFollowersFeedArgs = {
  input: SocialFollowersFeedInput;
};


export type QuerySocialGetCommentArgs = {
  input: SocialGetCommentInput;
};


export type QuerySocialGetPostArgs = {
  input: SocialGetPostInput;
};


export type QuerySocialGetUploadedArgs = {
  input: SocialGetUploadedInput;
};


export type QuerySocialGetUsersArgs = {
  input: SocialGetUsersInput;
};


export type QuerySocialListCommentsArgs = {
  input: SocialCommentsListInput;
};


export type QuerySocialListPostByProductArgs = {
  input: SocialListPostByProductInput;
};


export type QuerySocialSavedFeedArgs = {
  input: SocialSavedFeedInput;
};


export type QuerySocialUserFeedArgs = {
  input: SocialUserFeedInput;
};


export type QuerySparkArtArgs = {
  input: SparkArtGetInput;
};


export type QuerySparkArtListArgs = {
  input?: InputMaybe<SparkArtListInput>;
};


export type QuerySparkCrystallineArgs = {
  input: SparkCrystallineGetInput;
};


export type QuerySparkCrystallineListArgs = {
  input?: InputMaybe<SparkCrystallineListInput>;
};


export type QuerySparkGetUploadedArgs = {
  input: SparkGetUploadedInput;
};


export type QuerySparkImageMixGetArgs = {
  input: SparkImageMixGetInput;
};


export type QuerySparkImageMixListArgs = {
  input?: InputMaybe<SparkImageMixListInput>;
};


export type QuerySparkInpaintGetArgs = {
  input: SparkInpaintGetInput;
};


export type QuerySparkInpaintListArgs = {
  input?: InputMaybe<SparkInpaintListInput>;
};


export type QuerySparkOutpaintGetArgs = {
  input: SparkOutpaintGetInput;
};


export type QuerySparkOutpaintListArgs = {
  input?: InputMaybe<SparkOutpaintListInput>;
};


export type QuerySparkRemovedBackgroundArgs = {
  input: SparkRemoveBackgroundGetInput;
};


export type QuerySparkRemovedBackgroundListArgs = {
  input?: InputMaybe<SparkRemovedBackgroundListInput>;
};


export type QueryStorageInfoArgs = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStudioAllSimpleCommentsArgs = {
  input: StudioAllSimpleCommentsInput;
};


export type QueryStudioCommentReactionsArgs = {
  input: StudioCommentReactionsInput;
};


export type QueryStudioProjectDownloadAssetsArgs = {
  input: StudioProjectDownloadAssetsInput;
};


export type QueryStudioProjectsFolderGetArgs = {
  input: StudioProjectsFolderGetInput;
};


export type QueryStudioProjectsGetProjectArgs = {
  projectId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStudioProjectsGetProjectCommentsArgs = {
  input: StudioProjectsGetProjectCommentsInput;
};


export type QueryStudioProjectsGetTeamArgs = {
  input: StudioProjectsGetTeamInput;
};


export type QueryStudioProjectsListItemsInTrashArgs = {
  input: StudioProjectsListItemsInTrashInput;
};


export type QueryStudioProjectsListMostRecentArgs = {
  input: StudioProjectsListMostRecentInput;
};


export type QueryStudioProjectsListProjectsArgs = {
  input: StudioProjectsListProjectsInput;
};


export type QueryStudioProjectsListProjectsInTrashArgs = {
  input: StudioProjectsListProjectsInTrashInput;
};


export type QueryStudioProjectsListProjectsSharedWithMeArgs = {
  input: StudioProjectsListProjectsSharedWithMeInput;
};


export type QueryStudioSimpleCommentTaggableUsersArgs = {
  input: StudioSimpleCommentTaggableUsersInput;
};


export type QueryStudioSimpleCommentsArgs = {
  input: StudioSimpleCommentsInput;
};


export type QueryStudioTemplatesListArgs = {
  input: StudioTemplatesListInput;
};


export type QueryStudioUploadsGetFolderArgs = {
  input: StudioUploadsGetFolderInput;
};


export type QueryStudioUploadsGetTagsForUploadsArgs = {
  input: StudioUploadsGetTagsForUploadsInput;
};


export type QueryStudioUploadsSearchFilesArgs = {
  input?: InputMaybe<StudioUploadsSearchFilesInput>;
};


export type QueryStudioUploadsTagsArgs = {
  input?: InputMaybe<StudioUploadsTagsInput>;
};


export type QueryTagsGetProductTagsArgs = {
  input: GetProductTagsInput;
};


export type QueryTeamsFetchOutstandingInvoiceUrlArgs = {
  input: TeamsFetchOutstandingInvoiceUrlInput;
};


export type QueryTeamsFetchUpcomingInvoiceUrlArgs = {
  input: TeamsFetchUpcomingInvoiceUrlInput;
};


export type QueryTeamsGetArgs = {
  input: TeamsGetTeamInput;
};


export type QueryTeamsPreviewUpcomingChargesArgs = {
  input: TeamsPreviewUpcomingChargesInput;
};


export type QueryTransfersGetTransferArgs = {
  input: TransfersGetTransferInput;
};


export type QueryTransfersListTransfersArgs = {
  input: ListTransfersInput;
};


export type QueryUndoCancelSubscriptionArgs = {
  input: UndoCancelSubscriptionInput;
};


export type QueryUploadedFontsSearchArgs = {
  input?: InputMaybe<UploadedFontsSearchInput>;
};


export type QueryUpscalerImageArgs = {
  input: UpscalerGetImageInput;
};


export type QueryUpscalerImagesArgs = {
  input: UpscalerImagesInput;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserCheckEarlyTrialCancelArgs = {
  input?: InputMaybe<UserCheckEarlyTrialCancelInput>;
};


export type QueryUserFollowersArgs = {
  input?: InputMaybe<UserFollowersInput>;
};


export type QueryUserFollowersCountArgs = {
  input?: InputMaybe<UserFollowersCountInput>;
};


export type QueryUserFollowingArgs = {
  input?: InputMaybe<UserFollowersInput>;
};


export type QueryUserListLegacyAndContentFavoriteProductsArgs = {
  input: UsersListFavoriteProductsInput;
};


export type QueryUsersBanStatusForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsersCheckFollowingArgs = {
  input: UserCheckFollowingInput;
};


export type QueryUsersManageSubscriptionArgs = {
  subscriptionID: Scalars['String']['input'];
};


export type QueryVectorizerGetImageArgs = {
  input: VectorizerGetImageInput;
};


export type QueryVectorizerListImagesV2Args = {
  input: VectorizerListImagesInput;
};

export type Question = {
  __typename?: 'Question';
  answers?: Maybe<Array<Answer>>;
  assets?: Maybe<Array<AskCfAsset>>;
  context?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isFollowed: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  questionSlug: Scalars['String']['output'];
  topic: Scalars['String']['output'];
  topicClassifierTimeout: Scalars['Boolean']['output'];
  topicSlug: Scalars['String']['output'];
  totalAnswers: Scalars['Int']['output'];
  user: PublicUserProfile;
  /** @deprecated Use user field instead */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type RedeemCode = {
  __typename?: 'RedeemCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  provider: RedeemProvider;
};

export type RedeemInput = {
  code: Scalars['String']['input'];
  provider: RedeemProvider;
};

export enum RedeemProvider {
  Kreadoe = 'KREADOE'
}

export type RedeemReward = {
  __typename?: 'RedeemReward';
  downloadLinks: Array<RedeemRewardItem>;
};

export type RedeemRewardItem = {
  __typename?: 'RedeemRewardItem';
  downloadUrl: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RefreshTokenResponse = {
  __typename?: 'RefreshTokenResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  token?: Maybe<Scalars['String']['output']>;
};

export type RegisterInput = {
  deviceId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  origin?: InputMaybe<RegisterOrigin>;
  otp?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  referral_code?: InputMaybe<Scalars['String']['input']>;
  registrationSource?: InputMaybe<RegisterOrigin>;
  signIn?: InputMaybe<Scalars['Boolean']['input']>;
  terms: Scalars['Boolean']['input'];
};

export enum RegisterOrigin {
  Freemode = 'FREEMODE',
  Marketplace = 'MARKETPLACE',
  Studio = 'STUDIO',
  Team = 'TEAM'
}

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  challenge?: Maybe<AuthChallenge>;
  errors?: Maybe<Array<ErrorMessage>>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Input for removing a product. */
export type RemoveAdminProductInput = {
  /** Product ID */
  productId: Scalars['Int']['input'];
  /** Removal reason ID */
  reasonMain?: InputMaybe<Scalars['Int']['input']>;
  /** Removal reason text (detailed explanation for designer) */
  reasonText?: InputMaybe<Scalars['String']['input']>;
  /** Removal reason title (displayed in email) */
  reasonTitle?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send email notification to the designer */
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for removing a product. */
export type RemoveAdminProductResponse = {
  __typename?: 'RemoveAdminProductResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
};

export type RemoveBackgroundPublishImageInput = {
  id: Scalars['String']['input'];
};

export type RemoveBackgroundPublishImageResponse = {
  __typename?: 'RemoveBackgroundPublishImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  upload?: Maybe<StudioUploadsFile>;
};

export type ResetMyAccountEmailInput = {
  email: Scalars['String']['input'];
  /** Product surface the confirmation link should return to. Omitted keeps the marketplace account page. */
  origin?: InputMaybe<RegisterOrigin>;
};

export type ResetMyAccountEmailResponse = {
  __typename?: 'ResetMyAccountEmailResponse';
  error?: Maybe<ErrorGrowth>;
};

export type ResetPasswordInput = {
  /** Email address, or the login query param from the reset link. One of email or userId is required. */
  email?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  /** User id from the reset link. Used when the link has id and no login. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type ReviewAspect = {
  __typename?: 'ReviewAspect';
  feedback: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
};

export enum Role {
  Admin = 'Admin',
  Editor = 'Editor',
  NoAccess = 'NoAccess',
  Owner = 'Owner',
  Unknown = 'Unknown',
  Viewer = 'Viewer'
}

export enum RoleChangeStatus {
  AwaitingAdminApproval = 'AwaitingAdminApproval',
  Updated = 'Updated'
}

export type SeoData = {
  __typename?: 'SEOData';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SaveMyAccountNotificationSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type SaveMyAccountNotificationSettingsResponse = {
  __typename?: 'SaveMyAccountNotificationSettingsResponse';
  error?: Maybe<ErrorGrowth>;
};

export type SearchPromptResponse = {
  __typename?: 'SearchPromptResponse';
  flowID: Scalars['String']['output'];
  iterationID: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  publishTime: Scalars['DateTime']['output'];
  userID: Scalars['String']['output'];
};

export type SearchPromptsInput = {
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<SearchPromptsSort>;
  text: Scalars['String']['input'];
};

export type SearchPromptsResponse = {
  __typename?: 'SearchPromptsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  prompts?: Maybe<Array<SearchPromptResponse>>;
};

export type SearchPromptsSort = {
  direction: SortDirection;
  field: SearchPromptsSortField;
};

export enum SearchPromptsSortField {
  CreateTime = 'createTime',
  Reactions = 'reactions'
}

export type SetCoreFlagInput = {
  coreFlag: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type SetCoreFlagResponse = {
  __typename?: 'SetCoreFlagResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SetupIntent = {
  __typename?: 'SetupIntent';
  clientSecret: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SharedProjectsPagination = {
  __typename?: 'SharedProjectsPagination';
  currentPage: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SiteBannerCountdown = {
  __typename?: 'SiteBannerCountdown';
  text: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum SiteBannerType {
  AllAccess = 'all_access',
  AllAccessYearly = 'all_access_yearly',
  AllAccessYearlyExtend = 'all_access_yearly_extend',
  AllAccessYearlyTrial = 'all_access_yearly_trial',
  AwaitingRenewalConfirmation = 'awaiting_renewal_confirmation',
  CfPendingCancel = 'cf_pending_cancel',
  Classes = 'classes',
  Notification = 'notification',
  OnHoldSubscription = 'on_hold_subscription',
  PendingCancel = 'pending_cancel',
  SparkFreeTrial = 'spark_free_trial',
  StudioAiYearlyTrial = 'studio_ai_yearly_trial',
  Upsell = 'upsell',
  Verification = 'verification'
}

export type SiteCountdown = {
  __typename?: 'SiteCountdown';
  text: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SiteCurrencies = {
  __typename?: 'SiteCurrencies';
  activeCurrency: Currency;
  currencies: Array<Currency>;
};

export type SiteData = {
  __typename?: 'SiteData';
  allAccessBanner?: Maybe<AllAccessBanner>;
  allAccessYearlyBanner?: Maybe<AllAccessYearlyBanner>;
  allAccessYearlyExtendBanner?: Maybe<AllAccessYearlyExtendBanner>;
  allAccessYearlyTrialBanner?: Maybe<AllAccessYearlyTrialBanner>;
  awaitingRenewalConfirmationBanner?: Maybe<AwaitingRenewalConfirmationBanner>;
  billing: Scalars['Boolean']['output'];
  classesBanner?: Maybe<ClassesBanner>;
  currencies: SiteCurrencies;
  isExtensionPopupEnabled: IsPropertyEnabled;
  newsletterPopup?: Maybe<NewsletterPopup>;
  notificationBanner?: Maybe<NotificationBanner>;
  notificationPopup?: Maybe<NotificationPopup>;
  onHoldSubscriptionBanner?: Maybe<OnHoldSubscriptionBanner>;
  productCounts: ProductCounts;
  profileNudgePopup?: Maybe<ProfileNudgePopup>;
  promo: SitePromotions;
  sparkFreeTrialBanner?: Maybe<SparkFreeTrialBanner>;
  studioAiYearlyTrialBanner?: Maybe<StudioAiYearlyTrialBanner>;
  undoCancelationBanner?: Maybe<UndoCancelationBanner>;
  upsellBanner?: Maybe<UpsellBanner>;
  verificationBanner?: Maybe<VerificationBanner>;
};

export enum SitePopupType {
  Newsletter = 'newsletter',
  ProfileNudge = 'profile_nudge',
  SitewidePopup = 'sitewide_popup'
}

export type SitePromotion = {
  __typename?: 'SitePromotion';
  discount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type SitePromotions = {
  __typename?: 'SitePromotions';
  promotion?: Maybe<SitePromotion>;
  takeover?: Maybe<SiteTakeover>;
};

export type SiteTakeover = {
  __typename?: 'SiteTakeover';
  aboveNavBannerBtnColor: Scalars['String']['output'];
  aboveNavBannerBtnTextColor: Scalars['String']['output'];
  aboveNavBannerColor: Scalars['String']['output'];
  aboveNavBannerImg: Scalars['String']['output'];
  homepageFourButtonsColor: Scalars['String']['output'];
  homepageFourButtonsTextColor: Scalars['String']['output'];
  homepageHeroBtnColor: Scalars['String']['output'];
  homepageHeroBtnText: Scalars['String']['output'];
  homepageHeroBtnTextColor: Scalars['String']['output'];
  homepageHeroBtnUrl: Scalars['String']['output'];
  homepageHeroImg: Scalars['String']['output'];
  homepageHeroImgLeftImg: Scalars['String']['output'];
  homepageHeroImgRightImg: Scalars['String']['output'];
  homepageHeroImgUrl: Scalars['String']['output'];
  homepageHeroMblImg: Scalars['String']['output'];
  homepageHeroText: Scalars['String']['output'];
  homepageHeroTextColor: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  navMenuItemColor: Scalars['String']['output'];
  title: Scalars['String']['output'];
  websiteLogoImg: Scalars['String']['output'];
};

export type Snippet = {
  __typename?: 'Snippet';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  snippet: Scalars['String']['output'];
  snippetUrl: Scalars['String']['output'];
};

export enum SnippetView {
  LoggedUsersOnly = 'logged_users_only',
  Public = 'public',
  Unspecified = 'unspecified'
}

export type SnippetsCreateSnippetInput = {
  name: Scalars['String']['input'];
  snippet: Scalars['String']['input'];
};

export type SnippetsCreateSnippetResponse = {
  __typename?: 'SnippetsCreateSnippetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  snippet?: Maybe<Snippet>;
};

export type SnippetsDeleteSnippetInput = {
  id: Scalars['ID']['input'];
};

export type SnippetsDeleteSnippetResponse = {
  __typename?: 'SnippetsDeleteSnippetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  snippet?: Maybe<Snippet>;
};

export type SnippetsGetSnippetInput = {
  id: Scalars['ID']['input'];
};

export type SnippetsGetSnippetResponse = {
  __typename?: 'SnippetsGetSnippetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  snippet?: Maybe<Snippet>;
};

export type SnippetsListPagination = {
  __typename?: 'SnippetsListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SnippetsListSnippetInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
};

export type SnippetsListSnippetResponse = {
  __typename?: 'SnippetsListSnippetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination: SnippetsListPagination;
  snippets?: Maybe<Array<Snippet>>;
};

export type SnippetsUpdateSnippetInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
};

export type SnippetsUpdateSnippetResponse = {
  __typename?: 'SnippetsUpdateSnippetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  snippet?: Maybe<Snippet>;
};

export type SocialAsset = {
  __typename?: 'SocialAsset';
  createTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  optimizedUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use thumbnailUrls */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrls?: Maybe<Array<Thumbnail>>;
  type: SocialAssetType;
  url: Scalars['String']['output'];
  videoInfo?: Maybe<SocialVideoAsset>;
};

export type SocialAssetInput = {
  type: SocialAssetType;
  url: Scalars['String']['input'];
};

export enum SocialAssetType {
  Image = 'image',
  Video = 'video'
}

export type SocialBlockUserInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SocialBlockUserListInput = {
  itemsPerPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type SocialBlockUserListResponse = {
  __typename?: 'SocialBlockUserListResponse';
  UserBlockList?: Maybe<Array<UserBlock>>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<SocialPagination>;
};

export type SocialBlockUserResponse = {
  __typename?: 'SocialBlockUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialComment = {
  __typename?: 'SocialComment';
  assets?: Maybe<Array<SocialAsset>>;
  childComments?: Maybe<Array<SocialComment>>;
  commentsCount: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  createTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isLiked: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
  user: PublicUserProfile;
};

export type SocialCommentDeleteInput = {
  commentId: Scalars['ID']['input'];
};

export type SocialCommentDeleteResponse = {
  __typename?: 'SocialCommentDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialCommentLikeInput = {
  CommentId: Scalars['ID']['input'];
};

export type SocialCommentLikeRemoveInput = {
  CommentId: Scalars['ID']['input'];
};

export type SocialCommentLikeRemoveResponse = {
  __typename?: 'SocialCommentLikeRemoveResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialCommentLikeResponse = {
  __typename?: 'SocialCommentLikeResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialCommentListPagination = {
  __typename?: 'SocialCommentListPagination';
  hasNextPage: Scalars['Boolean']['output'];
  nextPageCursor: Scalars['DateTime']['output'];
};

export type SocialCommentsListInput = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  itemsPerPage: Scalars['Int']['input'];
  parentCommentID?: InputMaybe<Scalars['ID']['input']>;
  postID: Scalars['ID']['input'];
};

export type SocialCommentsListResponse = {
  __typename?: 'SocialCommentsListResponse';
  comments?: Maybe<Array<SocialComment>>;
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<SocialCommentListPagination>;
};

export type SocialCreateCommentInput = {
  assets?: InputMaybe<Array<SocialAssetInput>>;
  commentParentId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  postId: Scalars['ID']['input'];
};

export type SocialCreateCommentResponse = {
  __typename?: 'SocialCreateCommentResponse';
  comment?: Maybe<SocialComment>;
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialCreateSignedUploadUrlV2Input = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
};

export type SocialCreateSignedUploadUrlV2Response = {
  __typename?: 'SocialCreateSignedUploadUrlV2Response';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  inputFormFields?: Maybe<Array<KeyValuePairs>>;
  signedUrl: Scalars['String']['output'];
};

export type SocialCuratedFeedInput = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage: Scalars['Int']['input'];
};

export type SocialCuratedFeedPagination = {
  __typename?: 'SocialCuratedFeedPagination';
  itemsPerPage: Scalars['Int']['output'];
  nextPageCursor?: Maybe<Scalars['Int']['output']>;
  totalPages: Scalars['Int']['output'];
};

export type SocialCuratedFeedResponse = {
  __typename?: 'SocialCuratedFeedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<SocialCuratedFeedPagination>;
  posts?: Maybe<Array<Post>>;
};

export type SocialDiscoveryFeedInput = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage: Scalars['Int']['input'];
};

export type SocialFeedPagination = {
  __typename?: 'SocialFeedPagination';
  itemsPerPage: Scalars['Int']['output'];
  nextPageCursor?: Maybe<Scalars['Int']['output']>;
  totalPages: Scalars['Int']['output'];
};

export type SocialFeedResponse = {
  __typename?: 'SocialFeedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<SocialFeedPagination>;
  posts?: Maybe<Array<Post>>;
};

export type SocialFollowersFeedInput = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage: Scalars['Int']['input'];
};

export type SocialGetCommentInput = {
  commentId: Scalars['Int']['input'];
};

export type SocialGetCommentResponse = {
  __typename?: 'SocialGetCommentResponse';
  comment?: Maybe<SocialComment>;
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialGetEmailNotificationsSettingsResponse = {
  __typename?: 'SocialGetEmailNotificationsSettingsResponse';
  emailNotificationsEnabled: EmailNotificationSettings;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SocialGetPostInput = {
  postId?: InputMaybe<Scalars['ID']['input']>;
  postSlug?: InputMaybe<Scalars['String']['input']>;
};

export type SocialGetUploadedInput = {
  assetId: Scalars['String']['input'];
};

export type SocialGetUploadedResponse = {
  __typename?: 'SocialGetUploadedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type SocialGetUsersInput = {
  limit: Scalars['Int']['input'];
};

export type SocialGetUsersResponse = {
  __typename?: 'SocialGetUsersResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  users?: Maybe<Array<PublicUserProfile>>;
};

export type SocialGiveTipToPostInput = {
  postId?: InputMaybe<Scalars['Int']['input']>;
  postSlug?: InputMaybe<Scalars['String']['input']>;
};

export type SocialGiveTipToPostResponse = {
  __typename?: 'SocialGiveTipToPostResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialInstruction = {
  __typename?: 'SocialInstruction';
  assets?: Maybe<Array<SocialAsset>>;
  description?: Maybe<Scalars['String']['output']>;
  videoAssets?: Maybe<Array<SocialVideoAsset>>;
};

export type SocialLatestDownloadImagesResponse = {
  __typename?: 'SocialLatestDownloadImagesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  images?: Maybe<Array<Scalars['String']['output']>>;
};

export type SocialListPostByProductInput = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['ID']['input'];
};

export type SocialListPostByProductPagination = {
  __typename?: 'SocialListPostByProductPagination';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  nextPageCursor?: Maybe<Scalars['Int']['output']>;
};

export type SocialListPostByProductResponse = {
  __typename?: 'SocialListPostByProductResponse';
  Pagination?: Maybe<SocialListPostByProductPagination>;
  Posts: Array<Maybe<Post>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SocialLoginInput = {
  accessToken: Scalars['String']['input'];
  clientType: ClientType;
  type: AuthType;
};

export type SocialMediaAccounts = {
  __typename?: 'SocialMediaAccounts';
  behance: Scalars['String']['output'];
  dribbble: Scalars['String']['output'];
  facebook: Scalars['String']['output'];
  instagram: Scalars['String']['output'];
  pinterest: Scalars['String']['output'];
  tiktok: Scalars['String']['output'];
  twitter: Scalars['String']['output'];
  youtube: Scalars['String']['output'];
};

export type SocialPagination = {
  __typename?: 'SocialPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SocialPostDeleteFromUserInput = {
  userId: Scalars['ID']['input'];
};

export type SocialPostDeleteFromUserResponse = {
  __typename?: 'SocialPostDeleteFromUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialPostDeleteInput = {
  postId: Scalars['ID']['input'];
};

export type SocialPostDeleteResponse = {
  __typename?: 'SocialPostDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialPostInput = {
  assets?: InputMaybe<Array<SocialAssetInput>>;
  content: Scalars['String']['input'];
  instructions?: InputMaybe<Array<Scalars['String']['input']>>;
  level?: InputMaybe<ProjectLevel>;
  machines?: InputMaybe<Array<Scalars['String']['input']>>;
  materials?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SocialPostLikeInput = {
  postId: Scalars['Int']['input'];
};

export type SocialPostLikeRemoveInput = {
  postId: Scalars['Int']['input'];
};

export type SocialPostLikeRemoveResponse = {
  __typename?: 'SocialPostLikeRemoveResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialPostLikeResponse = {
  __typename?: 'SocialPostLikeResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialPostResponse = {
  __typename?: 'SocialPostResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  post?: Maybe<Post>;
  success: Scalars['Boolean']['output'];
};

export type SocialPostSaveInput = {
  postId: Scalars['ID']['input'];
};

export type SocialPostSaveRemoveInput = {
  postId: Scalars['ID']['input'];
};

export type SocialPostSaveRemoveResponse = {
  __typename?: 'SocialPostSaveRemoveResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialPostSaveResponse = {
  __typename?: 'SocialPostSaveResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialProduct = {
  __typename?: 'SocialProduct';
  author: PublicUserProfile;
  category: Scalars['String']['output'];
  categorySlug: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SocialProductCard = {
  __typename?: 'SocialProductCard';
  author?: Maybe<PublicUserProfile>;
  category: Scalars['String']['output'];
  categorySlug: Scalars['String']['output'];
  id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SocialProvider = {
  __typename?: 'SocialProvider';
  authUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type SocialRedirectLoginInput = {
  clientType: ClientType;
  type: AuthType;
};

export type SocialRedirectLoginResponse = {
  __typename?: 'SocialRedirectLoginResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  target_url?: Maybe<Scalars['String']['output']>;
};

export type SocialSavedFeedInput = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage: Scalars['Int']['input'];
};

export type SocialSavedFeedResponse = {
  __typename?: 'SocialSavedFeedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination: SocialFeedPagination;
  posts?: Maybe<Array<Post>>;
  totalSavedPosts: Scalars['Int']['output'];
};

export type SocialUnblockUserInput = {
  userId: Scalars['String']['input'];
};

export type SocialUnblockUserResponse = {
  __typename?: 'SocialUnblockUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialUpdateEmailNotificationsSettingsInput = {
  emailNotificationSettings: EmailNotificationSettingsInput;
};

export type SocialUpdateEmailNotificationsSettingsResponse = {
  __typename?: 'SocialUpdateEmailNotificationsSettingsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SocialUploadCreateSignedUrlInput = {
  uploadFile: Scalars['String']['input'];
};

export type SocialUploadCreateSignedUrlResponse = {
  __typename?: 'SocialUploadCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type SocialUserFeedInput = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  userSlug?: InputMaybe<Scalars['String']['input']>;
};

export type SocialVideoAsset = {
  __typename?: 'SocialVideoAsset';
  dash_urls: Array<Scalars['String']['output']>;
  hls_urls: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mp4_urls: Array<Scalars['String']['output']>;
  state: VideoState;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum Source {
  Marketplace = 'marketplace',
  Studio = 'studio'
}

export type SparkArt = {
  __typename?: 'SparkArt';
  id: Scalars['ID']['output'];
  images: Array<SparkArtImage>;
  prompt: Scalars['String']['output'];
};

export enum SparkArtAspectRatio {
  Landscape_4_3 = 'landscape_4_3',
  Landscape_16_9 = 'landscape_16_9',
  Portrait_3_4 = 'portrait_3_4',
  Portrait_9_16 = 'portrait_9_16',
  Square = 'square'
}

export type SparkArtDeleteInput = {
  id: Scalars['String']['input'];
};

export type SparkArtDeleteResponse = {
  __typename?: 'SparkArtDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkArtGenerateInput = {
  aspectRatio?: InputMaybe<SparkArtAspectRatio>;
  prompt: Scalars['String']['input'];
};

export type SparkArtGenerateResponse = {
  __typename?: 'SparkArtGenerateResponse';
  art?: Maybe<SparkArt>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SparkArtGetInput = {
  id: Scalars['String']['input'];
};

export type SparkArtGetResponse = {
  __typename?: 'SparkArtGetResponse';
  art?: Maybe<SparkArt>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SparkArtImage = {
  __typename?: 'SparkArtImage';
  id: Scalars['ID']['output'];
  originalUrl?: Maybe<Scalars['String']['output']>;
  state: SparkState;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type SparkArtListInput = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SparkArtListPagination = {
  __typename?: 'SparkArtListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SparkArtListResponse = {
  __typename?: 'SparkArtListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  list?: Maybe<Array<SparkArt>>;
  pagination?: Maybe<SparkArtListPagination>;
};

export type SparkArtRegisterInput = {
  ids: Array<Scalars['String']['input']>;
};

export type SparkBackgroundRemovedRegisterInput = {
  ids: Array<Scalars['String']['input']>;
};

export type SparkCrystalline = {
  __typename?: 'SparkCrystalline';
  id: Scalars['ID']['output'];
  images: Array<SparkCrystallineImage>;
  prompt: Scalars['String']['output'];
};

export type SparkCrystallineDeleteInput = {
  id: Scalars['String']['input'];
};

export type SparkCrystallineDeleteResponse = {
  __typename?: 'SparkCrystallineDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkCrystallineGenerateInput = {
  prompt: Scalars['String']['input'];
};

export type SparkCrystallineGenerateResponse = {
  __typename?: 'SparkCrystallineGenerateResponse';
  crystalline?: Maybe<SparkCrystalline>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SparkCrystallineGetInput = {
  id: Scalars['String']['input'];
};

export type SparkCrystallineGetResponse = {
  __typename?: 'SparkCrystallineGetResponse';
  crystalline?: Maybe<SparkCrystalline>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SparkCrystallineImage = {
  __typename?: 'SparkCrystallineImage';
  id: Scalars['ID']['output'];
  originalUrl?: Maybe<Scalars['String']['output']>;
  state: SparkState;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type SparkCrystallineListInput = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SparkCrystallineListPagination = {
  __typename?: 'SparkCrystallineListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SparkCrystallineListResponse = {
  __typename?: 'SparkCrystallineListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  list?: Maybe<Array<SparkCrystalline>>;
  pagination?: Maybe<SparkCrystallineListPagination>;
};

export type SparkCrystallineRegisterInput = {
  ids: Array<Scalars['String']['input']>;
};

export type SparkFreeTrialBanner = {
  __typename?: 'SparkFreeTrialBanner';
  aboveButtonText: Scalars['String']['output'];
  backgroundImage: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  bannerIsMinimized: Scalars['Boolean']['output'];
  belowButtonText: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  buttonUrl: Scalars['String']['output'];
  subtext: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: SiteBannerType;
};

export type SparkGetUploadedInput = {
  uploadId: Scalars['String']['input'];
};

export type SparkGetUploadedResponse = {
  __typename?: 'SparkGetUploadedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type SparkImageMix = {
  __typename?: 'SparkImageMix';
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  images: Array<SparkImageMixVersion>;
  prompt?: Maybe<Scalars['String']['output']>;
  strength: Scalars['Float']['output'];
  userId: Scalars['ID']['output'];
};

export type SparkImageMixDeleteAllResponse = {
  __typename?: 'SparkImageMixDeleteAllResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkImageMixDeleteInput = {
  id: Scalars['ID']['input'];
};

export type SparkImageMixDeleteResponse = {
  __typename?: 'SparkImageMixDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkImageMixGenerateInput = {
  imageUrl: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  strength: Scalars['Float']['input'];
};

export type SparkImageMixGenerateResponse = {
  __typename?: 'SparkImageMixGenerateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  imageMix: SparkImageMix;
};

export type SparkImageMixGetInput = {
  id: Scalars['ID']['input'];
};

export type SparkImageMixGetResponse = {
  __typename?: 'SparkImageMixGetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  imageMix?: Maybe<SparkImageMix>;
};

export type SparkImageMixListInput = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SparkImageMixListPagination = {
  __typename?: 'SparkImageMixListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SparkImageMixListResponse = {
  __typename?: 'SparkImageMixListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  list?: Maybe<Array<SparkImageMix>>;
  pagination?: Maybe<SparkImageMixListPagination>;
};

export type SparkImageMixRegisterInput = {
  ids: Array<Scalars['String']['input']>;
};

export type SparkImageMixVersion = {
  __typename?: 'SparkImageMixVersion';
  id: Scalars['ID']['output'];
  originalUrl?: Maybe<Scalars['String']['output']>;
  state: SparkState;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type SparkInpaint = {
  __typename?: 'SparkInpaint';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  prompt: Scalars['String']['output'];
  srcImageUrl: Scalars['String']['output'];
  srcInpaintAreaImageUrl: Scalars['String']['output'];
  srcThumbnailUrl: Scalars['String']['output'];
  state: SparkState;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type SparkInpaintDeleteAllResponse = {
  __typename?: 'SparkInpaintDeleteAllResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkInpaintDeleteInput = {
  id: Scalars['ID']['input'];
};

export type SparkInpaintDeleteResponse = {
  __typename?: 'SparkInpaintDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkInpaintGetInput = {
  id: Scalars['ID']['input'];
};

export type SparkInpaintGetResponse = {
  __typename?: 'SparkInpaintGetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  inpaint?: Maybe<SparkInpaint>;
};

export type SparkInpaintImageInput = {
  imageUrl: Scalars['String']['input'];
  inpaintAreaImageUrl: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type SparkInpaintImageResponse = {
  __typename?: 'SparkInpaintImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  inpaint?: Maybe<SparkInpaint>;
};

export type SparkInpaintListInput = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SparkInpaintListPagination = {
  __typename?: 'SparkInpaintListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SparkInpaintListResponse = {
  __typename?: 'SparkInpaintListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  list?: Maybe<Array<SparkInpaint>>;
  pagination: SparkInpaintListPagination;
};

export type SparkInpaintRegisterInput = {
  ids: Array<Scalars['String']['input']>;
};

export type SparkOutpaint = {
  __typename?: 'SparkOutpaint';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  increaseDown: Scalars['Int']['output'];
  increaseLeft: Scalars['Int']['output'];
  increaseRight: Scalars['Int']['output'];
  increaseUp: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  srcImageUrl: Scalars['String']['output'];
  srcThumbnailUrl: Scalars['String']['output'];
  state: SparkState;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type SparkOutpaintDeleteAllResponse = {
  __typename?: 'SparkOutpaintDeleteAllResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkOutpaintDeleteInput = {
  id: Scalars['ID']['input'];
};

export type SparkOutpaintDeleteResponse = {
  __typename?: 'SparkOutpaintDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkOutpaintGetInput = {
  id: Scalars['ID']['input'];
};

export type SparkOutpaintGetResponse = {
  __typename?: 'SparkOutpaintGetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  outpaint?: Maybe<SparkOutpaint>;
};

export type SparkOutpaintImageInput = {
  imageUrl: Scalars['String']['input'];
  increaseDown: Scalars['Int']['input'];
  increaseLeft: Scalars['Int']['input'];
  increaseRight: Scalars['Int']['input'];
  increaseUp: Scalars['Int']['input'];
  prompt: Scalars['String']['input'];
};

export type SparkOutpaintImageResponse = {
  __typename?: 'SparkOutpaintImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  outpaint?: Maybe<SparkOutpaint>;
};

export type SparkOutpaintListInput = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SparkOutpaintListPagination = {
  __typename?: 'SparkOutpaintListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SparkOutpaintListResponse = {
  __typename?: 'SparkOutpaintListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  list?: Maybe<Array<SparkOutpaint>>;
  pagination: SparkOutpaintListPagination;
};

export type SparkOutpaintRegisterInput = {
  ids: Array<Scalars['String']['input']>;
};

export type SparkRegisterArtResponse = {
  __typename?: 'SparkRegisterArtResponse';
  arts?: Maybe<Array<SparkArt>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SparkRegisterBackgroundRemovedResponse = {
  __typename?: 'SparkRegisterBackgroundRemovedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  removedBackgrounds?: Maybe<Array<SparkRemoveBackgroundImage>>;
};

export type SparkRegisterCrystallineResponse = {
  __typename?: 'SparkRegisterCrystallineResponse';
  crystallines?: Maybe<Array<SparkCrystalline>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SparkRegisterImageMixResponse = {
  __typename?: 'SparkRegisterImageMixResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  imagemix?: Maybe<Array<SparkImageMix>>;
};

export type SparkRegisterInpaintResponse = {
  __typename?: 'SparkRegisterInpaintResponse';
  Inpaints?: Maybe<Array<SparkInpaint>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SparkRegisterOutpaintResponse = {
  __typename?: 'SparkRegisterOutpaintResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  outpaints?: Maybe<Array<SparkOutpaint>>;
};

export type SparkRemoveBackgroundGetInput = {
  id: Scalars['String']['input'];
};

export type SparkRemoveBackgroundGetResponse = {
  __typename?: 'SparkRemoveBackgroundGetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  removedBackground?: Maybe<SparkRemoveBackgroundImage>;
};

export type SparkRemoveBackgroundImage = {
  __typename?: 'SparkRemoveBackgroundImage';
  generatedImagelUrl?: Maybe<Scalars['String']['output']>;
  generatedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  previewSourceImageUrl?: Maybe<Scalars['String']['output']>;
  sourceImageUrl?: Maybe<Scalars['String']['output']>;
  sourceThumbnailUrl?: Maybe<Scalars['String']['output']>;
  state: SparkState;
};

export type SparkRemoveBackgroundInput = {
  imageUrl: Scalars['String']['input'];
};

export type SparkRemoveBackgroundResponse = {
  __typename?: 'SparkRemoveBackgroundResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  removedBackground?: Maybe<SparkRemoveBackgroundImage>;
};

export type SparkRemovedBackgroundCancelInput = {
  id: Scalars['String']['input'];
};

export type SparkRemovedBackgroundCancelResponse = {
  __typename?: 'SparkRemovedBackgroundCancelResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkRemovedBackgroundDeleteAllResponse = {
  __typename?: 'SparkRemovedBackgroundDeleteAllResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkRemovedBackgroundDeleteInput = {
  id: Scalars['ID']['input'];
};

export type SparkRemovedBackgroundDeleteResponse = {
  __typename?: 'SparkRemovedBackgroundDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SparkRemovedBackgroundListInput = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SparkRemovedBackgroundListPagination = {
  __typename?: 'SparkRemovedBackgroundListPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SparkRemovedBackgroundListResponse = {
  __typename?: 'SparkRemovedBackgroundListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  list?: Maybe<Array<SparkRemoveBackgroundImage>>;
  pagination?: Maybe<SparkRemovedBackgroundListPagination>;
};

export type SparkRemovedBackgroundUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String']['input'];
};

export type SparkRemovedBackgroundUploadsCreateSignedUrlResponse = {
  __typename?: 'SparkRemovedBackgroundUploadsCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export enum SparkState {
  Cancelled = 'cancelled',
  Failed = 'failed',
  Generated = 'generated',
  Requested = 'requested',
  UploadPending = 'uploadPending'
}

export type SparkUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String']['input'];
};

export type SparkUploadsCreateSignedUrlResponse = {
  __typename?: 'SparkUploadsCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type StatisticsRecordStudioEventInput = {
  eventType: StudioEventType;
};

export type StatisticsRecordStudioEventResponse = {
  __typename?: 'StatisticsRecordStudioEventResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StatusMessage = {
  __typename?: 'StatusMessage';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum StatusType {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Deleted = 'deleted',
  Failed = 'failed',
  Pending = 'pending',
  Unknown = 'unknown'
}

export type StorageEnableOveragesInput = {
  enableOverages: Scalars['Boolean']['input'];
  teamId: Scalars['String']['input'];
};

export type StorageEnableOveragesResponse = {
  __typename?: 'StorageEnableOveragesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  storage?: Maybe<StorageInfo>;
};

export type StorageInfo = {
  __typename?: 'StorageInfo';
  available: StorageSize;
  blocks?: Maybe<BlocksRange>;
  enableOverages: Scalars['Boolean']['output'];
  maxFileSizeAllowed?: Maybe<StorageSize>;
  total: StorageSize;
  used: StorageSize;
};

export type StorageInfoResponse = {
  __typename?: 'StorageInfoResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  storage?: Maybe<StorageInfo>;
};

export type StorageSize = {
  __typename?: 'StorageSize';
  bytes: Scalars['Int']['output'];
  humanized: Scalars['String']['output'];
};

export type StorageUpdateSizeInput = {
  blocks: Scalars['Int']['input'];
  teamId: Scalars['String']['input'];
};

export type StorageUpdateSizeResponse = {
  __typename?: 'StorageUpdateSizeResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  storage?: Maybe<StorageInfo>;
};

export type StoreUserSearchInput = {
  searchTerm: Scalars['String']['input'];
};

export enum StripeAccount {
  Nl = 'NL',
  Us = 'US'
}

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  account: StripeAccount;
  id: Scalars['ID']['output'];
};

export type StripeSubscriptionExtensionInfo = {
  __typename?: 'StripeSubscriptionExtensionInfo';
  inProgress: Scalars['Boolean']['output'];
  nextPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  payInvoiceUrl?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<PaymentStatus>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
};

export type StudioAiYearlyTrialBanner = {
  __typename?: 'StudioAiYearlyTrialBanner';
  backgroundImage: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  buttonUrl: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  isHidden: Scalars['Boolean']['output'];
  showInHeader: Scalars['Boolean']['output'];
  type: SiteBannerType;
  variant: Scalars['String']['output'];
  yearly: Scalars['Boolean']['output'];
};

export type StudioAllSimpleCommentsInput = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<StudioSocialEntityType>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<StudioSimpleCommentType>;
};

/**
 * The inferred intent of a comment. When not Unspecified, the comment was not
 * posted and the UI should react (e.g. offer to apply an edit prompt, or show an
 * NSFW notice).
 */
export enum StudioCommentInference {
  Nsfw = 'Nsfw',
  Prompt = 'Prompt',
  Unspecified = 'Unspecified'
}

export type StudioCommentReactDeleteResponse = {
  __typename?: 'StudioCommentReactDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioCommentReactInput = {
  commentId: Scalars['ID']['input'];
  reaction: StudioCommentReactionType;
};

export type StudioCommentReactResponse = {
  __typename?: 'StudioCommentReactResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  reaction?: Maybe<StudioCommentReaction>;
  success: Scalars['Boolean']['output'];
};

export type StudioCommentReaction = {
  __typename?: 'StudioCommentReaction';
  commentId: Scalars['ID']['output'];
  createTime: Scalars['DateTime']['output'];
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  reaction: StudioCommentReactionType;
  user: PublicUserProfile;
};

export enum StudioCommentReactionType {
  Like = 'Like',
  Unspecified = 'Unspecified'
}

export type StudioCommentReactionsInput = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  commentId: Scalars['ID']['input'];
  reactionType?: InputMaybe<StudioCommentReactionType>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type StudioCommentReactionsResponse = {
  __typename?: 'StudioCommentReactionsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  reactions?: Maybe<Array<StudioCommentReaction>>;
};

export enum StudioEventType {
  AppOnboarding = 'appOnboarding',
  UserLogin = 'userLogin'
}

export enum StudioFolderType {
  BackgroundRemover = 'backgroundRemover',
  Unspecified = 'unspecified',
  User = 'user',
  Vectorizer = 'vectorizer'
}

export type StudioIsAiStudioUserResponse = {
  __typename?: 'StudioIsAIStudioUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  studioAIUser?: Maybe<Scalars['Boolean']['output']>;
};

export type StudioIsAllAccessUserResponse = {
  __typename?: 'StudioIsAllAccessUserResponse';
  allAccessUser?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type StudioProject = {
  __typename?: 'StudioProject';
  /** @deprecated will be removed soon */
  activeRevision: StudioProjectRevision;
  createTime: Scalars['String']['output'];
  deleteTime: Scalars['String']['output'];
  folderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  lastViewTime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner: PublicUserProfile;
  /** @deprecated use owner instead */
  projectOwner?: Maybe<PublicUserProfile>;
  /** @deprecated not being used */
  restoreTime: Scalars['String']['output'];
  team?: Maybe<Team>;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateOrigin?: Maybe<ProjectTemplateOrigin>;
  thumbnailUrl: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
  userPermissions: Array<UserProjectPermission>;
};

export type StudioProjectComment = {
  __typename?: 'StudioProjectComment';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  parentCommentId?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['String']['output'];
  status: StudioProjectCommentStatus;
  timestamp: Scalars['String']['output'];
  tool: StudioProjectCommentTool;
  usersTagged?: Maybe<Array<Scalars['String']['output']>>;
  usersToNotify?: Maybe<Array<Scalars['String']['output']>>;
  xCoordinate: Scalars['Int']['output'];
  yCoordinate: Scalars['Int']['output'];
};

export enum StudioProjectCommentStatus {
  Done = 'done',
  Open = 'open',
  Unspecified = 'unspecified'
}

export enum StudioProjectCommentTool {
  Board = 'board',
  Project = 'project',
  Unspecified = 'unspecified'
}

export type StudioProjectCreateFolderInput = {
  name: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectCreateFolderResponse = {
  __typename?: 'StudioProjectCreateFolderResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  folder?: Maybe<StudioProjectFolder>;
};

export type StudioProjectDeleteProjectInput = {
  id: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectDeleteProjectResponse = {
  __typename?: 'StudioProjectDeleteProjectResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectDownloadAssetsInput = {
  ids: Array<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectDownloadAssetsResponse = {
  __typename?: 'StudioProjectDownloadAssetsResponse';
  assets: Array<AssetDownloadResponse>;
  errors: Array<ErrorMessage>;
};

export type StudioProjectEmptyTrashInput = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectEmptyTrashResponse = {
  __typename?: 'StudioProjectEmptyTrashResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectFolder = {
  __typename?: 'StudioProjectFolder';
  collaborators: Array<PublicUserProfile>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  folders: Array<StudioProjectFolder>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: PublicUserProfile;
  parentFolderId?: Maybe<Scalars['ID']['output']>;
  projectCount?: Maybe<Scalars['Int']['output']>;
  projects: Array<StudioProject>;
  team?: Maybe<Team>;
  /** @deprecated use team instead */
  teamId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userPermissions: Array<UserProjectPermission>;
};

export type StudioProjectFolderDeleteInput = {
  folderId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectFolderDeleteResponse = {
  __typename?: 'StudioProjectFolderDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectMoveProjectsInput = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  projectIds: Array<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectMoveProjectsResponse = {
  __typename?: 'StudioProjectMoveProjectsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectOptimizeProjectInput = {
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  ignoreBackground?: InputMaybe<Scalars['Boolean']['input']>;
  returnFileType?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['String']['input']>;
};

export type StudioProjectOptimizeProjectResponse = {
  __typename?: 'StudioProjectOptimizeProjectResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StudioProjectRestoreProjectInput = {
  id: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectRestoreProjectResponse = {
  __typename?: 'StudioProjectRestoreProjectResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectRevision = {
  __typename?: 'StudioProjectRevision';
  createTime: Scalars['String']['output'];
  editor: ProjectEditor;
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAutoSave: Scalars['Boolean']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  teamId?: Maybe<Scalars['String']['output']>;
  thumbnailLastUpdate?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type StudioProjectSharingLink = {
  __typename?: 'StudioProjectSharingLink';
  defaultAccess: StudioProjectSharingLinkAccess;
  id: Scalars['ID']['output'];
  project: StudioProject;
  url: Scalars['String']['output'];
  usersWithAccess: Array<StudioProjectSharingUserAccess>;
};

export enum StudioProjectSharingLinkAccess {
  CanEdit = 'canEdit',
  CanView = 'canView',
  NoAccess = 'noAccess'
}

export type StudioProjectSharingUserAccess = {
  __typename?: 'StudioProjectSharingUserAccess';
  access: StudioProjectSharingLinkAccess;
  user: User;
};

export enum StudioProjectUpdateFields {
  Content = 'content',
  Editor = 'editor',
  Name = 'name',
  TemplateId = 'templateId',
  TemplateOrigin = 'templateOrigin',
  Thumbnail = 'thumbnail'
}

export type StudioProjectsAddMemberInput = {
  email: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  role: Role;
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type StudioProjectsAddMemberResponse = {
  __typename?: 'StudioProjectsAddMemberResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  status?: Maybe<InvitationStatus>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StudioProjectsAddUserToProjectSharingLinkInput = {
  access: StudioProjectSharingLinkAccess;
  linkId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectsAddUserToProjectSharingLinkResponse = {
  __typename?: 'StudioProjectsAddUserToProjectSharingLinkResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectsApproveInviteInput = {
  invitationCode: Scalars['String']['input'];
  invitationID?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};

export type StudioProjectsApproveInviteResponse = {
  __typename?: 'StudioProjectsApproveInviteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectsApproveProjectMemberUpdateInput = {
  approvalId?: InputMaybe<Scalars['String']['input']>;
  invitationCode: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type StudioProjectsApproveProjectMemberUpdateResponse = {
  __typename?: 'StudioProjectsApproveProjectMemberUpdateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StudioProjectsChangeUserRoleInput = {
  projectId: Scalars['String']['input'];
  role: Role;
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type StudioProjectsChangeUserRoleResponse = {
  __typename?: 'StudioProjectsChangeUserRoleResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  status?: Maybe<RoleChangeStatus>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StudioProjectsConfirmInviteInput = {
  invitationCode: Scalars['String']['input'];
  inviteId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type StudioProjectsConfirmInviteResponse = {
  __typename?: 'StudioProjectsConfirmInviteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectsCreateFromTemplateInput = {
  teamId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type StudioProjectsCreateFromTemplateResponse = {
  __typename?: 'StudioProjectsCreateFromTemplateResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  project?: Maybe<StudioProject>;
};

export type StudioProjectsCreateProjectCommentInput = {
  message: Scalars['String']['input'];
  parentCommentId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['String']['input'];
  tool: StudioProjectCommentTool;
  usersTagged?: InputMaybe<Array<Scalars['String']['input']>>;
  usersToNotify?: InputMaybe<Array<Scalars['String']['input']>>;
  xCoordinate: Scalars['Int']['input'];
  yCoordinate: Scalars['Int']['input'];
};

export type StudioProjectsCreateProjectCommentResponse = {
  __typename?: 'StudioProjectsCreateProjectCommentResponse';
  comment?: Maybe<StudioProjectComment>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type StudioProjectsCreateProjectInput = {
  autoSave?: InputMaybe<Scalars['Boolean']['input']>;
  content: Scalars['String']['input'];
  editor?: InputMaybe<ProjectEditor>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateOrigin?: InputMaybe<ProjectTemplateOrigin>;
};

export type StudioProjectsCreateProjectResponse = {
  __typename?: 'StudioProjectsCreateProjectResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  project?: Maybe<StudioProject>;
};

export type StudioProjectsCreateProjectSharingLinkInput = {
  defaultAccess: StudioProjectSharingLinkAccess;
  projectId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectsCreateProjectSharingLinkResponse = {
  __typename?: 'StudioProjectsCreateProjectSharingLinkResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  projectSharingLink?: Maybe<StudioProjectSharingLink>;
};

export type StudioProjectsFolderGetInput = {
  folderId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectsFolderGetResponse = {
  __typename?: 'StudioProjectsFolderGetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  folder?: Maybe<StudioProjectFolder>;
};

export type StudioProjectsFolderRenameInput = {
  folderId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectsFolderRenameResponse = {
  __typename?: 'StudioProjectsFolderRenameResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectsFolderRestoreInput = {
  folderId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioProjectsFolderRestoreResponse = {
  __typename?: 'StudioProjectsFolderRestoreResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectsGetProjectCommentsInput = {
  projectId: Scalars['String']['input'];
};

export type StudioProjectsGetProjectCommentsResponse = {
  __typename?: 'StudioProjectsGetProjectCommentsResponse';
  comments?: Maybe<Array<StudioProjectComment>>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type StudioProjectsGetProjectResponse = {
  __typename?: 'StudioProjectsGetProjectResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  project?: Maybe<StudioProject>;
};

export type StudioProjectsGetTeamInput = {
  projectId: Scalars['String']['input'];
};

export type StudioProjectsGetTeamResponse = {
  __typename?: 'StudioProjectsGetTeamResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  team?: Maybe<Team>;
};

export type StudioProjectsListItemsInTrashInput = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort: ProjectSort;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  timeFrame?: InputMaybe<TimeFrame>;
};

export type StudioProjectsListItemsInTrashResponse = {
  __typename?: 'StudioProjectsListItemsInTrashResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  folders?: Maybe<Array<StudioProjectFolder>>;
  projects?: Maybe<Array<StudioProject>>;
  templates?: Maybe<Array<Template>>;
};

export type StudioProjectsListMostRecentInput = {
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type StudioProjectsListMostRecentResponse = {
  __typename?: 'StudioProjectsListMostRecentResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  projects?: Maybe<Array<StudioProject>>;
};

export type StudioProjectsListProjectsInTrashInput = {
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort: ProjectSort;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  timeFrame?: InputMaybe<TimeFrame>;
};

export type StudioProjectsListProjectsInTrashResponse = {
  __typename?: 'StudioProjectsListProjectsInTrashResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  projects?: Maybe<Array<StudioProject>>;
};

export type StudioProjectsListProjectsInput = {
  filterEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort: ProjectSort;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  timeFrame?: InputMaybe<TimeFrame>;
};

export type StudioProjectsListProjectsResponse = {
  __typename?: 'StudioProjectsListProjectsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  folders?: Maybe<Array<StudioProjectFolder>>;
  projects?: Maybe<Array<StudioProject>>;
};

export type StudioProjectsListProjectsSharedWithMeInput = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ownedBy?: InputMaybe<OwnedBy>;
};

export type StudioProjectsListProjectsSharedWithMeResponse = {
  __typename?: 'StudioProjectsListProjectsSharedWithMeResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<SharedProjectsPagination>;
  teamsProjects?: Maybe<Array<StudioProjectsTeamSharedProjects>>;
  userProjects?: Maybe<Array<StudioProjectsUserSharedProjects>>;
};

export type StudioProjectsMarkProjectCommentDoneInput = {
  commentId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

export type StudioProjectsMarkProjectCommentDoneResponse = {
  __typename?: 'StudioProjectsMarkProjectCommentDoneResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectsRemoveUserInput = {
  projectId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type StudioProjectsRemoveUserResponse = {
  __typename?: 'StudioProjectsRemoveUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StudioProjectsTeamSharedProjects = {
  __typename?: 'StudioProjectsTeamSharedProjects';
  projects: Array<StudioProject>;
  team: Team;
};

export type StudioProjectsUpdateProjectInput = {
  autoSave?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  editor?: InputMaybe<ProjectEditor>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateOrigin?: InputMaybe<ProjectTemplateOrigin>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  updateFields: Array<StudioProjectUpdateFields>;
};

export type StudioProjectsUpdateProjectLastViewInput = {
  projectId: Scalars['ID']['input'];
};

export type StudioProjectsUpdateProjectLastViewResponse = {
  __typename?: 'StudioProjectsUpdateProjectLastViewResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectsUpdateProjectResponse = {
  __typename?: 'StudioProjectsUpdateProjectResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectsUserSharedProjects = {
  __typename?: 'StudioProjectsUserSharedProjects';
  owner: PublicUserProfile;
  projects: Array<StudioProject>;
};

export type StudioSimpleComment = {
  __typename?: 'StudioSimpleComment';
  childCount: Scalars['Int']['output'];
  createTime: Scalars['DateTime']['output'];
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  mentions?: Maybe<Array<PublicUserProfile>>;
  parentId?: Maybe<Scalars['ID']['output']>;
  reactions: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updateTime?: Maybe<Scalars['DateTime']['output']>;
  user: PublicUserProfile;
  userReaction?: Maybe<StudioCommentReactionType>;
};

export type StudioSimpleCommentResponse = {
  __typename?: 'StudioSimpleCommentResponse';
  comment?: Maybe<StudioSimpleComment>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type StudioSimpleCommentTaggableUser = {
  __typename?: 'StudioSimpleCommentTaggableUser';
  user: PublicUserProfile;
  userType: StudioSimpleCommentTaggableUserType;
};

export enum StudioSimpleCommentTaggableUserType {
  Commenter = 'Commenter',
  Follower = 'Follower',
  Unspecified = 'Unspecified'
}

export type StudioSimpleCommentTaggableUsersInput = {
  entityId: Scalars['ID']['input'];
  entityType?: InputMaybe<StudioSocialEntityType>;
  take?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StudioSimpleCommentType>;
};

export type StudioSimpleCommentTaggableUsersResponse = {
  __typename?: 'StudioSimpleCommentTaggableUsersResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  users?: Maybe<Array<StudioSimpleCommentTaggableUser>>;
};

export enum StudioSimpleCommentType {
  Flow = 'Flow',
  Fonts = 'Fonts',
  FreemodeVideoGenerator = 'FreemodeVideoGenerator',
  StudioAiSvgGenerator = 'StudioAiSvgGenerator',
  StudioLogoGenerator = 'StudioLogoGenerator',
  StudioMusicGenerator = 'StudioMusicGenerator',
  StudioQuoteGenerator = 'StudioQuoteGenerator',
  StudioSoundGenerator = 'StudioSoundGenerator',
  StudioVideoGenerator = 'StudioVideoGenerator',
  StudioYoutubeGenerator = 'StudioYoutubeGenerator',
  Unspecified = 'Unspecified'
}

export type StudioSimpleCommentsCreateInput = {
  entityId: Scalars['ID']['input'];
  entityType?: InputMaybe<StudioSocialEntityType>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
  type?: InputMaybe<StudioSimpleCommentType>;
};

export type StudioSimpleCommentsCreateResponse = {
  __typename?: 'StudioSimpleCommentsCreateResponse';
  comment?: Maybe<StudioSimpleComment>;
  errors?: Maybe<Array<ErrorMessage>>;
  inference?: Maybe<StudioCommentInference>;
  success: Scalars['Boolean']['output'];
};

export type StudioSimpleCommentsDeleteResponse = {
  __typename?: 'StudioSimpleCommentsDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioSimpleCommentsEditInput = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type StudioSimpleCommentsEditResponse = {
  __typename?: 'StudioSimpleCommentsEditResponse';
  comment?: Maybe<StudioSimpleComment>;
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioSimpleCommentsInput = {
  afterId?: InputMaybe<Scalars['ID']['input']>;
  entityId: Scalars['ID']['input'];
  entityType?: InputMaybe<StudioSocialEntityType>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<StudioSimpleCommentsSort>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<StudioSimpleCommentType>;
};

export type StudioSimpleCommentsResponse = {
  __typename?: 'StudioSimpleCommentsResponse';
  comments?: Maybe<Array<StudioSimpleComment>>;
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum StudioSimpleCommentsSort {
  CreateTime = 'CreateTime',
  Reactions = 'Reactions',
  Unspecified = 'Unspecified'
}

export enum StudioSocialEntityType {
  Flow = 'Flow',
  Fonts = 'Fonts',
  FreemodeVideoGenerator = 'FreemodeVideoGenerator',
  StudioAiSvgGenerator = 'StudioAiSvgGenerator',
  StudioLogoGenerator = 'StudioLogoGenerator',
  StudioMusicGenerator = 'StudioMusicGenerator',
  StudioQuoteGenerator = 'StudioQuoteGenerator',
  StudioSoundGenerator = 'StudioSoundGenerator',
  StudioVideoGenerator = 'StudioVideoGenerator',
  StudioYoutubeGenerator = 'StudioYoutubeGenerator',
  Unspecified = 'Unspecified'
}

export enum StudioSocialReactionEntityType {
  Comments = 'Comments',
  Flow = 'Flow',
  Fonts = 'Fonts',
  Unspecified = 'Unspecified'
}

export type StudioSwitchWorkspaceResponse = {
  __typename?: 'StudioSwitchWorkspaceResponse';
  token?: Maybe<Scalars['String']['output']>;
};

export type StudioTemplateDeleteInput = {
  teamId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type StudioTemplateDeleteResponse = {
  __typename?: 'StudioTemplateDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioTemplateListResponse = {
  __typename?: 'StudioTemplateListResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  pagination?: Maybe<StudioTemplatesPagination>;
  templates?: Maybe<Array<Template>>;
};

export type StudioTemplatePublishFromProjectInput = {
  projectId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type StudioTemplatePublishFromProjectResponse = {
  __typename?: 'StudioTemplatePublishFromProjectResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioTemplateRestoreInput = {
  teamId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type StudioTemplateRestoreResponse = {
  __typename?: 'StudioTemplateRestoreResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioTemplatesListInput = {
  currentPage: Scalars['Int']['input'];
  itemsPerPage: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
};

export type StudioTemplatesPagination = {
  __typename?: 'StudioTemplatesPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type StudioUploadsAddTagToFilesInput = {
  fileIds: Array<Scalars['ID']['input']>;
  tagId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsAddTagToFilesResponse = {
  __typename?: 'StudioUploadsAddTagToFilesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export enum StudioUploadsAssetType {
  AssetTypeBackground = 'ASSET_TYPE_BACKGROUND',
  AssetTypeElement = 'ASSET_TYPE_ELEMENT',
  AssetTypeFile = 'ASSET_TYPE_FILE',
  AssetTypeFont = 'ASSET_TYPE_FONT',
  AssetTypeIcon = 'ASSET_TYPE_ICON',
  AssetTypePattern = 'ASSET_TYPE_PATTERN',
  AssetTypePhoto = 'ASSET_TYPE_PHOTO',
  AssetTypeUnspecified = 'ASSET_TYPE_UNSPECIFIED'
}

export type StudioUploadsCreateFolderInput = {
  name: Scalars['String']['input'];
  parent_folder_id?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsCreateFolderResponse = {
  __typename?: 'StudioUploadsCreateFolderResponse';
  created?: Maybe<StudioUploadsFolder>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type StudioUploadsCreateSignedDownloadUrlInput = {
  teamId?: InputMaybe<Scalars['String']['input']>;
  uploadId: Scalars['String']['input'];
};

export type StudioUploadsCreateSignedDownloadUrlResponse = {
  __typename?: 'StudioUploadsCreateSignedDownloadUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  signedUrl: Scalars['String']['output'];
};

export type StudioUploadsCreateSignedUrlInput = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  uploadFile: Scalars['String']['input'];
};

export type StudioUploadsCreateSignedUrlResponse = {
  __typename?: 'StudioUploadsCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  signedUrl: Scalars['String']['output'];
};

export type StudioUploadsCreateTagInput = {
  color: Scalars['String']['input'];
  label: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsCreateTagResponse = {
  __typename?: 'StudioUploadsCreateTagResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  tag: StudioUploadsTag;
};

export type StudioUploadsDeleteFilesInput = {
  fileIds: Array<Scalars['ID']['input']>;
  folderId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsDeleteFilesResponse = {
  __typename?: 'StudioUploadsDeleteFilesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioUploadsDeleteFolderInput = {
  folderId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsDeleteFolderResponse = {
  __typename?: 'StudioUploadsDeleteFolderResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioUploadsDeleteTagInput = {
  id: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsDeleteTagResponse = {
  __typename?: 'StudioUploadsDeleteTagResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioUploadsFile = {
  __typename?: 'StudioUploadsFile';
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  folderId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  type: StudioUploadsAssetType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type StudioUploadsFolder = {
  __typename?: 'StudioUploadsFolder';
  createdAt: Scalars['String']['output'];
  files: Array<StudioUploadsFile>;
  folderType: StudioFolderType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['ID']['output']>;
  subfolders: Array<StudioUploadsSubFolder>;
  teamId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type StudioUploadsGetFolderInput = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsGetFolderResponse = {
  __typename?: 'StudioUploadsGetFolderResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  folder?: Maybe<StudioUploadsFolder>;
};

export type StudioUploadsGetTagsForUploadsInput = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['ID']['input'];
};

export type StudioUploadsGetTagsForUploadsResponse = {
  __typename?: 'StudioUploadsGetTagsForUploadsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  tags: Array<StudioUploadsTag>;
};

export type StudioUploadsMoveFilesInput = {
  fileIds: Array<Scalars['ID']['input']>;
  folderId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsMoveFilesResponse = {
  __typename?: 'StudioUploadsMoveFilesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  moved: Scalars['Boolean']['output'];
};

export type StudioUploadsRemoveTagFromFileInput = {
  fileIds: Array<Scalars['ID']['input']>;
  tagId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsRemoveTagFromFileResponse = {
  __typename?: 'StudioUploadsRemoveTagFromFileResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioUploadsRenameFolderInput = {
  folderId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsRenameFolderResponse = {
  __typename?: 'StudioUploadsRenameFolderResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  renamed: Scalars['Boolean']['output'];
};

export type StudioUploadsSearchFilesInput = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  search: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsSearchFilesResponse = {
  __typename?: 'StudioUploadsSearchFilesResponse';
  errors: Array<ErrorMessage>;
  files: Array<StudioUploadsFile>;
  folders: Array<StudioUploadsFolder>;
  tags: Array<StudioUploadsTag>;
};

export type StudioUploadsSubFolder = {
  __typename?: 'StudioUploadsSubFolder';
  folderType: StudioFolderType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalFiles: Scalars['Int']['output'];
};

export type StudioUploadsTag = {
  __typename?: 'StudioUploadsTag';
  color: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  teamId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type StudioUploadsTagUpdate = {
  color?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export enum StudioUploadsTagUpdateField {
  Color = 'color',
  Label = 'label'
}

export type StudioUploadsTagsInput = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StudioUploadsTagsResponse = {
  __typename?: 'StudioUploadsTagsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  tags: Array<StudioUploadsTag>;
};

export type StudioUploadsUpdateTagInput = {
  id: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  updateField: StudioUploadsTagUpdateField;
  updateTag: StudioUploadsTagUpdate;
};

export type StudioUploadsUpdateTagResponse = {
  __typename?: 'StudioUploadsUpdateTagResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type StudioUploadsUploadUpdatedInput = {
  id: Scalars['ID']['input'];
};

export type StudioUploadsUploadUpdatedResponse = {
  __typename?: 'StudioUploadsUploadUpdatedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  upload?: Maybe<StudioUploadsFile>;
};

export type SubmissionAnalyseResults = {
  __typename?: 'SubmissionAnalyseResults';
  passedAesthetics: Scalars['Boolean']['output'];
  passedCopyright: Scalars['Boolean']['output'];
  passedProfanity: Scalars['Boolean']['output'];
};

export type SubmitSubscriptionCheckoutCustomerDetails = {
  address: AddressInput;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitSubscriptionCheckoutInput = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: AvailableCurrencyCode;
  customerDetails: SubmitSubscriptionCheckoutCustomerDetails;
  mode: SubscriptionCheckoutMode;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  setupModeAttributes?: InputMaybe<SubmitSubscriptionCheckoutSetupModeAttributes>;
  subscriptionPlan: SubscriptionPlan;
};

export type SubmitSubscriptionCheckoutResponse = {
  __typename?: 'SubmitSubscriptionCheckoutResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  subscription?: Maybe<SubscriptionPayload>;
};

export type SubmitSubscriptionCheckoutSetupModeAttributes = {
  setupIntentId: Scalars['ID']['input'];
  trial: Scalars['Boolean']['input'];
};

export type SubscribeToClubhouseDigestInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type SubscribeToClubhouseDigestResponse = {
  __typename?: 'SubscribeToClubhouseDigestResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type SubscribeToDigestResponse = {
  __typename?: 'SubscribeToDigestResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  clubhouseOnlineCount: Scalars['Int']['output'];
  designReviewUpdates: DesignReview;
  entityView: EntityStatsResponse;
  flowActive: Scalars['Boolean']['output'];
  flowFeedStatusUpdated: FlowStatus;
  flowFeedUpdated: Flow;
  flowInteractions: FlowInteractionResponse;
  flowLiked: Scalars['Boolean']['output'];
  flowMostLikedFlowsUpdated: Array<Scalars['String']['output']>;
  flowMostViewedFlowsUpdated: Array<Scalars['String']['output']>;
  flowOnlineCount: Scalars['Int']['output'];
  flowQueueUpdated: FlowQueue;
  flowStatusUpdated: FlowStatus;
  flowUpdated: Flow;
  flowViewers: FlowViewersResponse;
  flowsFlowTipped: FlowsFlowTippedResponse;
  /** @deprecated use fontGeneratorFontPackProgress */
  fontGeneratorDownloadFontProgress: FontGeneratorFontProgressResponse;
  /** @deprecated use fontGeneratorUserFontProgress */
  fontGeneratorFontProgress: FontGeneratorFontProgressResponse;
  fontGeneratorSymbolProgress: FontGeneratorSymbolProgressResponse;
  fontGeneratorUserFontPackProgress: FontGeneratorUserFontProgressResponse;
  fontGeneratorUserFontProgress: FontGeneratorUserFontProgressResponse;
  fontsFeedUpdates: FontsFeedUpdatesResponse;
  healthz: HealthZResponse;
  /** @deprecated Use flowMostLikedFlowsUpdated */
  mostLikedFlowsUpdated: Array<Scalars['String']['output']>;
  /** @deprecated Use flowMostViewedFlowsUpdated */
  mostViewedFlowsUpdated: Array<Scalars['String']['output']>;
  publisherTemplateSubmissionUpdated: PublisherTemplateSubmissionUpdatedResponse;
  sparkRemovedBackgroundUpdates: SparkRemoveBackgroundImage;
  studioUploadsUploadUpdated: StudioUploadsUploadUpdatedResponse;
  transfersTransferUpdates: Transfer;
  uploadedFontsUploadUpdated: UploadedFontsUploadUpdatedResponse;
  upscalerImageUpdates: UpscalerImage;
  userBalanceChanged?: Maybe<UserBalanceChange>;
  userTipped: Scalars['Boolean']['output'];
  vectorizerImageUpdates: VectorizerImage;
  /** @deprecated Use flowViewers */
  viewers: FlowViewersResponse;
};


export type SubscriptionClubhouseOnlineCountArgs = {
  input?: InputMaybe<ClubhouseOnlineInput>;
};


export type SubscriptionDesignReviewUpdatesArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionEntityViewArgs = {
  id: EntityViewInput;
};


export type SubscriptionFlowActiveArgs = {
  flowID: Scalars['ID']['input'];
};


export type SubscriptionFlowInteractionsArgs = {
  input: FlowInteractionInput;
};


export type SubscriptionFlowLikedArgs = {
  flowId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionFlowQueueUpdatedArgs = {
  flowID?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionFlowStatusUpdatedArgs = {
  flowID: Scalars['ID']['input'];
};


export type SubscriptionFlowUpdatedArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionFlowViewersArgs = {
  flowId: Scalars['String']['input'];
};


export type SubscriptionFlowsFlowTippedArgs = {
  input: FlowFlowsTippedInput;
};


export type SubscriptionFontGeneratorDownloadFontProgressArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionFontGeneratorFontProgressArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionFontGeneratorSymbolProgressArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionFontGeneratorUserFontPackProgressArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionFontGeneratorUserFontProgressArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionPublisherTemplateSubmissionUpdatedArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionStudioUploadsUploadUpdatedArgs = {
  input: StudioUploadsUploadUpdatedInput;
};


export type SubscriptionTransfersTransferUpdatesArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionUploadedFontsUploadUpdatedArgs = {
  input: UploadedFontsUploadUpdatedInput;
};


export type SubscriptionUpscalerImageUpdatesArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionUserTippedArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionVectorizerImageUpdatesArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionViewersArgs = {
  flowId: Scalars['String']['input'];
};

export type SubscriptionAccess = {
  __typename?: 'SubscriptionAccess';
  allAccess: SubscriptionAccessDetails;
  coins: SubscriptionAccessDetails;
  studioAi: SubscriptionAccessDetails;
  studioUnlimited: SubscriptionAccessDetails;
  team: SubscriptionAccessDetails;
};

export type SubscriptionAccessDetails = {
  __typename?: 'SubscriptionAccessDetails';
  isEligbileForExtendTrial: Scalars['Boolean']['output'];
  isEligibleForAutoStart: Scalars['Boolean']['output'];
  isEligibleForAutoStartTrial: Scalars['Boolean']['output'];
  isEligibleForFreeTrial: Scalars['Boolean']['output'];
  isEligibleForYearlyUpgrade: Scalars['Boolean']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  subscription?: Maybe<SubscriptionRecord>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionCheckoutMode {
  Payment = 'payment',
  Setup = 'setup'
}

export type SubscriptionOptimisticallySetStateInput = {
  subscription: SubscriptionType;
  userId: Scalars['String']['input'];
};

export type SubscriptionOptimisticallySetStateResponse = {
  __typename?: 'SubscriptionOptimisticallySetStateResponse';
  accepted: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
};

export type SubscriptionPayload = {
  __typename?: 'SubscriptionPayload';
  id: Scalars['ID']['output'];
  latestInvoice?: Maybe<InvoicePayload>;
  nextPaymentAt?: Maybe<Scalars['DateTime']['output']>;
  status: SubscriptionStatus;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SubscriptionPlan {
  AllAccessYearly = 'allAccessYearly',
  CoinPackMonthly1M = 'coinPackMonthly1M',
  CoinPackMonthly25k = 'coinPackMonthly25k',
  CoinPackMonthly100k = 'coinPackMonthly100k',
  CoinPackMonthly250k = 'coinPackMonthly250k',
  CoinPackMonthly400k = 'coinPackMonthly400k',
  CoinPackMonthly700k = 'coinPackMonthly700k',
  StudioAiMonthly1900 = 'studioAiMonthly1900',
  StudioAiMonthly5900 = 'studioAiMonthly5900',
  StudioAiMonthly12900 = 'studioAiMonthly12900',
  StudioAiYearly = 'studioAiYearly',
  StudioAiYearly7188 = 'studioAiYearly7188',
  StudioAiYearly8388 = 'studioAiYearly8388',
  StudioAiYearly11988 = 'studioAiYearly11988',
  StudioAiYearly14900 = 'studioAiYearly14900',
  StudioAiYearly19900 = 'studioAiYearly19900',
  StudioAiYearly22800 = 'studioAiYearly22800',
  StudioAiYearly29900 = 'studioAiYearly29900',
  StudioAiYearly56400 = 'studioAiYearly56400',
  StudioAiYearly118800 = 'studioAiYearly118800',
  StudioAiYearlyV2 = 'studioAiYearlyV2',
  StudioUnlimitedYearly = 'studioUnlimitedYearly',
  TeamMonthly = 'teamMonthly'
}

export type SubscriptionRecord = {
  __typename?: 'SubscriptionRecord';
  billingPeriod: BillingPeriod;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isTrial: Scalars['Boolean']['output'];
  nextPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  type: SubscriptionPlan;
};

export enum SubscriptionStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Incomplete = 'incomplete',
  PastDue = 'pastDue',
  Pending = 'pending',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export enum SubscriptionType {
  AllAccessMonthly = 'allAccessMonthly',
  AllAccessMonthlyFreeTrial = 'allAccessMonthlyFreeTrial',
  AllAccessYearly = 'allAccessYearly',
  AllAccessYearlyFreeTrial = 'allAccessYearlyFreeTrial',
  AllAccessYearlyPromo = 'allAccessYearlyPromo',
  CoinPackMonthly1M = 'coinPackMonthly1M',
  CoinPackMonthly25k = 'coinPackMonthly25k',
  CoinPackMonthly100k = 'coinPackMonthly100k',
  CoinPackMonthly250k = 'coinPackMonthly250k',
  CoinPackMonthly400k = 'coinPackMonthly400k',
  CoinPackMonthly700k = 'coinPackMonthly700k',
  StudioAiYearly = 'studioAiYearly',
  StudioAiYearlyFreeTrial = 'studioAiYearlyFreeTrial'
}

export enum SubscriptionTypeAutoStartTrial {
  AllAccessYearly = 'allAccessYearly',
  StudioAiYearly = 'studioAiYearly',
  StudioAiYearlyV2 = 'studioAiYearlyV2',
  TeamMonthly = 'teamMonthly'
}

export enum SubscriptionTypeUpgrade {
  AllAccessYearly = 'allAccessYearly',
  AllAccessYearlyPromo = 'allAccessYearlyPromo',
  StudioAiYearly = 'studioAiYearly'
}

export type Subscriptions = {
  __typename?: 'Subscriptions';
  allAccess?: Maybe<Scalars['Boolean']['output']>;
  classes?: Maybe<Scalars['Boolean']['output']>;
  crafts?: Maybe<Scalars['Boolean']['output']>;
  embroidery?: Maybe<Scalars['Boolean']['output']>;
  fonts?: Maybe<Scalars['Boolean']['output']>;
  graphics?: Maybe<Scalars['Boolean']['output']>;
};

export type Tag = {
  __typename?: 'Tag';
  attributes: Array<TagAttribute>;
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  slugEn: Scalars['String']['output'];
  tagKey: Scalars['String']['output'];
};

export type TagAttribute = {
  __typename?: 'TagAttribute';
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TagProduct = {
  __typename?: 'TagProduct';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  popularity: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  tagIDs: Array<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type Team = {
  __typename?: 'Team';
  avatarColour?: Maybe<Scalars['String']['output']>;
  avatarInitials?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  members: Array<TeamMember>;
  name: Scalars['String']['output'];
  owner: PublicUserProfile;
  pendingInvitations?: Maybe<Array<InvitedTeamMember>>;
  scheduledDeletionTime?: Maybe<Scalars['String']['output']>;
  status: TeamStatus;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  member: PublicUserProfile;
  role: Role;
};

export enum TeamStatus {
  Deactivated = 'Deactivated',
  Free = 'Free',
  Premium = 'Premium',
  Suspended = 'Suspended'
}

export type TeamsApproveAdminRequestInput = {
  invitationCode: Scalars['String']['input'];
  invitationId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
};

export type TeamsApproveAdminRequestResponse = {
  __typename?: 'TeamsApproveAdminRequestResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type TeamsApproveNewTeamMemberInput = {
  invitationCode: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

export type TeamsApproveNewTeamMemberResponse = {
  __typename?: 'TeamsApproveNewTeamMemberResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type TeamsApproveTeamMemberRoleChangeInput = {
  invitationCode: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

export type TeamsApproveTeamMemberRoleChangeResponse = {
  __typename?: 'TeamsApproveTeamMemberRoleChangeResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type TeamsCancelInviteInput = {
  invitationId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

export type TeamsCancelInviteResponse = {
  __typename?: 'TeamsCancelInviteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type TeamsChangeUserRoleInput = {
  role: Role;
  teamId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type TeamsChangeUserRoleResponse = {
  __typename?: 'TeamsChangeUserRoleResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  status?: Maybe<ChangeUserRoleStatus>;
};

export type TeamsConfirmInviteInput = {
  invitationCode: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

export type TeamsConfirmInviteResponse = {
  __typename?: 'TeamsConfirmInviteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamsCreateTeamInput = {
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TeamsCreateTeamResponse = {
  __typename?: 'TeamsCreateTeamResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  team?: Maybe<Team>;
};

export type TeamsDeactivateTeamInput = {
  teamId: Scalars['String']['input'];
};

export type TeamsDeactivateTeamResponse = {
  __typename?: 'TeamsDeactivateTeamResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type TeamsFetchOutstandingInvoiceUrlInput = {
  teamId: Scalars['String']['input'];
};

export type TeamsFetchOutstandingInvoiceUrlResponse = {
  __typename?: 'TeamsFetchOutstandingInvoiceUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasOutstandingInvoice?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `url` instead */
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TeamsFetchUpcomingInvoiceUrlInput = {
  teamId: Scalars['String']['input'];
};

export type TeamsFetchUpcomingInvoiceUrlResponse = {
  __typename?: 'TeamsFetchUpcomingInvoiceUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasUpcomingInvoice?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TeamsGetCheckoutUrlInput = {
  cancelRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
};

export type TeamsGetCheckoutUrlResponse = {
  __typename?: 'TeamsGetCheckoutURLResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TeamsGetTeamInput = {
  teamId: Scalars['String']['input'];
};

export type TeamsGetTeamResponse = {
  __typename?: 'TeamsGetTeamResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  team?: Maybe<Team>;
};

export type TeamsInviteUsersInput = {
  invitedUser?: InputMaybe<TeamsInvitedUser>;
  teamId: Scalars['String']['input'];
  users?: InputMaybe<Array<TeamsInvitedUser>>;
};

export type TeamsInviteUsersResponse = {
  __typename?: 'TeamsInviteUsersResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  status?: Maybe<InvitationStatus>;
};

export type TeamsInvitedUser = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  role: Role;
};

export type TeamsLeaveTeamInput = {
  teamId: Scalars['String']['input'];
};

export type TeamsLeaveTeamResponse = {
  __typename?: 'TeamsLeaveTeamResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TeamsPreviewUpcomingCharges = {
  __typename?: 'TeamsPreviewUpcomingCharges';
  hasUpcomingCharges: Scalars['Boolean']['output'];
  nextBillingTime: Scalars['String']['output'];
  seatCharges: TeamsPreviewUpcomingSeatCharges;
  storageCharges: TeamsPreviewUpcomingStorageCharges;
};

export type TeamsPreviewUpcomingChargesInput = {
  teamId: Scalars['String']['input'];
};

export type TeamsPreviewUpcomingChargesResponse = {
  __typename?: 'TeamsPreviewUpcomingChargesResponse';
  charges?: Maybe<TeamsPreviewUpcomingCharges>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type TeamsPreviewUpcomingSeatCharges = {
  __typename?: 'TeamsPreviewUpcomingSeatCharges';
  freeSeats: Scalars['Int']['output'];
  paidSeats: Scalars['Int']['output'];
  totalSeatsUsed: Scalars['Int']['output'];
  unpaidSeats: Scalars['Int']['output'];
};

export type TeamsPreviewUpcomingStorageCharges = {
  __typename?: 'TeamsPreviewUpcomingStorageCharges';
  paidStorageBlocks: Scalars['Int']['output'];
  usedStorageBlocks: Scalars['Int']['output'];
  usedStorageGbs: Scalars['Int']['output'];
};

export type TeamsRemoveUsersInput = {
  teamId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type TeamsRemoveUsersResponse = {
  __typename?: 'TeamsRemoveUsersResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  removedUserIds: Array<Scalars['String']['output']>;
  teamId: Scalars['String']['output'];
};

export type TeamsResendInviteInput = {
  invitationId: Scalars['String']['input'];
  inviteId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
};

export type TeamsResendInviteResponse = {
  __typename?: 'TeamsResendInviteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type TeamsUpdateTeamInput = {
  avatarColour?: InputMaybe<Scalars['String']['input']>;
  avatarInitials?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
};

export type TeamsUpdateTeamResponse = {
  __typename?: 'TeamsUpdateTeamResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
};

export type Template = {
  __typename?: 'Template';
  contentUrl: Scalars['String']['output'];
  createTime: Scalars['String']['output'];
  /** @deprecated Use createTime */
  createdAt: Scalars['String']['output'];
  createdBy: PublicUserProfile;
  deleteTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  team?: Maybe<Team>;
  thumbnailUrl: Scalars['String']['output'];
};

export type TemplateFormatImageOnly = {
  __typename?: 'TemplateFormatImageOnly';
  image: CampaignAsset;
};

export type TemplateFormatImagesAndLogo = {
  __typename?: 'TemplateFormatImagesAndLogo';
  image: CampaignAsset;
  logo: CampaignAsset;
  textResources: TextResources;
};

export type TemplateFormatImagesAndText = {
  __typename?: 'TemplateFormatImagesAndText';
  mainImage: CampaignAsset;
  secondaryImage: CampaignAsset;
  textResources: TextResources;
};

export type TemplateFormatVideoAndImage = {
  __typename?: 'TemplateFormatVideoAndImage';
  image: CampaignAsset;
  textResources: TextResources;
  video: CampaignAsset;
};

export type TemplateFormatVideoOnly = {
  __typename?: 'TemplateFormatVideoOnly';
  video: CampaignAsset;
};

export type TemplateSubmission = {
  __typename?: 'TemplateSubmission';
  analyseResults?: Maybe<SubmissionAnalyseResults>;
  category?: Maybe<Scalars['String']['output']>;
  createTime?: Maybe<Scalars['DateTime']['output']>;
  deleteTime?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: TemplateSubmissionStatus;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['DateTime']['output']>;
};

export enum TemplateSubmissionStatus {
  Analysing = 'analysing',
  AwaitingModeration = 'awaitingModeration',
  Draft = 'draft',
  Published = 'published',
  Rejected = 'rejected',
  Unknown = 'unknown'
}

export type TextResources = {
  __typename?: 'TextResources';
  ctaText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type TimeFrame = {
  dateField: DateField;
  dateRange: DateRange;
};

export enum TimeRange {
  Day = 'DAY',
  Unspecified = 'UNSPECIFIED',
  Week = 'WEEK'
}

export type TopCommentedThread = {
  __typename?: 'TopCommentedThread';
  commentsCount: Scalars['Int']['output'];
  externalId: Scalars['String']['output'];
};

export type Topic = {
  __typename?: 'Topic';
  clubhouseSlug: Scalars['String']['output'];
  discussions?: Maybe<Array<DiscussionListItem>>;
  id: Scalars['ID']['output'];
  topicName: Scalars['String']['output'];
  topicSlug: Scalars['String']['output'];
};

export type Totals = {
  __typename?: 'Totals';
  discount: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Transfer = {
  __typename?: 'Transfer';
  accessCode?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  files: Array<Maybe<TransferFile>>;
  filesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<PublicUserProfile>;
  recipients: Array<Maybe<TransferRecipient>>;
  status: TransferStatus;
  subject: Scalars['String']['output'];
  team?: Maybe<Team>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipFile?: Maybe<Scalars['String']['output']>;
  zipSize: Scalars['Int']['output'];
};

export type TransferFile = {
  __typename?: 'TransferFile';
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  transferId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStatus: UploadStatus;
};

export type TransferRecipient = {
  __typename?: 'TransferRecipient';
  createdAt: Scalars['DateTime']['output'];
  downloaded: Scalars['Boolean']['output'];
  downloadedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  transferAccessCode?: Maybe<Scalars['String']['output']>;
  transferId: Scalars['String']['output'];
  userInfo?: Maybe<UserInfo>;
};

export type TransferSort = {
  direction: SortDirection;
  field: TransferSortField;
};

export enum TransferSortField {
  CreatedAt = 'createdAt',
  Unknown = 'unknown'
}

export enum TransferStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Failed = 'failed',
  Initialized = 'initialized',
  Ready = 'ready',
  RequiresOtpVerification = 'requiresOTPVerification',
  Sending = 'sending',
  Unknown = 'unknown',
  Waiting = 'waiting'
}

export type TransfersAddRecipientsInput = {
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  transferId: Scalars['String']['input'];
  userInfos: Array<UserInfoInput>;
};

export type TransfersAddRecipientsResponse = {
  __typename?: 'TransfersAddRecipientsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  recipients?: Maybe<Array<TransferRecipient>>;
};

export type TransfersCancelInput = {
  id: Scalars['String']['input'];
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type TransfersCancelResponse = {
  __typename?: 'TransfersCancelResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TransfersConfirmOwnerEmailInput = {
  transferId: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type TransfersConfirmOwnerEmailResponse = {
  __typename?: 'TransfersConfirmOwnerEmailResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TransfersCreateSignedDownloadUrlInput = {
  accessCode: Scalars['String']['input'];
  transferId: Scalars['String']['input'];
};

export type TransfersCreateSignedDownloadUrlResponse = {
  __typename?: 'TransfersCreateSignedDownloadUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  signedUrl: Scalars['String']['output'];
};

export type TransfersDeleteInput = {
  id: Scalars['String']['input'];
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type TransfersDeleteResponse = {
  __typename?: 'TransfersDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum TransfersExpiryDuration {
  OneDay = 'ONE_DAY',
  OneMonth = 'ONE_MONTH',
  OneWeek = 'ONE_WEEK',
  OneYear = 'ONE_YEAR',
  TenMinutes = 'TEN_MINUTES',
  ThreeDays = 'THREE_DAYS'
}

export type TransfersGetTransferInput = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type TransfersGetTransferResponse = {
  __typename?: 'TransfersGetTransferResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  transfer?: Maybe<Transfer>;
};

export type TransfersInitiateTransferInput = {
  expiresAt?: InputMaybe<TransfersExpiryDuration>;
  filesCount: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type TransfersInitiateTransferResponse = {
  __typename?: 'TransfersInitiateTransferResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id?: Maybe<Scalars['String']['output']>;
};

export type TransfersInitiateTransferV2Input = {
  expiresAt?: InputMaybe<TransfersExpiryDuration>;
  filesCount: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type TransfersInitiateTransferV2Response = {
  __typename?: 'TransfersInitiateTransferV2Response';
  errors?: Maybe<Array<ErrorMessage>>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TransferStatus>;
};

export type TransfersVerifyOwnerEmailInput = {
  ownerEmail: Scalars['String']['input'];
  transferId: Scalars['String']['input'];
};

export type TransfersVerifyOwnerEmailResponse = {
  __typename?: 'TransfersVerifyOwnerEmailResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TransformedPricesResponse = {
  __typename?: 'TransformedPricesResponse';
  basePrice: Scalars['Int']['output'];
  currencyPrice: Scalars['Int']['output'];
};

export enum TrialActivationReason {
  LimitReachedCoins = 'limitReachedCoins',
  LimitReachedDownloads = 'limitReachedDownloads',
  Scheduled = 'scheduled',
  UserRequest = 'userRequest'
}

export type UndoCancelSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export type UndoCancelSubscriptionResponse = {
  __typename?: 'UndoCancelSubscriptionResponse';
  error?: Maybe<ErrorGrowth>;
};

export type UndoCancelationBanner = {
  __typename?: 'UndoCancelationBanner';
  backgroundColor: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  button: UndoCancelationBannerButton;
  countdown: SiteBannerCountdown;
  subscriptionId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: SiteBannerType;
};

export type UndoCancelationBannerButton = {
  __typename?: 'UndoCancelationBannerButton';
  backgroundColor: Scalars['String']['output'];
  hoverTextColor: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  onClick: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
};

export type UnsubscribeToClubhouseDigestInput = {
  clubhouseSlug: Scalars['String']['input'];
};

export type UnsubscribeToClubhouseDigestResponse = {
  __typename?: 'UnsubscribeToClubhouseDigestResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

/** Input for updating product tags. */
export type UpdateAdminProductTagsInput = {
  /** Product ID */
  productId: Scalars['Int']['input'];
  /** Tag names to add (will be created if they don't exist) */
  tagsToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tag IDs to remove */
  tagsToRemove?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Response for updating product tags. */
export type UpdateAdminProductTagsResponse = {
  __typename?: 'UpdateAdminProductTagsResponse';
  /** Error details if the request fails */
  error?: Maybe<ErrorGrowth>;
};

export type UpdateCoinTransactionStatusResponse = {
  __typename?: 'UpdateCoinTransactionStatusResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  transaction?: Maybe<CoinTransaction>;
};

export type UpdateCustomerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerResponse = {
  __typename?: 'UpdateCustomerResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpgradeSubscriptionResult = {
  __typename?: 'UpgradeSubscriptionResult';
  payInvoiceUrl?: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus;
  userBanned?: Maybe<Scalars['Boolean']['output']>;
};

export enum UploadStatus {
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Started = 'started',
  Unknown = 'unknown'
}

export type UploadUserAvatarInput = {
  file: Scalars['Upload']['input'];
};

export type UploadUserAvatarResponse = {
  __typename?: 'UploadUserAvatarResponse';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<ErrorGrowth>;
};

export type UploadedFont = {
  __typename?: 'UploadedFont';
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: FontType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type UploadedFontsCreateSignedUrlInput = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadedFontsCreateSignedUrlResponse = {
  __typename?: 'UploadedFontsCreateSignedUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['ID']['output'];
  signedUrl: Scalars['String']['output'];
};

export type UploadedFontsCreateSignedUrlV2Input = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadedFontsCreateSignedUrlV2Response = {
  __typename?: 'UploadedFontsCreateSignedUrlV2Response';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['ID']['output'];
  inputFormFields?: Maybe<Array<KeyValuePairs>>;
  signedUrl: Scalars['String']['output'];
};

export type UploadedFontsDeleteInput = {
  fontIds: Array<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadedFontsDeleteResponse = {
  __typename?: 'UploadedFontsDeleteResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type UploadedFontsSearchInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<FontType>;
};

export type UploadedFontsSearchResponse = {
  __typename?: 'UploadedFontsSearchResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  fonts?: Maybe<Array<UploadedFont>>;
};

export type UploadedFontsUploadUpdatedInput = {
  id: Scalars['ID']['input'];
};

export type UploadedFontsUploadUpdatedResponse = {
  __typename?: 'UploadedFontsUploadUpdatedResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  font?: Maybe<UploadedFont>;
};

export enum UploadsApp {
  Spark = 'spark',
  Studio = 'studio',
  Teams = 'teams',
  Upscaler = 'upscaler',
  Vectorizer = 'vectorizer'
}

export type UploadsCreateSignedUrlInputV2 = {
  app: UploadsApp;
  fileName: Scalars['String']['input'];
};

export type UploadsCreateSignedUrlResponseV2 = {
  __typename?: 'UploadsCreateSignedUrlResponseV2';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type UploadsCreateSignedUrlV3Input = {
  app: UploadsApp;
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadsCreateSignedUrlV3Response = {
  __typename?: 'UploadsCreateSignedUrlV3Response';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['String']['output'];
  inputFormFields?: Maybe<Array<KeyValuePairs>>;
  signedUrl: Scalars['String']['output'];
};

export enum UpscaleImageSource {
  Flows = 'flows'
}

export type UpscalerCancelImageInput = {
  id: Scalars['ID']['input'];
};

export type UpscalerCancelImageResponse = {
  __typename?: 'UpscalerCancelImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpscalerCreateSignedUploadUrl = {
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type UpscalerCreateSignedUploadUrlResponse = {
  __typename?: 'UpscalerCreateSignedUploadUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id?: Maybe<Scalars['ID']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type UpscalerDeleteAllImagesResponse = {
  __typename?: 'UpscalerDeleteAllImagesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type UpscalerDeleteImageInput = {
  id: Scalars['ID']['input'];
};

export type UpscalerDeleteImageResponse = {
  __typename?: 'UpscalerDeleteImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type UpscalerDownloadImageInput = {
  id: Scalars['ID']['input'];
};

export type UpscalerDownloadImageResponse = {
  __typename?: 'UpscalerDownloadImageResponse';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ErrorMessage>>;
};

export type UpscalerGetImageInput = {
  id: Scalars['ID']['input'];
};

export type UpscalerGetImageResponse = {
  __typename?: 'UpscalerGetImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  image?: Maybe<UpscalerImage>;
};

export type UpscalerImage = {
  __typename?: 'UpscalerImage';
  createTime?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  originalUrl?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  status: UpscalerImageStatus;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['DateTime']['output']>;
};

export enum UpscalerImageStatus {
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Unknown = 'unknown'
}

export type UpscalerImagesInput = {
  afterId?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};

export type UpscalerImagesResponse = {
  __typename?: 'UpscalerImagesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<UpscalerImage>>;
};

export type UpscalerPublishImageInput = {
  id: Scalars['ID']['input'];
};

export type UpscalerPublishImageResponse = {
  __typename?: 'UpscalerPublishImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type UpscalerUpscaleImageInput = {
  id: Scalars['ID']['input'];
  source: UpscaleImageSource;
};

export type UpscalerUpscaleImageResponse = {
  __typename?: 'UpscalerUpscaleImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  /** @deprecated Use image.id instead */
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<UpscalerImage>;
};

export type UpsellBanner = {
  __typename?: 'UpsellBanner';
  backgroundColor: Scalars['String']['output'];
  button: UpsellBannerButton;
  countdown: SiteBannerCountdown;
  text: Scalars['String']['output'];
  type: SiteBannerType;
};

export type UpsellBannerButton = {
  __typename?: 'UpsellBannerButton';
  backgroundColor: Scalars['String']['output'];
  hoverTextColor: Scalars['String']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  affiliateInfo?: Maybe<AffiliateInfo>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billingDetails: BillingDetails;
  bio: Scalars['String']['output'];
  canSwitchVisibility: Scalars['Boolean']['output'];
  capabilities: Array<Scalars['String']['output']>;
  contentInterests: Array<Scalars['String']['output']>;
  craftMachines?: Maybe<CraftMachineListResponse>;
  craftingTypes: Array<Scalars['String']['output']>;
  currency: Currency;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<UserFlags>;
  following: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isBanned: Scalars['Boolean']['output'];
  isEligibleForFreeTrial: Scalars['Boolean']['output'];
  isEligibleForYearlyUpgrade: Scalars['Boolean']['output'];
  isSubscribedToFlowDailyDigest: Scalars['Boolean']['output'];
  isTemporary: Scalars['Boolean']['output'];
  isUserBlocklisted: IsUserBlocklisted;
  language: Language;
  lastName?: Maybe<Scalars['String']['output']>;
  location: UserLocation;
  login?: Maybe<Scalars['String']['output']>;
  machineTypes: Array<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  stripeCustomer?: Maybe<StripeCustomer>;
  stripeCustomerId: Scalars['String']['output'];
  subscriptionAccess: SubscriptionAccess;
  subscriptions?: Maybe<Subscriptions>;
  superSkill?: Maybe<Scalars['String']['output']>;
  teams: Array<Team>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UserBalance = {
  __typename?: 'UserBalance';
  balance: Scalars['Int']['output'];
};

export type UserBalanceChange = {
  __typename?: 'UserBalanceChange';
  balance: Scalars['Int']['output'];
};

export type UserBlock = {
  __typename?: 'UserBlock';
  BlockedBy: Scalars['String']['output'];
  EndDate?: Maybe<Scalars['DateTime']['output']>;
  Reason: Scalars['String']['output'];
  StartDate: Scalars['DateTime']['output'];
  Status: Scalars['String']['output'];
  blockedByUserID: Scalars['Int']['output'];
};

export type UserCheckEarlyTrialCancelInput = {
  stripeCustomerId: Scalars['String']['input'];
};

export type UserCheckEarlyTrialCancelResponse = {
  __typename?: 'UserCheckEarlyTrialCancelResponse';
  earlyTrialCancel: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
};

export type UserCheckFollowingInput = {
  targetUserId?: InputMaybe<Scalars['ID']['input']>;
  targetUserSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UserEligibleForDeletionReason = {
  __typename?: 'UserEligibleForDeletionReason';
  desc: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type UserEligibleForDeletionResponse = {
  __typename?: 'UserEligibleForDeletionResponse';
  canBeDeleted: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  reasons?: Maybe<Array<UserEligibleForDeletionReason>>;
};

export type UserFlags = {
  __typename?: 'UserFlags';
  hasNewUserNewsletter?: Maybe<Scalars['Boolean']['output']>;
  identifyUser?: Maybe<Scalars['Boolean']['output']>;
  isCreativeFabrica?: Maybe<Scalars['Boolean']['output']>;
  isGAdsSignup?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isOnHoldSubscriber?: Maybe<Scalars['Boolean']['output']>;
  isUserVerificationRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type UserFollowersCountInput = {
  userId: Scalars['String']['input'];
};

export type UserFollowersCountResponse = {
  __typename?: 'UserFollowersCountResponse';
  FollowersCount: Scalars['Int']['output'];
  FollowingCount: Scalars['Int']['output'];
  errors?: Maybe<Array<ErrorMessage>>;
};

export type UserFollowersInput = {
  itemsPerPage: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type UserFollowersPagination = {
  __typename?: 'UserFollowersPagination';
  currentPage: Scalars['Int']['output'];
  itemsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type UserFollowersResponse = {
  __typename?: 'UserFollowersResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  followers?: Maybe<Array<PublicUserProfile>>;
  pagination: UserFollowersPagination;
};

export type UserFollowingResponse = {
  __typename?: 'UserFollowingResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  following?: Maybe<Array<PublicUserProfile>>;
  pagination: UserFollowersPagination;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  address?: Maybe<EmailAddress>;
  user?: Maybe<UserProfile>;
};

export type UserInfoInput = {
  address?: InputMaybe<EmailAddressInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserListFavoriteProduct = {
  __typename?: 'UserListFavoriteProduct';
  favoriteCount: Scalars['Int']['output'];
  hasBeenDownloaded: Scalars['Boolean']['output'];
  mainCategoryName: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  productImage: Scalars['String']['output'];
  productTitle: Scalars['String']['output'];
};

export type UserLocation = {
  __typename?: 'UserLocation';
  country: CountryCode;
};

export type UserLocationResponse = {
  __typename?: 'UserLocationResponse';
  location: UserLocation;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type UserProjectPermission = {
  __typename?: 'UserProjectPermission';
  projectRole: Role;
  teamRole: Role;
  user: PublicUserProfile;
};

export type UserSearch = {
  __typename?: 'UserSearch';
  createdAt: Scalars['Time']['output'];
  id: Scalars['String']['output'];
  searchTerm: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserShippingAddressResponse = {
  __typename?: 'UserShippingAddressResponse';
  address?: Maybe<UsersShippingAddress>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  isTrial: Scalars['Boolean']['output'];
};

export type UserUpdateFlagsInput = {
  identifyUser?: InputMaybe<Scalars['Boolean']['input']>;
  isGAdsSignup?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UserUpdateGdprConsent {
  News = 'news',
  None = 'none'
}

export type UserUpdateGdprInput = {
  consent: UserUpdateGdprConsent;
  page: Scalars['String']['input'];
  userID: Scalars['ID']['input'];
};

export type UsersBanResponse = {
  __typename?: 'UsersBanResponse';
  banStatus: BanStatus;
};

export type UsersEditBanInput = {
  banStatus: BanStatus;
  userId: Scalars['String']['input'];
};

export type UsersEditBanResponse = {
  __typename?: 'UsersEditBanResponse';
  success: Scalars['Boolean']['output'];
};

export type UsersFavoriteProductResponse = {
  __typename?: 'UsersFavoriteProductResponse';
  favoriteCount: Scalars['Int']['output'];
  productID: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type UsersGetInput = {
  id: Scalars['ID']['input'];
};

export type UsersGetResponse = {
  __typename?: 'UsersGetResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  user?: Maybe<User>;
};

export type UsersListFavoriteProductsInput = {
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeSkipTrial?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<ContentLanguage>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersManageSubscriptionInvoiceResponse = {
  __typename?: 'UsersManageSubscriptionInvoiceResponse';
  currency: Currency;
  id: Scalars['ID']['output'];
  paidAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type UsersManageSubscriptionResponse = {
  __typename?: 'UsersManageSubscriptionResponse';
  compensationOptions?: Maybe<Array<InvoiceCompensationType>>;
  errors?: Maybe<Array<ErrorMessage>>;
  invoice?: Maybe<UsersManageSubscriptionInvoiceResponse>;
};

export type UsersSaveShippingAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  addressConfirmation: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UsersSaveShippingAddressResponse = {
  __typename?: 'UsersSaveShippingAddressResponse';
  error?: Maybe<ErrorGrowth>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UsersShippingAddress = {
  __typename?: 'UsersShippingAddress';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type ValidateTokenResponse = {
  __typename?: 'ValidateTokenResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type VectorizerCancelImageVectorizationInput = {
  id: Scalars['ID']['input'];
};

export type VectorizerCancelImageVectorizationResponse = {
  __typename?: 'VectorizerCancelImageVectorizationResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VectorizerCreateImageResponse = {
  __typename?: 'VectorizerCreateImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type VectorizerCreateInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type VectorizerCreateSignedUploadUrl = {
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['Int']['input']>;
};

export type VectorizerCreateSignedUploadUrlResponse = {
  __typename?: 'VectorizerCreateSignedUploadUrlResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  id: Scalars['ID']['output'];
  signedUrl: Scalars['String']['output'];
};

export type VectorizerDeleteAllImagesResponse = {
  __typename?: 'VectorizerDeleteAllImagesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  ids?: Maybe<Array<Scalars['ID']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type VectorizerDeleteImageInput = {
  id: Scalars['ID']['input'];
};

export type VectorizerDeleteImageResponse = {
  __typename?: 'VectorizerDeleteImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  success: Scalars['Boolean']['output'];
};

export type VectorizerGetImageInput = {
  id: Scalars['ID']['input'];
};

export type VectorizerGetImageResponse = {
  __typename?: 'VectorizerGetImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  image?: Maybe<VectorizerImage>;
};

export type VectorizerImage = {
  __typename?: 'VectorizerImage';
  createTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  status: StatusType;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  vectorizedUrl?: Maybe<Scalars['String']['output']>;
};

export type VectorizerImagesRegisterToUserInput = {
  ids: Array<Scalars['String']['input']>;
};

export type VectorizerImagesRegisterToUserResponse = {
  __typename?: 'VectorizerImagesRegisterToUserResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  images: Array<VectorizerImage>;
};

export type VectorizerListImagesInput = {
  afterId?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};

export type VectorizerListImagesResponse = {
  __typename?: 'VectorizerListImagesResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  images: Array<VectorizerImage>;
};

export type VectorizerListImagesV2Response = {
  __typename?: 'VectorizerListImagesV2Response';
  errors?: Maybe<Array<ErrorMessage>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<VectorizerImage>>;
};

export type VectorizerPublishImageInput = {
  id: Scalars['ID']['input'];
};

export type VectorizerPublishImageResponse = {
  __typename?: 'VectorizerPublishImageResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  upload?: Maybe<StudioUploadsFile>;
};

export type VerificationBanner = {
  __typename?: 'VerificationBanner';
  backgroundColor: Scalars['String']['output'];
  bannerAboveNav: Scalars['String']['output'];
  bannerAboveNavState: Scalars['String']['output'];
  button: VerificationBannerButton;
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
  type: SiteBannerType;
};

export type VerificationBannerButton = {
  __typename?: 'VerificationBannerButton';
  backgroundColor: Scalars['String']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
};

export enum VideoState {
  Failed = 'failed',
  Processing = 'processing',
  Ready = 'ready'
}

export type AskGetGivenTopicsResponse = {
  __typename?: 'askGetGivenTopicsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  topics?: Maybe<Array<Maybe<AskCfTopic>>>;
};

export type AskGetTopicResponse = {
  __typename?: 'askGetTopicResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  topic?: Maybe<AskCfTopic>;
};

export type AskGetTopicsResponse = {
  __typename?: 'askGetTopicsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  topics?: Maybe<Array<AskCfTopic>>;
};

export type AskGetUserDigestStatusResponse = {
  __typename?: 'askGetUserDigestStatusResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  subscribed: Scalars['Boolean']['output'];
};

export type AskGetUserStatsResponse = {
  __typename?: 'askGetUserStatsResponse';
  errors?: Maybe<Array<ErrorMessage>>;
  stats?: Maybe<AskCfUserStats>;
};

export enum CoinPack {
  CoinPack1M = 'coinPack1M',
  CoinPack25k = 'coinPack25k',
  CoinPack100k = 'coinPack100k',
  CoinPack250k = 'coinPack250k',
  CoinPack1000k = 'coinPack1000k',
  CoinPackTeam1M = 'coinPackTeam1M',
  CoinPackTeam5M = 'coinPackTeam5M',
  CoinPackTeam10M = 'coinPackTeam10M',
  CoinPackTeam30M = 'coinPackTeam30M',
  CoinPackUndefined = 'coinPackUndefined'
}

export type FlowInteractionImageReactionTotal = {
  __typename?: 'flowInteractionImageReactionTotal';
  imageId: Scalars['ID']['output'];
  reaction: ImageReaction;
  reactionsTotal: Scalars['Int']['output'];
};

export type PaymentsAutoStartTrialResult = {
  __typename?: 'paymentsAutoStartTrialResult';
  errors?: Maybe<Array<ErrorMessage>>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PaymentsBuyCoinsResult = {
  __typename?: 'paymentsBuyCoinsResult';
  errors?: Maybe<Array<ErrorMessage>>;
  payInvoiceUrl?: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus;
};
